import * as i0 from '@angular/core';
import { ViewContainerRef, Component, ViewChild, Directive, ChangeDetectionStrategy, ViewEncapsulation, Input, ContentChild, EventEmitter, Output, NgModule, Injectable, Inject, Optional, forwardRef, ContentChildren, HostListener } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i2$2 from '@angular/forms';
import { ReactiveFormsModule, FormsModule, Validators, UntypedFormGroup, FormGroup } from '@angular/forms';
import * as i3 from '@ngx-formly/core';
import { FieldWrapper, FieldType, FormlyModule } from '@ngx-formly/core';
import * as i4 from '@ngx-formly/core/select';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { MAT_NATIVE_DATE_FORMATS, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import * as i2$4 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i2$6 from '@gsa-sam/sam-material-extensions';
import { SdsTableModule } from '@gsa-sam/sam-material-extensions';
import * as i2$3 from '@gsa-sam/components';
import { SDSAutocompleteComponent, SdsTextComponent, SdsSearchComponent, SdsEditorComponent, SdsRichTextComponent, SdsStepArrowComponent, SdsAutocompleteModule, SdsDialogModule, SdsSearchModule, SdsTextModule, SdsEditorModule, SdsCollapseModule, SdsTooltipModule, SdsTabsModule, SdsPopoverModule, SdsRichTextModule, SdsStepArrowModule, SDS_DIALOG_DATA } from '@gsa-sam/components';
import * as qs from 'qs';
import * as i2 from '@gsa-sam/ngx-uswds';
import { UsaAccordionItem, UsaFileInputComponent, UsaAccordionModule, UsaFileInputModule } from '@gsa-sam/ngx-uswds';
import * as i2$1 from '@gsa-sam/ngx-uswds-icons';
import { IconModule } from '@gsa-sam/ngx-uswds-icons';
import * as i2$5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3$1 from '@angular/material/form-field';
import { Subscription, Subject, BehaviorSubject } from 'rxjs';
import { trigger, state, style, transition, group, animate } from '@angular/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i1$1 from 'ngx-bootstrap-icons';
import { NgxBootstrapIconsModule, caretDownFill, caretUpFill, filter, arrowClockwise, chevronDown, infoCircleFill, calendar, x, chevronLeft, chevronRight, check, question, save } from 'ngx-bootstrap-icons';
import { startWith, tap, takeUntil } from 'rxjs/operators';
import * as _ from 'lodash-es';
import { cloneDeep } from 'lodash-es';
import * as i3$2 from '@angular/router';
import { RouterModule } from '@angular/router';

const _c0$s = ["fieldComponent"];
function FormlyWrapperFormFieldComponent_label_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.props.tagClass ? ctx_r0.props.tagClass : "sds-tag--info-white");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.props.tagText);
} }
function FormlyWrapperFormFieldComponent_label_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " (Optional)");
    i0.ɵɵelementEnd();
} }
function FormlyWrapperFormFieldComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtemplate(1, FormlyWrapperFormFieldComponent_label_1_span_1_Template, 2, 2, "span", 6);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FormlyWrapperFormFieldComponent_label_1_span_4_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.props.labelClass);
    i0.ɵɵattribute("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.props.tagText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.props.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.props.required && !ctx_r0.props.hideOptional);
} }
function FormlyWrapperFormFieldComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.props.description, " ");
} }
function FormlyWrapperFormFieldComponent_ng_template_3_Template(rf, ctx) { }
function FormlyWrapperFormFieldComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "formly-validation-message", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("display", "block");
    i0.ɵɵadvance();
    i0.ɵɵproperty("field", ctx_r0.field);
} }
/**
 * @param string [props.tagClass] Class to be added to the tag (default: sds-tag--info-white)
 * @param string [props.tagText] Text to be shown inside the tag
 * @param string [props.labelClass] Class to be applied to the label
 * @param string [props.label] Text to be shown for the label
 * @param string [props.required] Makes the field required
 * @param string [props.description] Add a description below the label
 * @param string [props.hideOptional] Remove the optional text
 * @param string [props.hideLabel] Hide the label
 *
 */
class FormlyWrapperFormFieldComponent extends FieldWrapper {
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyWrapperFormFieldComponent_BaseFactory; return function FormlyWrapperFormFieldComponent_Factory(t) { return (ɵFormlyWrapperFormFieldComponent_BaseFactory || (ɵFormlyWrapperFormFieldComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyWrapperFormFieldComponent)))(t || FormlyWrapperFormFieldComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyWrapperFormFieldComponent, selectors: [["sds-formly-wrapper-form-field"]], viewQuery: function FormlyWrapperFormFieldComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$s, 5, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 5, consts: [["fieldComponent", ""], [1, "usa-form-group"], ["class", "usa-label", 3, "ngClass", 4, "ngIf"], ["class", "usa-label--description", 4, "ngIf"], ["class", "usa-error-message", 3, "display", 4, "ngIf"], [1, "usa-label", 3, "ngClass"], ["class", "usa-tag", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "usa-tag", 3, "ngClass"], [1, "usa-label--description"], [1, "usa-error-message"], [3, "field"]], template: function FormlyWrapperFormFieldComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, FormlyWrapperFormFieldComponent_label_1_Template, 5, 5, "label", 2)(2, FormlyWrapperFormFieldComponent_div_2_Template, 2, 1, "div", 3)(3, FormlyWrapperFormFieldComponent_ng_template_3_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, FormlyWrapperFormFieldComponent_div_5_Template, 2, 3, "div", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("usa-form-group--error", ctx.showError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.label && ctx.props.hideLabel !== true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.description);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showError);
        } }, dependencies: [i1.NgClass, i1.NgIf, i3.ɵFormlyValidationMessage], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyWrapperFormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-wrapper-form-field',
                template: `
    <div class="usa-form-group" [class.usa-form-group--error]="showError">
      <label
        class="usa-label"
        *ngIf="props.label && props.hideLabel !== true"
        [attr.for]="id"
        [ngClass]="props.labelClass"
      >
        <span
          *ngIf="props.tagText"
          class="usa-tag"
          [ngClass]="props.tagClass ? props.tagClass : 'sds-tag--info-white'"
          >{{ props.tagText }}</span
        >
        <span>{{ props.label }}</span>
        <span *ngIf="!props.required && !props.hideOptional"> (Optional)</span>
      </label>
      <div *ngIf="props.description" class="usa-label--description">
        {{ props.description }}
      </div>
      <ng-template #fieldComponent></ng-template>
      <div *ngIf="showError" class="usa-error-message" [style.display]="'block'">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </div>
  `,
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyWrapperFormFieldComponent, { className: "FormlyWrapperFormFieldComponent" }); })();

const _c0$r = ["fieldComponent"];
const _c1$9 = ["groupAccordion"];
function FormlyAccordianFormFieldComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("class", ctx_r0.props.labelClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.props.label);
} }
function FormlyAccordianFormFieldComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 1);
} }
/**
 * @param string [props.expand] to expand the accordion
 *
 */
class FormlyAccordianFormFieldComponent extends FieldWrapper {
    constructor() {
        super();
        this.multi = true;
    }
    ngAfterViewInit() {
        if (this.props.group != 'accordion' || !this.accordion) {
            return;
        }
        // this.resetAllSubscription = this.field.options.fieldChanges
        //   .pipe(filter(({ type }) => type === 'resetAll' && this.accordionItem.expanded))
        //   .subscribe(() => {
        //     if (!this.modelHasValue()) {
        //       this.accordion.collapse(this.accordionItem.id);
        //     }
        //   });
        this.resetAllSubscription = this.field.options.fieldChanges.subscribe(({ type }) => {
            if (type === 'resetAll' && this.accordionItem.expanded) {
                if (!this.modelHasValue()) {
                    this.accordion.collapse(this.accordionItem.id);
                }
            }
        });
    }
    ngOnDestroy() {
        if (this.resetAllSubscription) {
            this.resetAllSubscription.unsubscribe();
        }
    }
    modelHasValue() {
        if (this.props.hasOwnProperty('expand')) {
            return this.props.expand;
        }
        else {
            const hasValue = this.formControl.value instanceof Object
                ? qs.stringify(this.formControl.value, { skipNulls: true })
                : this.formControl.value;
            return hasValue || this.formControl.dirty ? true : false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyAccordianFormFieldComponent_Factory(t) { return new (t || FormlyAccordianFormFieldComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyAccordianFormFieldComponent, selectors: [["sam-formly-accordian-form-field"]], viewQuery: function FormlyAccordianFormFieldComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$r, 5, ViewContainerRef);
            i0.ɵɵviewQuery(_c1$9, 5);
            i0.ɵɵviewQuery(UsaAccordionItem, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionItem = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [["groupAccordion", ""], ["fieldComponent", ""], [1, "sds-accordion--filters", 3, "singleSelect"], ["]", "", 3, "expanded"], ["UsaAccordionHeader", ""], ["UsaAccordionContent", ""]], template: function FormlyAccordianFormFieldComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "usa-accordion", 2, 0)(2, "usa-accordion-item", 3);
            i0.ɵɵtemplate(3, FormlyAccordianFormFieldComponent_ng_template_3_Template, 2, 2, "ng-template", 4)(4, FormlyAccordianFormFieldComponent_ng_template_4_Template, 2, 0, "ng-template", 5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("singleSelect", !ctx.multi);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("expanded", ctx.modelHasValue());
        } }, dependencies: [i2.UsaAccordionComponent, i2.UsaAccordionHeader, i2.UsaAccordionContent, i2.UsaAccordionItem], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyAccordianFormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'sam-formly-accordian-form-field',
                template: `
    <usa-accordion #groupAccordion [singleSelect]="!multi" class="sds-accordion--filters">
      <usa-accordion-item [expanded]="modelHasValue()" ]>
        <ng-template UsaAccordionHeader>
          <span [attr.class]="props.labelClass">{{ props.label }}</span>
        </ng-template>
        <ng-template UsaAccordionContent>
          <ng-container #fieldComponent></ng-container>
        </ng-template>
      </usa-accordion-item>
    </usa-accordion>
  `,
            }]
    }], () => [], { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }], accordion: [{
            type: ViewChild,
            args: ['groupAccordion']
        }], accordionItem: [{
            type: ViewChild,
            args: [UsaAccordionItem]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyAccordianFormFieldComponent, { className: "FormlyAccordianFormFieldComponent" }); })();

const _c0$q = ["fieldComponent"];
/**
 * @param string [props.ariaHidden] Hide the label
 * @param string [props.label] Text to be shown for the label
 */
class FormlyFormFieldFilterWrapperComponent extends FieldWrapper {
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFormFieldFilterWrapperComponent_BaseFactory; return function FormlyFormFieldFilterWrapperComponent_Factory(t) { return (ɵFormlyFormFieldFilterWrapperComponent_BaseFactory || (ɵFormlyFormFieldFilterWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFormFieldFilterWrapperComponent)))(t || FormlyFormFieldFilterWrapperComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFormFieldFilterWrapperComponent, selectors: [["sam-formly-filter-wrapper-form-field"]], viewQuery: function FormlyFormFieldFilterWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$q, 5, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [["fieldComponent", ""], [1, "wrapper-body"], [1, "sds-accordion__trigger", "header-label"]], template: function FormlyFormFieldFilterWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainer(3, null, 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-hidden", ctx.props.ariaHidden ? "false" : "true");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.props.label, " ");
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFormFieldFilterWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'sam-formly-filter-wrapper-form-field',
                template: `
    <div class="wrapper-body">
      <div class="sds-accordion__trigger header-label" [attr.aria-hidden]="props.ariaHidden ? 'false' : 'true'">
        {{ props.label }}
      </div>
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFormFieldFilterWrapperComponent, { className: "FormlyFormFieldFilterWrapperComponent" }); })();

const _c0$p = (a0, a1) => ({ "usa-input--disabled": a0, "usa-input--error": a1 });
function FormlyFieldInputComponent_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵlistener("click", function FormlyFieldInputComponent_div_1_span_1_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onPrefixClick($event)); });
    i0.ɵɵelement(1, "usa-icon", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.props.prefixIcon);
} }
function FormlyFieldInputComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, FormlyFieldInputComponent_div_1_span_1_Template, 2, 1, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.props.prefixIcon && !ctx_r1.props.prefix);
} }
function FormlyFieldInputComponent_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵlistener("click", function FormlyFieldInputComponent_div_3_span_1_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onSuffixClick($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.props.suffix);
} }
function FormlyFieldInputComponent_div_3_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵlistener("click", function FormlyFieldInputComponent_div_3_span_2_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onSuffixClick($event)); });
    i0.ɵɵelement(1, "usa-icon", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.props.suffixIcon);
} }
function FormlyFieldInputComponent_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵlistener("click", function FormlyFieldInputComponent_div_3_span_3_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onClear()); })("keyup.enter", function FormlyFieldInputComponent_div_3_span_3_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onClear()); });
    i0.ɵɵelement(1, "usa-icon", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "x");
} }
function FormlyFieldInputComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, FormlyFieldInputComponent_div_3_span_1_Template, 2, 1, "span", 5)(2, FormlyFieldInputComponent_div_3_span_2_Template, 2, 1, "span", 5)(3, FormlyFieldInputComponent_div_3_span_3_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.props.suffix && !ctx_r1.props.suffixIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.props.suffixIcon && !ctx_r1.props.suffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.field.formControl.value && !ctx_r1.props.disabled);
} }
class FormlyFieldInputComponent extends FieldType {
    onClear() {
        this.field.formControl.setValue('');
        this.field.focus = true;
        this.field.formControl.markAsDirty();
    }
    onSuffixClick(ev) {
        if (this.props.onSuffixClick) {
            this.props.onSuffixClick(ev);
        }
    }
    onPrefixClick(ev) {
        if (this.props.onPrefixClick) {
            this.props.onPrefixClick(ev);
        }
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldInputComponent_BaseFactory; return function FormlyFieldInputComponent_Factory(t) { return (ɵFormlyFieldInputComponent_BaseFactory || (ɵFormlyFieldInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldInputComponent)))(t || FormlyFieldInputComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldInputComponent, selectors: [["sds-formly-field-input"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 11, consts: [[1, "usa-input-group", "maxw-mobile-lg"], ["class", "usa-input-prefix", "aria-hidden", "true", 4, "ngIf"], [1, "usa-input", 3, "id", "ngClass", "formlyAttributes", "type", "formControl"], ["class", "usa-input-suffix", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "usa-input-prefix"], [3, "click", 4, "ngIf"], [3, "click"], ["size", "lg", 1, "font-sans-xs", 3, "icon"], ["aria-hidden", "true", 1, "usa-input-suffix"], ["role", "button", "aria-label", "Clear input", "tabindex", "0", "class", "icon-container", 3, "click", "keyup.enter", 4, "ngIf"], ["role", "button", "aria-label", "Clear input", "tabindex", "0", 1, "icon-container", 3, "click", "keyup.enter"]], template: function FormlyFieldInputComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FormlyFieldInputComponent_div_1_Template, 2, 1, "div", 1);
            i0.ɵɵelement(2, "input", 2);
            i0.ɵɵtemplate(3, FormlyFieldInputComponent_div_3_Template, 4, 3, "div", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.prefix || ctx.props.prefixIcon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.id)("ngClass", i0.ɵɵpureFunction2(8, _c0$p, ctx.props.disabled, ctx.showError))("formlyAttributes", ctx.field)("type", ctx.props.inputType ? ctx.props.inputType : "text")("formControl", ctx.formControl);
            i0.ɵɵattribute("aria-describedby", ctx.props.description ? ctx.id + "-description" : undefined);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.suffix || ctx.props.suffixIcon || ctx.field.formControl.value);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.IconComponent, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.FormControlDirective, i3.ɵFormlyAttributes], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldInputComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-input',
                template: `
    <div class="usa-input-group maxw-mobile-lg">
      <div *ngIf="props.prefix || props.prefixIcon" class="usa-input-prefix" aria-hidden="true">
        <span *ngIf="props.prefixIcon && !props.prefix" (click)="onPrefixClick($event)">
          <usa-icon [icon]="props.prefixIcon" size="lg" class="font-sans-xs"></usa-icon>
        </span>
      </div>
      <input
        [id]="id"
        class="usa-input"
        [ngClass]="{
          'usa-input--disabled': props.disabled,
          'usa-input--error': showError
        }"
        [formlyAttributes]="field"
        [type]="props.inputType ? props.inputType : 'text'"
        [formControl]="formControl"
        [attr.aria-describedby]="props.description ? id + '-description' : undefined"
      />
      <div
        *ngIf="props.suffix || props.suffixIcon || field.formControl.value"
        class="usa-input-suffix"
        aria-hidden="true"
      >
        <span *ngIf="props.suffix && !props.suffixIcon" (click)="onSuffixClick($event)">{{ props.suffix }}</span>
        <span *ngIf="props.suffixIcon && !props.suffix" (click)="onSuffixClick($event)">
          <usa-icon [icon]="props.suffixIcon" size="lg" class="font-sans-xs"></usa-icon>
        </span>
        <span
          *ngIf="field.formControl.value && !props.disabled"
          role="button"
          aria-label="Clear input"
          (click)="onClear()"
          (keyup.enter)="onClear()"
          tabindex="0"
          class="icon-container"
        >
          <usa-icon [icon]="'x'" size="lg" class="font-sans-xs"></usa-icon>
        </span>
      </div>
    </div>
  `,
            }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldInputComponent, { className: "FormlyFieldInputComponent" }); })();

function FormlyFieldSelectComponent_select_0_ng_container_1_optgroup_1_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r1 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", child_r1.value)("disabled", child_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", child_r1.label, " ");
} }
function FormlyFieldSelectComponent_select_0_ng_container_1_optgroup_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "optgroup", 6);
    i0.ɵɵtemplate(1, FormlyFieldSelectComponent_select_0_ng_container_1_optgroup_1_option_1_Template, 2, 3, "option", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("label", item_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r2.group);
} }
function FormlyFieldSelectComponent_select_0_ng_container_1_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngValue", item_r2.value)("disabled", item_r2.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.label);
} }
function FormlyFieldSelectComponent_select_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormlyFieldSelectComponent_select_0_ng_container_1_optgroup_1_Template, 2, 2, "optgroup", 4)(2, FormlyFieldSelectComponent_select_0_ng_container_1_option_2_Template, 2, 3, "option", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r2.group);
} }
function FormlyFieldSelectComponent_select_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "select", 2);
    i0.ɵɵtemplate(1, FormlyFieldSelectComponent_select_0_ng_container_1_Template, 3, 2, "ng-container", 3);
    i0.ɵɵpipe(2, "formlySelectOptions");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("custom-select", ctx_r2.props.customSelect)("is-invalid", ctx_r2.showError);
    i0.ɵɵproperty("formControl", ctx_r2.formControl)("formlyAttributes", ctx_r2.field);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 10, i0.ɵɵpipeBind2(2, 7, ctx_r2.props.options, ctx_r2.field)));
} }
function FormlyFieldSelectComponent_ng_template_1_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngValue", null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.props.placeholder);
} }
function FormlyFieldSelectComponent_ng_template_1_ng_container_2_optgroup_1_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", child_r4.value)("disabled", child_r4.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", child_r4.label, " ");
} }
function FormlyFieldSelectComponent_ng_template_1_ng_container_2_optgroup_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "optgroup", 6);
    i0.ɵɵtemplate(1, FormlyFieldSelectComponent_ng_template_1_ng_container_2_optgroup_1_option_1_Template, 2, 3, "option", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("label", item_r5.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r5.group);
} }
function FormlyFieldSelectComponent_ng_template_1_ng_container_2_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngValue", item_r5.value)("disabled", item_r5.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r5.label);
} }
function FormlyFieldSelectComponent_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormlyFieldSelectComponent_ng_template_1_ng_container_2_optgroup_1_Template, 2, 2, "optgroup", 4)(2, FormlyFieldSelectComponent_ng_template_1_ng_container_2_option_2_Template, 2, 3, "option", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r5.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r5.group);
} }
function FormlyFieldSelectComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "select", 9);
    i0.ɵɵtemplate(1, FormlyFieldSelectComponent_ng_template_1_option_1_Template, 2, 2, "option", 10)(2, FormlyFieldSelectComponent_ng_template_1_ng_container_2_Template, 3, 2, "ng-container", 3);
    i0.ɵɵpipe(3, "formlySelectOptions");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("custom-select", ctx_r2.props.customSelect)("is-invalid", ctx_r2.showError);
    i0.ɵɵproperty("formControl", ctx_r2.formControl)("formlyAttributes", ctx_r2.field);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.props.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 11, i0.ɵɵpipeBind2(3, 8, ctx_r2.props.options, ctx_r2.field)));
} }
class FormlyFieldSelectComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            props: { options: [] },
        };
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldSelectComponent_BaseFactory; return function FormlyFieldSelectComponent_Factory(t) { return (ɵFormlyFieldSelectComponent_BaseFactory || (ɵFormlyFieldSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldSelectComponent)))(t || FormlyFieldSelectComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldSelectComponent, selectors: [["sds-formly-field-select"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["singleSelect", ""], ["multiple", "", 3, "custom-select", "formControl", "is-invalid", "formlyAttributes", 4, "ngIf", "ngIfElse"], ["multiple", "", 3, "formControl", "formlyAttributes"], [4, "ngFor", "ngForOf"], [3, "label", 4, "ngIf"], [3, "ngValue", "disabled", 4, "ngIf"], [3, "label"], [3, "ngValue", "disabled", 4, "ngFor", "ngForOf"], [3, "ngValue", "disabled"], [1, "usa-select", 3, "formControl", "formlyAttributes"], [3, "ngValue", 4, "ngIf"], [3, "ngValue"]], template: function FormlyFieldSelectComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FormlyFieldSelectComponent_select_0_Template, 4, 12, "select", 1)(1, FormlyFieldSelectComponent_ng_template_1_Template, 5, 13, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const singleSelect_r6 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.props.multiple)("ngIfElse", singleSelect_r6);
        } }, dependencies: [i1.NgForOf, i1.NgIf, i2$2.NgSelectOption, i2$2.ɵNgSelectMultipleOption, i2$2.SelectControlValueAccessor, i2$2.SelectMultipleControlValueAccessor, i2$2.NgControlStatus, i2$2.FormControlDirective, i3.ɵFormlyAttributes, i1.AsyncPipe, i4.FormlySelectOptionsPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldSelectComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-select',
                template: `
    <select
      *ngIf="props.multiple; else singleSelect"
      multiple
      [class.custom-select]="props.customSelect"
      [formControl]="formControl"
      [class.is-invalid]="showError"
      [formlyAttributes]="field"
    >
      <ng-container *ngFor="let item of props.options | formlySelectOptions: field | async">
        <optgroup *ngIf="item.group" label="{{ item.label }}">
          <option *ngFor="let child of item.group" [ngValue]="child.value" [disabled]="child.disabled">
            {{ child.label }}
          </option>
        </optgroup>
        <option *ngIf="!item.group" [ngValue]="item.value" [disabled]="item.disabled">{{ item.label }}</option>
      </ng-container>
    </select>
    <ng-template #singleSelect>
      <select
        class="usa-select"
        [formControl]="formControl"
        [class.custom-select]="props.customSelect"
        [class.is-invalid]="showError"
        [formlyAttributes]="field"
      >
        <option *ngIf="props.placeholder" [ngValue]="null">{{ props.placeholder }}</option>
        <ng-container *ngFor="let item of props.options | formlySelectOptions: field | async">
          <optgroup *ngIf="item.group" label="{{ item.label }}">
            <option *ngFor="let child of item.group" [ngValue]="child.value" [disabled]="child.disabled">
              {{ child.label }}
            </option>
          </optgroup>
          <option *ngIf="!item.group" [ngValue]="item.value" [disabled]="item.disabled">{{ item.label }}</option>
        </ng-container>
      </select>
    </ng-template>
  `,
            }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldSelectComponent, { className: "FormlyFieldSelectComponent" }); })();

const _c0$o = ["defaultTemplate"];
const _c1$8 = (a0, a1) => ({ "horizontal": a0, "grid-row": a1 });
const _c2$6 = (a0, a1, a2, a3, a4, a5, a6) => ({ $implicit: a0, i: a1, props: a2, field: a3, id: a4, showError: a5, formControl: a6 });
const _c3$3 = a0 => ({ "horizontal-option": a0 });
const _c4$2 = (a0, a1) => ({ "usa-radio__input--tile": a0, "usa-input--error": a1 });
const _c5$1 = (a0, a1) => ({ "horizontal-option": a0, "margin-top-1": a1 });
function FormlyFieldRadioComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const defaultTemplate_r4 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.props.template ? ctx_r2.props.template : defaultTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction7(2, _c2$6, option_r1, i_r2, ctx_r2.props, ctx_r2.field, ctx_r2.id, ctx_r2.showError, ctx_r2.formControl));
} }
function FormlyFieldRadioComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormlyFieldRadioComponent_div_1_ng_container_1_Template, 1, 10, "ng-container", 4);
    i0.ɵɵpipe(2, "formlySelectOptions");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 4, i0.ɵɵpipeBind2(2, 1, ctx_r2.props.options, ctx_r2.field)));
} }
function FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_ng_container_6_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 17);
} if (rf & 2) {
    const description_r5 = ctx.$implicit;
    i0.ɵɵproperty("innerHtml", description_r5, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_ng_container_6_span_2_Template, 1, 1, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r6 = i0.ɵɵnextContext().index;
    const option_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", option_r7.value[j_r6].description);
} }
function FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_div_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 20);
} if (rf & 2) {
    const j_r6 = i0.ɵɵnextContext(2).index;
    const option_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", option_r7.value[j_r6].tooltipClass)("innerHTML", option_r7.value[j_r6].tooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_div_7_ng_template_1_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent_r8 = i0.ɵɵreference(2);
    const j_r6 = i0.ɵɵnextContext().index;
    const option_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", option_r7.value[j_r6].tooltipPosition ? option_r7.value[j_r6].tooltipPosition : "right")("sdsTooltip", tipContent_r8)("size", "lg")("icon", "info-circle");
} }
function FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 8);
    i0.ɵɵelementStart(1, "div", 10)(2, "div");
    i0.ɵɵelement(3, "input", 11);
    i0.ɵɵelementStart(4, "label", 12);
    i0.ɵɵelement(5, "span", 13);
    i0.ɵɵtemplate(6, FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_ng_container_6_Template, 3, 1, "ng-container", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_div_7_Template, 4, 4, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const opt_r9 = ctx.$implicit;
    const j_r6 = ctx.index;
    const ctx_r9 = i0.ɵɵnextContext();
    const option_r7 = ctx_r9.$implicit;
    const i_r11 = ctx_r9.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$3, ctx_r2.props.horizontal));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c4$2, ctx_r2.props.tile, !ctx_r2.showError))("formlyAttributes", ctx_r2.field)("id", ctx_r2.id + "_" + i_r11 + "_" + j_r6)("name", option_r7.value)("formControl", ctx_r2.formControl)("value", opt_r9.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.getClassName(j_r6))("for", ctx_r2.id + "_" + i_r11 + "_" + j_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", opt_r9.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r7.value[j_r6].description && option_r7.value[j_r6].description.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r7.value[j_r6].tooltipText);
} }
function FormlyFieldRadioComponent_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 8);
    i0.ɵɵelementStart(1, "div")(2, "legend")(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, FormlyFieldRadioComponent_div_2_ng_container_2_ng_container_5_Template, 8, 17, "ng-container", 7);
    i0.ɵɵpipe(6, "formlySelectOptions");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(option_r7.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(7, 5, i0.ɵɵpipeBind2(6, 2, option_r7.value, ctx_r2.field)));
} }
function FormlyFieldRadioComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "fieldset", 6);
    i0.ɵɵtemplate(2, FormlyFieldRadioComponent_div_2_ng_container_2_Template, 8, 7, "ng-container", 7);
    i0.ɵɵpipe(3, "keyvalue");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 1, ctx_r2.props.groupOptions));
} }
function FormlyFieldRadioComponent_ng_template_3_ng_container_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 17);
} if (rf & 2) {
    const description_r12 = ctx.$implicit;
    i0.ɵɵproperty("innerHtml", description_r12, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldRadioComponent_ng_template_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, FormlyFieldRadioComponent_ng_template_3_ng_container_5_span_2_Template, 1, 1, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    const i_r14 = ctx_r12.i;
    const props_r15 = ctx_r12.props;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", props_r15.options[i_r14].description);
} }
function FormlyFieldRadioComponent_ng_template_3_div_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 20);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    const i_r14 = ctx_r12.i;
    const props_r15 = ctx_r12.props;
    i0.ɵɵproperty("ngClass", props_r15.options[i_r14].tooltipClass)("innerHTML", props_r15.options[i_r14].tooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldRadioComponent_ng_template_3_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, FormlyFieldRadioComponent_ng_template_3_div_6_ng_template_1_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent_r16 = i0.ɵɵreference(2);
    const ctx_r12 = i0.ɵɵnextContext();
    const i_r14 = ctx_r12.i;
    const props_r15 = ctx_r12.props;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", props_r15.options[i_r14].tooltipPosition ? props_r15.options[i_r14].tooltipPosition : "right")("sdsTooltip", tipContent_r16)("size", "lg")("icon", "info-circle");
} }
function FormlyFieldRadioComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div");
    i0.ɵɵelement(2, "input", 21);
    i0.ɵɵelementStart(3, "label", 12);
    i0.ɵɵelement(4, "span", 13);
    i0.ɵɵtemplate(5, FormlyFieldRadioComponent_ng_template_3_ng_container_5_Template, 3, 1, "ng-container", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, FormlyFieldRadioComponent_ng_template_3_div_6_Template, 4, 4, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r17 = ctx.$implicit;
    const i_r14 = ctx.i;
    const props_r15 = ctx.props;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c5$1, props_r15.horizontal, props_r15.description && i_r14 == 0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c4$2, props_r15.tile, !ctx_r2.showError))("formlyAttributes", ctx_r2.field)("id", ctx_r2.id + "_" + i_r14)("name", ctx_r2.id)("formControl", ctx_r2.formControl)("value", option_r17.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.getClassName(i_r14))("for", ctx_r2.id + "_" + i_r14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", option_r17.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", props_r15.options[i_r14].description && props_r15.options[i_r14].description.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", props_r15.options[i_r14].tooltipText);
} }
class FormlyFieldRadioComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.displayedTemplate = null;
        this.defaultOptions = {
            props: {
                options: [],
            },
        };
    }
    getClassName(index) {
        let cls = '';
        if (index === 0) {
            cls = 'margin-top-0';
        }
        return `${this.props.optionsClass} ${cls}`;
    }
    ngAfterViewInit() {
        const passedIn = this.props.template;
        setTimeout(() => {
            this.displayedTemplate = passedIn ? passedIn : this.defaultTemplate;
        });
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldRadioComponent_BaseFactory; return function FormlyFieldRadioComponent_Factory(t) { return (ɵFormlyFieldRadioComponent_BaseFactory || (ɵFormlyFieldRadioComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldRadioComponent)))(t || FormlyFieldRadioComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldRadioComponent, selectors: [["sds-formly-field-radio"]], viewQuery: function FormlyFieldRadioComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$o, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 9, consts: [["defaultTemplate", ""], ["tipContent", ""], [1, "usa-radio", 3, "id", "ngClass"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "usa-fieldset"], ["class", "grid-row", 4, "ngFor", "ngForOf"], [1, "grid-row"], [1, "text-bold", "display-block", "margin-top-1", "margin-bottom-05"], [1, "grid-row", 3, "ngClass"], ["type", "radio", "checked", "checked", 1, "usa-radio__input", 3, "ngClass", "formlyAttributes", "id", "name", "formControl", "value"], [1, "usa-radio__label", 3, "ngClass", "for"], [3, "innerHtml"], ["class", "margin-left-1", 4, "ngIf"], [1, "usa-checkbox__label-description"], ["class", "display-block", 3, "innerHtml", 4, "ngFor", "ngForOf"], [1, "display-block", 3, "innerHtml"], [1, "margin-left-1"], [1, "text-secondary", 3, "position", "sdsTooltip", "size", "icon"], [1, "margin-1", 3, "ngClass", "innerHTML"], ["type", "radio", "checked", "checked", "tabindex", "0", 1, "usa-radio__input", 3, "ngClass", "formlyAttributes", "id", "name", "formControl", "value"]], template: function FormlyFieldRadioComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 2);
            i0.ɵɵtemplate(1, FormlyFieldRadioComponent_div_1_Template, 4, 6, "div", 3)(2, FormlyFieldRadioComponent_div_2_Template, 4, 3, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, FormlyFieldRadioComponent_ng_template_3_Template, 7, 18, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("id", ctx.id)("ngClass", i0.ɵɵpureFunction2(6, _c1$8, ctx.props.horizontal, ctx.props.horizontal));
            i0.ɵɵattribute("aria-label", ctx.props.ariaLabel ? ctx.props.ariaLabel : ctx.props.label)("aria-describedby", ctx.props.description ? ctx.id + "-description" : undefined);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.options);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.groupOptions);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.IconComponent, i2$2.ɵNgNoValidate, i2$2.DefaultValueAccessor, i2$2.RadioControlValueAccessor, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormControlDirective, i2$2.NgForm, i2$3.SdsTooltip, i3.ɵFormlyAttributes, i1.AsyncPipe, i1.KeyValuePipe, i4.FormlySelectOptionsPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldRadioComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-field-radio', template: "<form\n  class=\"usa-radio\"\n  [id]=\"id\"\n  [attr.aria-label]=\"props.ariaLabel? props.ariaLabel : props.label\"\n  [attr.aria-describedby]=\"props.description ? id + '-description' : undefined\"\n  [ngClass]=\"{'horizontal': props.horizontal, 'grid-row': props.horizontal}\"\n>\n  <div *ngIf=\"props.options\">\n    <ng-container\n      *ngFor=\"\n  let option of props.options | formlySelectOptions: field | async;\n  let i = index\"\n      [ngTemplateOutlet]=\"(props.template ? props.template : defaultTemplate)\"\n      [ngTemplateOutletContext]=\"{\n    $implicit: option,\n    i: i,\n    props:props,\n    field: field,\n    id: id,\n    showError: showError,\n    formControl: formControl\n  }\"\n    >\n    </ng-container>\n  </div>\n\n  <div *ngIf=\"props.groupOptions\">\n    <fieldset class=\"usa-fieldset\">\n      <ng-container class=\"grid-row\" *ngFor=\"let option of (props.groupOptions |  keyvalue); let i = index\">\n        <div>\n          <legend>\n            <span class=\"text-bold display-block margin-top-1 margin-bottom-05\">{{option.key}}</span>\n          </legend>\n\n          <ng-container\n            class=\"grid-row\"\n            *ngFor=\"let opt of option.value | formlySelectOptions: field | async; let j = index\"\n          >\n            <div class=\"grid-row\" [ngClass]=\"{'horizontal-option': props.horizontal}\">\n              <div>\n                <input\n                  class=\"usa-radio__input\"\n                  [ngClass]=\"{'usa-radio__input--tile': props.tile, 'usa-input--error': !showError}\"\n                  [formlyAttributes]=\"field\"\n                  [id]=\"id + '_' + i+ '_'+ j\"\n                  type=\"radio\"\n                  [name]=\"option.value\"\n                  checked=\"checked\"\n                  [formControl]=\"formControl\"\n                  [value]=\"opt.value\"\n                />\n\n                <label class=\"usa-radio__label\" [ngClass]=\"getClassName(j)\" [for]=\"id + '_' + i+ '_'+ j\">\n                  <span [innerHtml]=\"opt.label\"></span>\n                  <ng-container *ngIf=\"option.value[j].description && option.value[j].description.length\">\n                    <div class=\"usa-checkbox__label-description\">\n                      <span\n                        class=\"display-block\"\n                        *ngFor=\"let description of option.value[j].description\"\n                        [innerHtml]=\"description\"\n                      ></span>\n                    </div>\n                  </ng-container>\n                </label>\n              </div>\n\n              <div class=\"margin-left-1\" *ngIf=\"option.value[j].tooltipText\">\n                <ng-template #tipContent>\n                  <p\n                    [ngClass]=\"option.value[j].tooltipClass\"\n                    class=\"margin-1\"\n                    [innerHTML]=\"option.value[j].tooltipText\"\n                  ></p>\n                </ng-template>\n                <usa-icon\n                  class=\"text-secondary\"\n                  [position]=\"option.value[j].tooltipPosition ? option.value[j].tooltipPosition :'right'\"\n                  [sdsTooltip]=\"tipContent\"\n                  [size]=\"'lg'\"\n                  [icon]=\"'info-circle'\"\n                ></usa-icon>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </fieldset>\n  </div>\n</form>\n\n<ng-template let-option let-i=\"i\" let-props=\"props\" #defaultTemplate>\n  <div class=\"grid-row\" [ngClass]=\"{'horizontal-option': props.horizontal ,'margin-top-1': props.description && i==0 }\">\n    <div>\n      <input\n        class=\"usa-radio__input\"\n        [ngClass]=\"{'usa-radio__input--tile': props.tile, 'usa-input--error': !showError}\"\n        [formlyAttributes]=\"field\"\n        [id]=\"id + '_' + i\"\n        type=\"radio\"\n        [name]=\"id\"\n        checked=\"checked\"\n        [formControl]=\"formControl\"\n        [value]=\"option.value\"\n        tabindex=\"0\"\n      />\n\n      <label class=\"usa-radio__label\" [ngClass]=\"getClassName(i)\" [for]=\"id + '_' + i\">\n        <span [innerHtml]=\"option.label\"></span>\n        <ng-container *ngIf=\"props.options[i].description && props.options[i].description.length\">\n          <div class=\"usa-checkbox__label-description\">\n            <span\n              class=\"display-block\"\n              *ngFor=\"let description of props.options[i].description\"\n              [innerHtml]=\"description\"\n            ></span>\n          </div>\n        </ng-container>\n      </label>\n    </div>\n\n    <div class=\"margin-left-1\" *ngIf=\"props.options[i].tooltipText\">\n      <ng-template #tipContent>\n        <p [ngClass]=\"props.options[i].tooltipClass\" class=\"margin-1\" [innerHTML]=\"props.options[i].tooltipText\"></p>\n      </ng-template>\n      <usa-icon\n        class=\"text-secondary\"\n        [position]=\"props.options[i].tooltipPosition ? props.options[i].tooltipPosition :'right'\"\n        [sdsTooltip]=\"tipContent\"\n        [size]=\"'lg'\"\n        [icon]=\"'info-circle'\"\n      ></usa-icon>\n    </div>\n  </div>\n</ng-template>\n" }]
    }], null, { defaultTemplate: [{
            type: ViewChild,
            args: ['defaultTemplate']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldRadioComponent, { className: "FormlyFieldRadioComponent" }); })();

const _c0$n = ["defaultTemplate"];
const _c1$7 = (a0, a1, a2, a3, a4) => ({ $implicit: a0, showError: a1, formControl: a2, field: a3, id: a4 });
function FormlyFieldCheckboxComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementContainer(2, 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.props.template)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c1$7, ctx_r0.props, ctx_r0.showError, ctx_r0.formControl, ctx_r0.field, ctx_r0.id));
} }
function FormlyFieldCheckboxComponent_ng_template_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " (Optional)");
    i0.ɵɵelementEnd();
} }
function FormlyFieldCheckboxComponent_ng_template_2_div_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 13);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.props.tooltipClass)("innerHTML", ctx_r0.props.tooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldCheckboxComponent_ng_template_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, FormlyFieldCheckboxComponent_ng_template_2_div_5_ng_template_1_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent_r2 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", ctx_r0.props.tooltipPosition ? ctx_r0.props.tooltipPosition : "right")("sdsTooltip", tipContent_r2)("size", "lg")("icon", "info-circle");
} }
function FormlyFieldCheckboxComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "input", 6);
    i0.ɵɵelementStart(2, "label", 7);
    i0.ɵɵelement(3, "span", 8);
    i0.ɵɵtemplate(4, FormlyFieldCheckboxComponent_ng_template_2_span_4_Template, 2, 0, "span", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, FormlyFieldCheckboxComponent_ng_template_2_div_5_Template, 4, 4, "div", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("text-align-end", ctx_r0.props.textAlignEnd);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-invalid", ctx_r0.showError);
    i0.ɵɵproperty("indeterminate", ctx_r0.props.indeterminate && ctx_r0.formControl.value === null)("formControl", ctx_r0.formControl)("formlyAttributes", ctx_r0.field);
    i0.ɵɵattribute("aria-describedby", ctx_r0.props.description ? ctx_r0.id + "-description" : undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", ctx_r0.props.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.props.required && !ctx_r0.props.hideOptional);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.props.tooltipText);
} }
class FormlyFieldCheckboxComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.displayedTemplate = null;
        this.defaultOptions = {
            props: {
                indeterminate: true,
                hideLabel: true,
            },
        };
    }
    ngAfterViewInit() {
        const passedIn = this.props.template;
        setTimeout(() => {
            this.displayedTemplate = passedIn ? passedIn : this.defaultTemplate;
        });
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldCheckboxComponent_BaseFactory; return function FormlyFieldCheckboxComponent_Factory(t) { return (ɵFormlyFieldCheckboxComponent_BaseFactory || (ɵFormlyFieldCheckboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldCheckboxComponent)))(t || FormlyFieldCheckboxComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldCheckboxComponent, selectors: [["sds-formly-field-checkbox"]], viewQuery: function FormlyFieldCheckboxComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$n, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [["defaultTemplate", ""], ["tipContent", ""], [1, "grid-row"], [4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "usa-checkbox"], ["type", "checkbox", 1, "usa-checkbox__input", 3, "indeterminate", "formControl", "formlyAttributes"], [1, "usa-checkbox__label", 3, "for"], [3, "innerHtml"], [4, "ngIf"], ["class", "padding-top-105 margin-left-1", 4, "ngIf"], [1, "padding-top-105", "margin-left-1"], [1, "text-secondary", 3, "position", "sdsTooltip", "size", "icon"], [1, "margin-1", 3, "ngClass", "innerHTML"]], template: function FormlyFieldCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, FormlyFieldCheckboxComponent_ng_container_1_Template, 3, 8, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, FormlyFieldCheckboxComponent_ng_template_2_Template, 6, 12, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultTemplate_r3 = i0.ɵɵreference(3);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.template)("ngIfElse", defaultTemplate_r3);
        } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2$1.IconComponent, i2$2.CheckboxControlValueAccessor, i2$2.NgControlStatus, i2$2.FormControlDirective, i2$3.SdsTooltip, i3.ɵFormlyAttributes], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldCheckboxComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-field-checkbox', template: "<div class=\"grid-row\">\n  <ng-container *ngIf=\"props.template; else defaultTemplate\">\n    <div class=\"grid-row\">\n      <ng-container\n        [ngTemplateOutlet]=\"(props.template)\"\n        [ngTemplateOutletContext]=\"{\n        $implicit: props,\n        showError: showError,\n        formControl: formControl,\n        field: field,\n        id: id\n      }\"\n      >\n      </ng-container>\n    </div>\n  </ng-container>\n</div>\n\n<ng-template #defaultTemplate>\n  <div class=\"usa-checkbox\" [class.text-align-end]=\"props.textAlignEnd\">\n    <input\n      class=\"usa-checkbox__input\"\n      type=\"checkbox\"\n      [class.is-invalid]=\"showError\"\n      [indeterminate]=\"props.indeterminate && formControl.value === null\"\n      [formControl]=\"formControl\"\n      [formlyAttributes]=\"field\"\n      [attr.aria-describedby]=\"props.description ? id + '-description' : undefined\"\n    />\n    <label class=\"usa-checkbox__label\" [for]=\"id\">\n      <span [innerHtml]=\"props.label\"></span>\n      <span *ngIf=\"!props.required && !props.hideOptional\"> (Optional)</span>\n    </label>\n  </div>\n\n  <div *ngIf=\"props.tooltipText\" class=\"padding-top-105 margin-left-1\">\n    <ng-template #tipContent>\n      <p [ngClass]=\"props.tooltipClass\" class=\"margin-1\" [innerHTML]=\"props.tooltipText\"></p>\n    </ng-template>\n    <usa-icon\n      class=\"text-secondary\"\n      [position]=\"props.tooltipPosition ? props.tooltipPosition :'right'\"\n      [sdsTooltip]=\"tipContent\"\n      [size]=\"'lg'\"\n      [icon]=\"'info-circle'\"\n    ></usa-icon>\n  </div>\n</ng-template>\n" }]
    }], null, { defaultTemplate: [{
            type: ViewChild,
            args: ['defaultTemplate']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldCheckboxComponent, { className: "FormlyFieldCheckboxComponent" }); })();

const _c0$m = a0 => ({ "margin-top-1": a0 });
const _c1$6 = a0 => ({ "margin-left-4 ": a0 });
const _c2$5 = a0 => ({ "margin-top-0": a0 });
const _c3$2 = a0 => ({ "margin-left-6 ": a0 });
function FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const j_r4 = i0.ɵɵnextContext().index;
    const option_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", option_r5.value[j_r4].tagClass ? option_r5.value[j_r4].tagClass : "sds-tag--info-white");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r5.value[j_r4].tagText, " ");
} }
function FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_div_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 22);
} if (rf & 2) {
    const j_r4 = i0.ɵɵnextContext(2).index;
    const option_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", option_r5.value[j_r4].tooltipClass)("innerHTML", option_r5.value[j_r4].tooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_div_6_ng_template_1_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent_r6 = i0.ɵɵreference(2);
    const j_r4 = i0.ɵɵnextContext().index;
    const option_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", option_r5.value[j_r4].tooltipPosition ? option_r5.value[j_r4].tooltipPosition : "right")("sdsTooltip", tipContent_r6)("size", "sm")("icon", "info-circle");
} }
function FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12)(1, "div", 13)(2, "input", 14);
    i0.ɵɵlistener("change", function FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_Template_input_change_2_listener($event) { const opt_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onChange(opt_r2.value, $event.target.checked)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 15);
    i0.ɵɵtemplate(4, FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_span_4_Template, 2, 2, "span", 16);
    i0.ɵɵelement(5, "span", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_div_6_Template, 4, 4, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r2 = ctx.$implicit;
    const j_r4 = ctx.index;
    const ctx_r6 = i0.ɵɵnextContext();
    const option_r5 = ctx_r6.$implicit;
    const i_r8 = ctx_r6.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("text-align-end", ctx_r2.props.textAlignEnd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id + "_" + i_r8 + j_r4)("name", ctx_r2.id + "_name_" + i_r8 + j_r4)("disabled", opt_r2.disabled)("value", opt_r2.label)("formlyAttributes", ctx_r2.field)("checked", ctx_r2.isChecked(opt_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r2.id + "_" + i_r8 + j_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r5.value[j_r4].tagText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", opt_r2.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r5.value[j_r4].tooltipText);
} }
function FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 9)(1, "div")(2, "legend")(3, "span", 10);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_li_5_Template, 7, 12, "li", 11);
    i0.ɵɵpipe(6, "formlySelectOptions");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(option_r5.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(7, 5, i0.ɵɵpipeBind2(6, 2, option_r5.value, ctx_r2.field)));
} }
function FormlyFieldMultiCheckboxComponent_fieldset_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 6)(1, "ul", 7);
    i0.ɵɵtemplate(2, FormlyFieldMultiCheckboxComponent_fieldset_3_li_2_Template, 8, 7, "li", 8);
    i0.ɵɵpipe(3, "keyvalue");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 1, ctx_r2.props.groupOptions));
} }
function FormlyFieldMultiCheckboxComponent_ul_4_li_1_div_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 22);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r2.props.tooltipClass)("innerHTML", ctx_r2.props.selectTooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_li_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormlyFieldMultiCheckboxComponent_ul_4_li_1_div_5_ng_template_1_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent1_r10 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", ctx_r2.props.selecttooltipPosition ? ctx_r2.props.selecttooltipPosition : "right")("sdsTooltip", tipContent1_r10)("size", "sm")("icon", "info-circle");
} }
function FormlyFieldMultiCheckboxComponent_ul_4_li_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 28);
    i0.ɵɵlistener("click", function FormlyFieldMultiCheckboxComponent_ul_4_li_1_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.props.expandedOptions = !ctx_r2.props.expandedOptions); });
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtext(3, "expand/collapsed");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "usa-icon", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-expanded", !ctx_r2.props.expandedOptions)("aria-controls", ctx_r2.id + "collapseID");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("icon", ctx_r2.props.expandedOptions ? "caret-down-fill" : "caret-up-fill")("size", "1x");
} }
function FormlyFieldMultiCheckboxComponent_ul_4_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 9)(1, "div", 13)(2, "input", 25);
    i0.ɵɵlistener("change", function FormlyFieldMultiCheckboxComponent_ul_4_li_1_Template_input_change_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.setAll($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 15);
    i0.ɵɵelement(4, "span", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, FormlyFieldMultiCheckboxComponent_ul_4_li_1_div_5_Template, 4, 4, "div", 26)(6, FormlyFieldMultiCheckboxComponent_ul_4_li_1_div_6_Template, 5, 4, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("text-align-end", ctx_r2.props.textAlignEnd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id)("name", ctx_r2.id + "_name_" + "Select")("value", ctx_r2.props.label)("checked", ctx_r2.checkMainOption(ctx_r2.id, ctx_r2.props.options));
    i0.ɵɵattribute("aria-checked", ctx_r2.mainOptionAriaChecked[ctx_r2.getIndex(ctx_r2.id)]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", ctx_r2.props.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.props.selectTooltipText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.props.expandableOptions);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", option_r13.tagClass ? option_r13.tagClass : "sds-tag--info-white");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r13.tagText, " ");
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_div_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 22);
} if (rf & 2) {
    const option_r13 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngClass", option_r13.tooltipClass)("innerHTML", option_r13.tooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_div_6_ng_template_1_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent_r14 = i0.ɵɵreference(2);
    const option_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", option_r13.tooltipPosition ? option_r13.tooltipPosition : "right")("sdsTooltip", tipContent_r14)("size", "sm")("icon", "info-circle");
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 31)(1, "div", 13)(2, "input", 14);
    i0.ɵɵlistener("change", function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_Template_input_change_2_listener($event) { i0.ɵɵrestoreView(_r12); const option_r13 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onMainOptionChange(option_r13.value, $event.target.checked, ctx_r2.props.options, ctx_r2.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 32);
    i0.ɵɵtemplate(4, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_span_4_Template, 2, 2, "span", 16);
    i0.ɵɵelement(5, "span", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_div_6_Template, 4, 4, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const option_r13 = ctx_r14.$implicit;
    const i_r16 = ctx_r14.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1$6, ctx_r2.props.selectAllOption));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("text-align-end", ctx_r2.props.textAlignEnd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id + "_" + i_r16)("name", ctx_r2.id + "_name_" + i_r16)("disabled", option_r13.disabled)("value", option_r13.label)("formlyAttributes", ctx_r2.field)("checked", ctx_r2.isChecked(option_r13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c2$5, i_r16 == 0))("for", ctx_r2.id + "_" + i_r16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r13.tagText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", option_r13.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r13.tooltipText);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subOption_r19 = i0.ɵɵnextContext().$implicit;
    const option_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", subOption_r19.tagClass ? subOption_r19.tagClass : "sds-tag--info-white");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r13.tagText, " ");
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_div_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 22);
} if (rf & 2) {
    const subOption_r19 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", subOption_r19.tooltipClass)("innerHTML", subOption_r19.tooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_div_6_ng_template_1_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent_r20 = i0.ɵɵreference(2);
    const subOption_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", subOption_r19.tooltipPosition ? subOption_r19.tooltipPosition : "right")("sdsTooltip", tipContent_r20)("size", "sm")("icon", "info-circle");
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 9)(1, "div", 13)(2, "input", 14);
    i0.ɵɵlistener("change", function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_Template_input_change_2_listener($event) { const subOption_r19 = i0.ɵɵrestoreView(_r18).$implicit; const ctx_r14 = i0.ɵɵnextContext(2); const option_r13 = ctx_r14.$implicit; const i_r16 = ctx_r14.index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onSubOptionChange(subOption_r19, $event.target.checked, option_r13.props.options, i_r16)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 15);
    i0.ɵɵtemplate(4, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_span_4_Template, 2, 2, "span", 16);
    i0.ɵɵelement(5, "span", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_div_6_Template, 4, 4, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subOption_r19 = ctx.$implicit;
    const j_r21 = ctx.index;
    const i_r16 = i0.ɵɵnextContext(2).index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("text-align-end", ctx_r2.props.textAlignEnd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id + "_" + i_r16 + "_" + j_r21)("name", ctx_r2.id + "_" + i_r16 + "_name_" + j_r21)("disabled", subOption_r19.disabled)("value", subOption_r19.label)("formlyAttributes", ctx_r2.field)("checked", ctx_r2.isChecked(subOption_r19));
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r2.id + "_" + i_r16 + "_" + j_r21);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", subOption_r19.tagText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", subOption_r19.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", subOption_r19.tooltipText);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 33)(2, "div", 13)(3, "input", 25);
    i0.ɵɵlistener("change", function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_Template_input_change_3_listener($event) { i0.ɵɵrestoreView(_r17); const option_r13 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onMainOptionChange(option_r13.value, $event.target.checked, ctx_r2.props.options, ctx_r2.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 15);
    i0.ɵɵelement(5, "span", 17);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "ul", 34);
    i0.ɵɵtemplate(7, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_li_7_Template, 7, 12, "li", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const option_r13 = ctx_r14.$implicit;
    const i_r16 = ctx_r14.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("text-align-end", ctx_r2.props.textAlignEnd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id + "_" + i_r16)("name", ctx_r2.id + "_name_" + i_r16)("value", option_r13.props.label)("checked", ctx_r2.checkSubOption(option_r13.props.options, i_r16));
    i0.ɵɵattribute("aria-checked", ctx_r2.subOptionAriaChecked[i_r16]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r2.id + "_" + i_r16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", option_r13.props.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "collapseID")("sdsCollapse", ctx_r2.props.expandedOptions)("ngClass", i0.ɵɵpureFunction1(13, _c3$2, ctx_r2.props.selectAllOption));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", option_r13.props.options);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_li_1_Template, 7, 18, "li", 30)(2, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_ng_container_2_Template, 8, 15, "ng-container", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r13 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !option_r13.props);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r13.props);
} }
function FormlyFieldMultiCheckboxComponent_ul_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 7);
    i0.ɵɵtemplate(1, FormlyFieldMultiCheckboxComponent_ul_4_li_1_Template, 7, 11, "li", 23)(2, FormlyFieldMultiCheckboxComponent_ul_4_ng_container_2_Template, 3, 2, "ng-container", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.props.selectAllOption);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.props.options);
} }
class FormlyFieldMultiCheckboxComponent extends FieldType {
    constructor(cdr) {
        super();
        this.cdr = cdr;
        this.defaultOptions = {
            props: {
                options: [],
                expandableOptions: false,
                expandedOptions: false,
            },
        };
        this.ariaChecked = '';
        this.mainOptionAriaChecked = [];
        this.subOptionAriaChecked = [];
    }
    ngOnInit() {
        this.subOptionAriaChecked.fill('false');
        this.mainOptionAriaChecked.fill('false');
    }
    checkSubOption(allSubOptions, index) {
        let allKeys = allSubOptions.map((opt) => opt.value);
        const uniqValues = {};
        if (this.formControl.value) {
            this.formControl.value.forEach((i) => (uniqValues[i] = true));
            if (allKeys.every((val) => uniqValues[val])) {
                this.subOptionAriaChecked[index] = 'true';
                return true;
            }
            else if (allKeys.some((val) => uniqValues[val])) {
                this.subOptionAriaChecked[index] = 'mixed';
                return true;
            }
            else {
                this.subOptionAriaChecked[index] = 'false';
                return false;
            }
        }
    }
    checkMainOption(id, allSubOptions) {
        let index = this.getIndex(id);
        let allKeys = [];
        allSubOptions.map((opt) => {
            allKeys.push(opt.value);
            if (opt.props && opt.props.options) {
                opt.props.options.map((subOpt) => allKeys.push(subOpt.value));
            }
        });
        let uniqValues = {};
        if (this.formControl.value && Array.isArray(this.formControl.value)) {
            this.formControl.value.forEach((i) => (uniqValues[i] = true));
        }
        else if (this.formControl.value && typeof this.formControl.value === 'object') {
            uniqValues = this.formControl.value;
        }
        if (allKeys.every((val) => uniqValues[val])) {
            this.mainOptionAriaChecked[index] = 'true';
            return true;
        }
        else if (allKeys.some((val) => uniqValues[val])) {
            this.mainOptionAriaChecked[index] = 'mixed';
            return true;
        }
        else {
            this.mainOptionAriaChecked[index] = 'false';
            return false;
        }
    }
    onSubOptionChange(subOption, checked, allSubOptions, index) {
        this.onChange(subOption.value, checked);
        let checkedValues = [];
        allSubOptions.forEach((subOpt) => {
            checkedValues.push(this.isChecked(subOpt));
        });
        if (checkedValues.every((val, i, arr) => val === arr[0])) {
            this.subOptionAriaChecked[index] = checkedValues[0] ? 'true' : 'false';
        }
        else {
            this.subOptionAriaChecked[index] = 'mixed';
        }
    }
    onMainOptionChange(value, checked, mainOptions, id) {
        this.onChange(value, checked);
        let checkedValues = [];
        let i = this.getIndex(id);
        mainOptions.forEach((mainOpt) => {
            checkedValues.push(this.isChecked(mainOpt));
            if (mainOpt.props) {
                mainOpt.props.options.forEach((subOpt) => {
                    checkedValues.push(this.isChecked(subOpt));
                });
                if (mainOpt.value === value)
                    this.setAllSubList(checked, mainOpt, i);
            }
        });
        if (checkedValues.every((val, _i, arr) => val === arr[0])) {
            this.mainOptionAriaChecked[i] = checkedValues[0] ? 'true' : 'false';
        }
        else {
            this.mainOptionAriaChecked[i] = 'mixed';
        }
    }
    onChange(value, checked) {
        if (this.props.type === 'array') {
            this.formControl.patchValue(checked
                ? [...(this.formControl.value || []), value]
                : [...(this.formControl.value || [])].filter((o) => o !== value));
        }
        else {
            this.formControl.patchValue({
                ...this.formControl.value,
                [value]: checked,
            });
        }
        this.formControl.markAsTouched();
        this.cdr.detectChanges();
    }
    isChecked(option) {
        if (!this.formControl.value) {
            return false;
        }
        if (this.props.type === 'array') {
            return this.formControl.value.includes(option.value) && option.value != 'false';
        }
        else if (this.props.groupOptions && this.formControl.value[option.value]) {
            return this.formControl.value[option.value] && this.formControl.value[option.value] != 'false';
        }
        else if (this.formControl.value[option.value]) {
            return this.formControl.value[option.value] && this.formControl.value[option.value] != 'false';
        }
    }
    setAllSubList(checked, subList, index) {
        this.subOptionAriaChecked[index] = checked ? 'true' : 'false';
        if (Array.isArray(subList.props.options)) {
            this.field.props.options.forEach((subOption) => {
                if (subOption['value'] === subList.value) {
                    subOption['props'].options.map((item) => {
                        this.onChange(item.value, checked);
                    });
                }
            });
        }
    }
    getIndex(id) {
        return id.substring(id.length - 1);
    }
    setAll(ev) {
        let id = ev.target.id;
        let i = this.getIndex(id);
        this.mainOptionAriaChecked[i] = ev.target.checked;
        if (Array.isArray(this.field.props.options)) {
            this.formControl.setValue([]);
            this.field.props.options.map((option, index) => {
                this.onChange(option.value, ev.target.checked);
                if (option.props) {
                    this.setAllSubList(ev.target.checked, option, index);
                }
            });
        }
    }
    _getAriaChecked(value) {
        let i = this.getIndex(this.id);
        if (Array.isArray(this.field.props.options)) {
            this.allComplete = value === this.field.props.options.length ? true : false;
        }
        if (value === 0) {
            this.mainOptionAriaChecked[i] = 'false';
        }
        else {
            this.mainOptionAriaChecked[i] = value > 0 && !this.allComplete ? 'mixed' : 'true';
        }
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldMultiCheckboxComponent_Factory(t) { return new (t || FormlyFieldMultiCheckboxComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldMultiCheckboxComponent, selectors: [["sds-formly-field-multicheckbox"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 6, consts: [["tipContent", ""], ["tipContent1", ""], [1, "usa-fieldset", 3, "ngClass"], [1, "usa-sr-only"], ["class", "usa-fieldset", 4, "ngIf"], ["class", "sds-list sds-list--no-bullets margin-y-0", 4, "ngIf"], [1, "usa-fieldset"], [1, "sds-list", "sds-list--no-bullets", "margin-y-0"], ["class", "grid-row", 4, "ngFor", "ngForOf"], [1, "grid-row"], [1, "text-bold", "display-block"], ["class", "grid-row margin-bottom-0", 4, "ngFor", "ngForOf"], [1, "grid-row", "margin-bottom-0"], [1, "usa-checkbox"], ["type", "checkbox", 1, "usa-checkbox__input", 3, "change", "id", "name", "disabled", "value", "formlyAttributes", "checked"], [1, "usa-checkbox__label", 3, "for"], ["class", "usa-tag", 3, "ngClass", 4, "ngIf"], [3, "innerHtml"], ["class", "margin-left-1", 4, "ngIf"], [1, "usa-tag", 3, "ngClass"], [1, "margin-left-1"], [1, "text-secondary", 3, "position", "sdsTooltip", "size", "icon"], [1, "margin-1", 3, "ngClass", "innerHTML"], ["class", "grid-row", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["type", "checkbox", 1, "usa-checkbox__input", 3, "change", "id", "name", "value", "checked"], [4, "ngIf"], [1, "margin-left-1", 3, "position", "sdsTooltip", "size", "icon"], ["type", "button", 1, "sds-button", "padding-top-0", 3, "click"], [3, "icon", "size"], ["class", "margin-y-0 grid-row", 3, "ngClass", 4, "ngIf"], [1, "margin-y-0", "grid-row", 3, "ngClass"], [1, "usa-checkbox__label", 3, "ngClass", "for"], [1, "margin-left-4"], [3, "id", "sdsCollapse", "ngClass"]], template: function FormlyFieldMultiCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "fieldset", 2)(1, "legend", 3);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, FormlyFieldMultiCheckboxComponent_fieldset_3_Template, 4, 3, "fieldset", 4)(4, FormlyFieldMultiCheckboxComponent_ul_4_Template, 3, 2, "ul", 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$m, ctx.props.description));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.props.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.groupOptions);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.options);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$3.CollapseDirective, i2$1.IconComponent, i2$3.SdsTooltip, i3.ɵFormlyAttributes, i1.AsyncPipe, i1.KeyValuePipe, i4.FormlySelectOptionsPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldMultiCheckboxComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-field-multicheckbox', template: "<fieldset class=\"usa-fieldset\" [ngClass]=\"{ 'margin-top-1': props.description }\">\n  <legend class=\"usa-sr-only\">{{ props.label }}</legend>\n\n  <fieldset *ngIf=\"props.groupOptions\" class=\"usa-fieldset\">\n    <ul class=\"sds-list sds-list--no-bullets margin-y-0\">\n      <li class=\"grid-row\" *ngFor=\" let option of (props.groupOptions | keyvalue); let i=index\">\n        <div>\n          <legend>\n            <span class=\"text-bold display-block\">{{option.key}}</span>\n          </legend>\n          <li\n            class=\"grid-row margin-bottom-0\"\n            *ngFor=\"let opt of option.value | formlySelectOptions: field | async; let j = index\"\n          >\n            <div class=\"usa-checkbox\" [class.text-align-end]=\"props.textAlignEnd\">\n              <input\n                class=\"usa-checkbox__input\"\n                [id]=\"id + '_' + i + j\"\n                type=\"checkbox\"\n                [name]=\"id + '_name_' + i + j\"\n                [disabled]=\"opt.disabled\"\n                [value]=\"opt.label\"\n                [formlyAttributes]=\"field\"\n                (change)=\"onChange(opt.value, $event.target.checked)\"\n                [checked]=\"isChecked(opt)\"\n              />\n              <label class=\"usa-checkbox__label\" [for]=\"id + '_' + i + j\">\n                <span\n                  *ngIf=\"option.value[j].tagText\"\n                  class=\"usa-tag\"\n                  [ngClass]=\"option.value[j].tagClass ? option.value[j].tagClass : 'sds-tag--info-white'\"\n                >\n                  {{option.value[j].tagText}}\n                </span>\n                <span [innerHtml]=\"opt.label\"></span>\n              </label>\n            </div>\n            <div *ngIf=\"option.value[j].tooltipText\" class=\"margin-left-1\">\n              <ng-template #tipContent>\n                <p\n                  [ngClass]=\"option.value[j].tooltipClass\"\n                  class=\"margin-1\"\n                  [innerHTML]=\"option.value[j].tooltipText\"\n                ></p>\n              </ng-template>\n              <usa-icon\n                class=\"text-secondary\"\n                [position]=\"option.value[j].tooltipPosition ? option.value[j].tooltipPosition :'right'\"\n                [sdsTooltip]=\"tipContent\"\n                [size]=\"'sm'\"\n                [icon]=\"'info-circle'\"\n              ></usa-icon>\n            </div>\n          </li>\n        </div>\n      </li>\n    </ul>\n  </fieldset>\n\n  <ul *ngIf=\"props.options\" class=\"sds-list sds-list--no-bullets margin-y-0\">\n    <li class=\"grid-row\" *ngIf=\"props.selectAllOption\">\n      <div class=\"usa-checkbox\" [class.text-align-end]=\"props.textAlignEnd\">\n        <input\n          [id]=\"id\"\n          type=\"checkbox\"\n          class=\"usa-checkbox__input\"\n          [name]=\"id + '_name_' + 'Select'\"\n          [value]=\"props.label\"\n          [checked]=\"checkMainOption(id, props.options)\"\n          [attr.aria-checked]=\"mainOptionAriaChecked[getIndex(id)]\"\n          (change)=\"setAll($event)\"\n        />\n        <label class=\"usa-checkbox__label\" [for]=\"id\">\n          <span [innerHtml]=\"props.label\"></span>\n        </label>\n      </div>\n      <div *ngIf=\"props.selectTooltipText\">\n        <ng-template #tipContent1>\n          <p [ngClass]=\"props.tooltipClass\" class=\"margin-1\" [innerHTML]=\"props.selectTooltipText\"></p>\n        </ng-template>\n        <usa-icon\n          class=\"text-secondary\"\n          class=\"margin-left-1\"\n          [position]=\"props.selecttooltipPosition ? props.selecttooltipPosition :'right'\"\n          [sdsTooltip]=\"tipContent1\"\n          [size]=\"'sm'\"\n          [icon]=\"'info-circle'\"\n        ></usa-icon>\n      </div>\n\n      <div *ngIf=\"props.expandableOptions\">\n        <button\n          type=\"button\"\n          class=\"sds-button padding-top-0\"\n          [attr.aria-expanded]=\"!props.expandedOptions\"\n          [attr.aria-controls]=\"id + 'collapseID'\"\n          (click)=\"props.expandedOptions = !props.expandedOptions\"\n        >\n          <span class=\"usa-sr-only\">expand/collapsed</span>\n          <usa-icon [icon]=\"props.expandedOptions ?'caret-down-fill': 'caret-up-fill'\" [size]=\"'1x'\"> </usa-icon>\n        </button>\n      </div>\n    </li>\n    <ng-container *ngFor=\"let option of props.options; let i = index\">\n      <li *ngIf=\"!option.props\" class=\"margin-y-0 grid-row\" [ngClass]=\"{'margin-left-4 ': props.selectAllOption}\">\n        <div class=\"usa-checkbox\" [class.text-align-end]=\"props.textAlignEnd\">\n          <input\n            class=\"usa-checkbox__input\"\n            [id]=\"id + '_' + i\"\n            type=\"checkbox\"\n            [name]=\"id + '_name_' + i\"\n            [disabled]=\"option.disabled\"\n            [value]=\"option.label\"\n            [formlyAttributes]=\"field\"\n            (change)=\"onMainOptionChange(option.value, $event.target.checked, props.options, id)\"\n            [checked]=\"isChecked(option)\"\n          />\n          <label class=\"usa-checkbox__label\" [ngClass]=\"{'margin-top-0': i==0}\" [for]=\"id + '_' + i\">\n            <span\n              *ngIf=\"option.tagText\"\n              class=\"usa-tag\"\n              [ngClass]=\"option.tagClass ? option.tagClass : 'sds-tag--info-white'\"\n            >\n              {{option.tagText}}\n            </span>\n\n            <span [innerHtml]=\"option.label\"></span>\n          </label>\n        </div>\n        <div *ngIf=\"option.tooltipText\" class=\"margin-left-1\">\n          <ng-template #tipContent>\n            <p [ngClass]=\"option.tooltipClass\" class=\"margin-1\" [innerHTML]=\"option.tooltipText\"></p>\n          </ng-template>\n          <usa-icon\n            class=\"text-secondary\"\n            [position]=\"option.tooltipPosition ? option.tooltipPosition :'right'\"\n            [sdsTooltip]=\"tipContent\"\n            [size]=\"'sm'\"\n            [icon]=\"'info-circle'\"\n          ></usa-icon>\n        </div>\n      </li>\n\n      <ng-container *ngIf=\"option.props\">\n        <li class=\"grid-row\" class=\"margin-left-4\">\n          <div class=\"usa-checkbox\" [class.text-align-end]=\"props.textAlignEnd\">\n            <input\n              [id]=\"id + '_' + i\"\n              type=\"checkbox\"\n              class=\"usa-checkbox__input\"\n              [name]=\"id + '_name_' + i\"\n              [value]=\"option.props.label\"\n              [checked]=\"checkSubOption(option.props.options, i)\"\n              [attr.aria-checked]=\"subOptionAriaChecked[i]\"\n              (change)=\"onMainOptionChange(option.value, $event.target.checked, props.options, id)\"\n            />\n            <!-- setAllSubList($event, option, i)\" /> -->\n            <label class=\"usa-checkbox__label\" [for]=\"id + '_' + i\">\n              <span [innerHtml]=\"option.props.label\"></span>\n            </label>\n          </div>\n        </li>\n        <ul\n          [id]=\"'collapseID'\"\n          [sdsCollapse]=\"props.expandedOptions\"\n          [ngClass]=\"{'margin-left-6 ': props.selectAllOption}\"\n        >\n          <li class=\"grid-row\" *ngFor=\"let subOption of (option.props.options); let j = index\">\n            <div class=\"usa-checkbox\" [class.text-align-end]=\"props.textAlignEnd\">\n              <input\n                class=\"usa-checkbox__input\"\n                [id]=\"id + '_' + i + '_' + j\"\n                type=\"checkbox\"\n                [name]=\"id + '_' + i + '_name_' + j\"\n                [disabled]=\"subOption.disabled\"\n                [value]=\"subOption.label\"\n                [formlyAttributes]=\"field\"\n                (change)=\"onSubOptionChange(subOption, $event.target.checked, option.props.options, i)\"\n                [checked]=\"isChecked(subOption)\"\n              />\n              <label class=\"usa-checkbox__label\" [for]=\"id + '_' + i + '_' + j\">\n                <span\n                  *ngIf=\"subOption.tagText\"\n                  class=\"usa-tag\"\n                  [ngClass]=\"subOption.tagClass ? subOption.tagClass : 'sds-tag--info-white'\"\n                >\n                  {{option.tagText}}\n                </span>\n                <span [innerHtml]=\"subOption.label\"></span>\n              </label>\n            </div>\n            <div *ngIf=\"subOption.tooltipText\" class=\"margin-left-1\">\n              <ng-template #tipContent>\n                <p [ngClass]=\"subOption.tooltipClass\" class=\"margin-1\" [innerHTML]=\"subOption.tooltipText\"></p>\n              </ng-template>\n              <usa-icon\n                class=\"text-secondary\"\n                [position]=\"subOption.tooltipPosition ? subOption.tooltipPosition :'right'\"\n                [sdsTooltip]=\"tipContent\"\n                [size]=\"'sm'\"\n                [icon]=\"'info-circle'\"\n              ></usa-icon>\n            </div>\n          </li>\n        </ul>\n      </ng-container>\n    </ng-container>\n  </ul>\n</fieldset>\n" }]
    }], () => [{ type: i0.ChangeDetectorRef }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldMultiCheckboxComponent, { className: "FormlyFieldMultiCheckboxComponent" }); })();

const _c0$l = ["textarea"];
const _c1$5 = (a0, a1, a2) => ({ "sds-textarea-small": a0, "sds-textarea-medium": a1, "sds-textarea-large": a2 });
function FormlyFieldTextAreaComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate3(" ", ctx_r1.charactersRemaining, " ", ctx_r1.charactersRemaining === 1 ? "character" : "characters", " ", ctx_r1.charactersRemaining === ctx_r1.props.maxLength ? "allowed" : "left", " ");
} }
class FormlyFieldTextAreaComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            props: {
                cols: 1,
                rows: 1,
                width: 'small', // default to small if not specified
            },
        };
    }
    ngOnInit() {
        if (!this.props.maxLength) {
            return;
        }
        if (this.props.maxLength) {
            this.textareaRef.nativeElement.setAttribute('maxLength', this.props.maxLength);
        }
        const initialValue = this.field.formControl.value;
        if (!initialValue) {
            this.charactersRemaining = this.props.maxLength;
            return;
        }
        if (initialValue && initialValue.length <= this.props.maxLength) {
            this.charactersRemaining = this.props.maxLength - initialValue.length;
            return;
        }
        // Contains initial value that is over max length limit, so we truncate text to be at max length
        const truncatedValue = initialValue.substring(0, this.props.maxLength);
        this.formControl.setValue(truncatedValue);
        this.charactersRemaining = this.props.maxLength - truncatedValue.length;
    }
    valueChange(value) {
        if (!this.props.maxLength) {
            return;
        }
        if (value != null && value != undefined) {
            if (value.length > this.props.maxLength) {
                const newValue = value.substring(0, this.props.maxLength);
                this.formControl.setValue(newValue);
            }
            else {
                this.charactersRemaining = Math.max(0, this.props.maxLength - value.length);
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldTextAreaComponent_BaseFactory; return function FormlyFieldTextAreaComponent_Factory(t) { return (ɵFormlyFieldTextAreaComponent_BaseFactory || (ɵFormlyFieldTextAreaComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldTextAreaComponent)))(t || FormlyFieldTextAreaComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldTextAreaComponent, selectors: [["sds-formly-field-textarea"]], viewQuery: function FormlyFieldTextAreaComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$l, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textareaRef = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 14, consts: [["textarea", ""], [3, "ngClass"], [1, "usa-textarea", "minw-15", 3, "ngModelChange", "formControl", "cols", "rows", "placeholder", "formlyAttributes"], ["aria-live", "polite", 1, "usa-hint"], [4, "ngIf"]], template: function FormlyFieldTextAreaComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "textarea", 2, 0);
            i0.ɵɵlistener("ngModelChange", function FormlyFieldTextAreaComponent_Template_textarea_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.valueChange($event)); });
            i0.ɵɵtext(3, "      ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵtemplate(5, FormlyFieldTextAreaComponent_span_5_Template, 2, 3, "span", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c1$5, ctx.props.maxLength && ctx.props.size === "small", ctx.props.maxLength && ctx.props.size === "medium", ctx.props.maxLength && ctx.props.size === "large"));
            i0.ɵɵadvance();
            i0.ɵɵclassProp("usa-input--error", ctx.showError);
            i0.ɵɵproperty("formControl", ctx.formControl)("cols", ctx.props.cols)("rows", ctx.props.rows)("placeholder", ctx.props.placeholder)("formlyAttributes", ctx.field);
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("id", ctx.id + "-character-count");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.maxLength);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.FormControlDirective, i3.ɵFormlyAttributes], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldTextAreaComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-textarea',
                template: `
    <div
      [ngClass]="{
        'sds-textarea-small': props.maxLength && props.size === 'small',
        'sds-textarea-medium': props.maxLength && props.size === 'medium',
        'sds-textarea-large': props.maxLength && props.size === 'large'
      }"
    >
      <textarea
        #textarea
        [formControl]="formControl"
        [cols]="props.cols"
        [rows]="props.rows"
        class="usa-textarea minw-15"
        [class.usa-input--error]="showError"
        [placeholder]="props.placeholder"
        [formlyAttributes]="field"
        (ngModelChange)="valueChange($event)"
      >
      </textarea>
      <span [attr.id]="id + '-character-count'" class="usa-hint" aria-live="polite">
        <span *ngIf="props.maxLength">
          {{ charactersRemaining }}
          {{ charactersRemaining === 1 ? 'character' : 'characters' }}
          {{ charactersRemaining === props.maxLength ? 'allowed' : 'left' }}
        </span>
      </span>
    </div>
  `,
            }]
    }], null, { textareaRef: [{
            type: ViewChild,
            args: ['textarea', { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldTextAreaComponent, { className: "FormlyFieldTextAreaComponent" }); })();

class AbstractSdsFormly extends FieldType {
    ngOnInit() {
        this.setProperties(this.template, this.field.props);
    }
    setProperties(component, configuration) {
        Object.keys(configuration).map(function (key) {
            component[key] = configuration[key];
        });
        if (this.template.control) {
            this.template.control = this.formControl;
        }
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵAbstractSdsFormly_BaseFactory; return function AbstractSdsFormly_Factory(t) { return (ɵAbstractSdsFormly_BaseFactory || (ɵAbstractSdsFormly_BaseFactory = i0.ɵɵgetInheritedFactory(AbstractSdsFormly)))(t || AbstractSdsFormly); }; })(); }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: AbstractSdsFormly, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbstractSdsFormly, [{
        type: Directive
    }], null, null); })();

class FormlyFieldAutoCompleteComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super(); /* istanbul ignore next */
        this.defaultOptions = {
            props: {
                essentialModelFields: true,
            },
        };
        this.cdr = _cdr;
    }
    ngAfterViewInit() {
        if (this.template.configuration.id !== undefined && this.template.configuration.id !== this.id) {
            console.warn(`Formly Autocomplete ID mismatch: Formly Autocomplete ID(${this.id}) does not match Autocomplete Configuration ID (${this.template.configuration.id})`);
        }
        if (!this.template.configuration.id) {
            this.template.configuration.id = this.id;
        }
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldAutoCompleteComponent_Factory(t) { return new (t || FormlyFieldAutoCompleteComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldAutoCompleteComponent, selectors: [["sds-formly-field-autocomplete"]], viewQuery: function FormlyFieldAutoCompleteComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(SDSAutocompleteComponent, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formControl"]], template: function FormlyFieldAutoCompleteComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "sds-autocomplete", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl);
        } }, dependencies: [i2$3.SDSAutocompleteComponent, i2$2.NgControlStatus, i2$2.FormControlDirective], encapsulation: 2, changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldAutoCompleteComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-autocomplete',
                template: ` <sds-autocomplete [formControl]="formControl"></sds-autocomplete> `,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], () => [{ type: i0.ChangeDetectorRef }], { template: [{
            type: ViewChild,
            args: [SDSAutocompleteComponent, { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldAutoCompleteComponent, { className: "FormlyFieldAutoCompleteComponent" }); })();

class FormlyFieldDatePickerComponent extends FieldType {
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldDatePickerComponent_BaseFactory; return function FormlyFieldDatePickerComponent_Factory(t) { return (ɵFormlyFieldDatePickerComponent_BaseFactory || (ɵFormlyFieldDatePickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldDatePickerComponent)))(t || FormlyFieldDatePickerComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldDatePickerComponent, selectors: [["sds-formly-field-datepicker"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 14, consts: [["picker", ""], [1, "display-flex"], ["matInput", "", 1, "usa-input", "display-inline-block", "margin-top-3", 3, "ngModelChange", "id", "formControl", "formlyAttributes", "min", "max", "matDatepicker", "placeholder"], ["matSuffix", "", 1, "padding-left-1", "padding-top-2", 3, "for"], ["matDatepickerToggleIcon", "", 3, "icon", "size"], [3, "startAt"]], template: function FormlyFieldDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "input", 2);
            i0.ɵɵlistener("ngModelChange", function FormlyFieldDatePickerComponent_Template_input_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.props.change ? ctx.props.change(ctx.field) : ""); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "mat-datepicker-toggle", 3);
            i0.ɵɵelement(3, "usa-icon", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "mat-datepicker", 5, 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const picker_r2 = i0.ɵɵreference(5);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("usa-input--error", ctx.showError);
            i0.ɵɵproperty("id", ctx.id)("formControl", ctx.formControl)("formlyAttributes", ctx.field)("min", ctx.props.minDate)("max", ctx.props.maxDate)("matDatepicker", picker_r2)("placeholder", ctx.props.placeholder ? ctx.props.placeholder : "");
            i0.ɵɵattribute("aria-describedby", ctx.props.description ? ctx.id + "-description" : undefined);
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", picker_r2);
            i0.ɵɵadvance();
            i0.ɵɵproperty("icon", "calendar")("size", "sm");
            i0.ɵɵadvance();
            i0.ɵɵproperty("startAt", ctx.props.startDate);
        } }, dependencies: [i2$4.MatDatepicker, i2$4.MatDatepickerInput, i2$4.MatDatepickerToggle, i2$4.MatDatepickerToggleIcon, i2$5.MatInput, i3$1.MatSuffix, i2$1.IconComponent, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.FormControlDirective, i3.ɵFormlyAttributes], styles: ["table.mat-calendar-table td,table.mat-calendar-table th{border-style:none;background-color:unset}\n"], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldDatePickerComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-field-datepicker', template: `
    <div class="display-flex">
      <input
        [id]="id"
        class="usa-input display-inline-block margin-top-3"
        [class.usa-input--error]="showError"
        [formControl]="formControl"
        [formlyAttributes]="field"
        matInput
        [min]="props.minDate"
        [max]="props.maxDate"
        [matDatepicker]="picker"
        [placeholder]="props.placeholder ? props.placeholder : ''"
        [attr.aria-describedby]="props.description ? id + '-description' : undefined"
        (ngModelChange)="props.change ? props.change(field) : ''"
      />
      <mat-datepicker-toggle class="padding-left-1 padding-top-2" matSuffix [for]="picker">
        <usa-icon [icon]="'calendar'" matDatepickerToggleIcon [size]="'sm'"></usa-icon>
      </mat-datepicker-toggle>
      <mat-datepicker [startAt]="props.startDate" #picker></mat-datepicker>
    </div>
  `, encapsulation: ViewEncapsulation.None, styles: ["table.mat-calendar-table td,table.mat-calendar-table th{border-style:none;background-color:unset}\n"] }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldDatePickerComponent, { className: "FormlyFieldDatePickerComponent" }); })();

function FormlyFieldButtonComponent_button_0_usa_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "usa-icon", 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", ctx_r1.props.btnIcon)("size", "s");
} }
function FormlyFieldButtonComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function FormlyFieldButtonComponent_button_0_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onClick($event)); });
    i0.ɵɵtemplate(1, FormlyFieldButtonComponent_button_0_usa_icon_1_Template, 1, 2, "usa-icon", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.props.btnClass);
    i0.ɵɵattribute("aria-label", ctx_r1.props.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.props.btnIcon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.props.text, " ");
} }
function FormlyFieldButtonComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "formly-field", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("field", ctx_r1.additionalField);
} }
class FormlyFieldButtonComponent extends FieldType {
    constructor(formBuilder) {
        super();
        this.formBuilder = formBuilder;
        this.additionalField = null;
        this.hideButton = false;
    }
    ngOnInit() {
        if (this.props.additionalField && this.model[this.props.additionalField.key] && this.props.enableInput) {
            this.hideButton = true;
            this.additionalField = this.props.additionalField;
            this.formBuilder.buildForm(this.form, [this.additionalField], this.model, this.options);
        }
    }
    onClick($event) {
        if (this.props.enableInput) {
            if (this.additionalField) {
                return;
            }
            this.additionalField = this.props.additionalField;
            this.hideButton = true;
            this.formBuilder.buildForm(this.form, [this.additionalField], this.model, this.options);
        }
        if (this.props.onClick) {
            this.props.onClick($event);
        }
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldButtonComponent_Factory(t) { return new (t || FormlyFieldButtonComponent)(i0.ɵɵdirectiveInject(i3.FormlyFormBuilder)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldButtonComponent, selectors: [["sds-formly-field-button"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "usa-button", 3, "ngClass", "click", 4, "ngIf"], [4, "ngIf"], [1, "usa-button", 3, "click", "ngClass"], [3, "icon", "size", 4, "ngIf"], [3, "icon", "size"], [1, "margin-top-0", 3, "field"]], template: function FormlyFieldButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FormlyFieldButtonComponent_button_0_Template, 3, 4, "button", 0)(1, FormlyFieldButtonComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.hideButton && !ctx.additionalField);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.additionalField);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.IconComponent, i3.FormlyField], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldButtonComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-button',
                template: `
    <button
      *ngIf="!hideButton && !additionalField"
      class="usa-button"
      [ngClass]="props.btnClass"
      (click)="onClick($event)"
      [attr.aria-label]="props.text"
    >
      <usa-icon *ngIf="props.btnIcon" [icon]="props.btnIcon" [size]="'s'"></usa-icon>
      {{ props.text }}
    </button>

    <ng-container *ngIf="additionalField">
      <formly-field class="margin-top-0" [field]="additionalField"></formly-field>
    </ng-container>
  `,
            }]
    }], () => [{ type: i3.FormlyFormBuilder }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldButtonComponent, { className: "FormlyFieldButtonComponent" }); })();

class FormlyFieldTextComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super(); /* istanbul ignore next */
        this.cdr = _cdr;
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldTextComponent_Factory(t) { return new (t || FormlyFieldTextComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldTextComponent, selectors: [["sds-formly-field-text"]], viewQuery: function FormlyFieldTextComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(SdsTextComponent, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formControl"]], template: function FormlyFieldTextComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "sds-text", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl);
        } }, dependencies: [i2$3.SdsTextComponent, i2$2.NgControlStatus, i2$2.FormControlDirective], encapsulation: 2, changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldTextComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-text',
                template: ` <sds-text [formControl]="formControl"></sds-text> `,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], () => [{ type: i0.ChangeDetectorRef }], { template: [{
            type: ViewChild,
            args: [SdsTextComponent, { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldTextComponent, { className: "FormlyFieldTextComponent" }); })();

/**
 *
 * @param control
 * @param field
 */
function minDateValidator(control, field) {
    let toReturn = null;
    let minDateField = field.props.minDate;
    let value = control.value;
    if (value && minDateField) {
        if (value instanceof Date && minDateField instanceof Date) {
            minDateField.setHours(0, 0, 0, 0);
            if (value.getTime() < minDateField.getTime() && value.getTime() === minDateField.getTime()) {
                if (!field.props.maxDate && !(field.props.maxDate instanceof Date)) {
                    toReturn = {
                        minDate: true,
                    };
                }
                else {
                    toReturn = {
                        betweenDate: true,
                    };
                }
            }
        }
    }
    return toReturn;
}
/**
 * Usage:
 *  Override the required validator to allow autocompletes to behave more like
 *  the other inputs regarding error messages
 *
 // In the formly config
 {
      type: 'autocomplete',
      props: {
        required: true,
      },
      validators: {
        required: autocompleteRequired
      },
 */
function autocompleteRequired(control) {
    return control.value && control.value.items && control.value.length ? { required: true } : null;
}
/**
 * Usage:
 *  Override the required validator to allow multicheckbox to behave more like required atleast one item is selected
 *  the other inputs regarding error messages
 *
 In the formly config
 {
      type: 'multicheckbox',
      props: {
        required: true,
      },
      validators: {
        required: multiCheckboxRequired
      },
 */
function multiCheckboxRequired(control) {
    const hasTrueKeys = Object.keys(control.value).some((k) => control.value[k]);
    return hasTrueKeys ? { required: true } : null;
}
/**
 *
 * @param control
 * @param field
 */
function maxDateValidator(control, field) {
    let toReturn = null;
    let maxDateField = field.props.maxDate;
    let value = control.value;
    if (value && maxDateField) {
        if (value instanceof Date && maxDateField instanceof Date) {
            maxDateField.setHours(0, 0, 0, 0);
            if (value.getTime() > maxDateField.getTime() && value.getTime() === maxDateField.getTime()) {
                if (!field.props.minDate && !(field.props.minDate instanceof Date)) {
                    toReturn = {
                        maxDate: true,
                    };
                }
                else {
                    toReturn = {
                        betweenDate: true,
                    };
                }
            }
        }
    }
    return toReturn;
}
function dateRangeValidator(control, field) {
    if (field.formControl.invalid && field.formControl.errors) {
        return field.formControl.errors;
    }
    const innerFieldGroup = field.fieldGroup.find((field) => field.formControl.invalid && field.formControl.errors);
    if (!innerFieldGroup) {
        return null;
    }
    return innerFieldGroup.formControl.errors;
}

let sdsFieldWrapper = ['readonly', 'label', 'description', 'validation'];
let sdsGroupWrapper = ['group'];
let sdsWrappers = [...sdsGroupWrapper, ...sdsFieldWrapper];

const _c0$k = ["fieldComponent"];
const _c1$4 = (a0, a1) => ({ "{{props.labelContentClass}}": a0, "single-form-control": a1 });
const _c2$4 = (a0, a1) => ({ "margin-bottom-1": a0, "usa-sr-only": a1 });
function FormlyLabelWrapperComponent_label_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.props.tagClass ? ctx_r0.props.tagClass : "sds-tag--info-white");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.props.tagText);
} }
function FormlyLabelWrapperComponent_label_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.props.labelTemplate);
} }
function FormlyLabelWrapperComponent_label_1_ng_container_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, " (Optional)");
    i0.ɵɵelementEnd();
} }
function FormlyLabelWrapperComponent_label_1_ng_container_3_span_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 16);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r0.props.tooltipClass)("innerHTML", ctx_r0.props.tooltipText, i0.ɵɵsanitizeHtml);
} }
function FormlyLabelWrapperComponent_label_1_ng_container_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtemplate(1, FormlyLabelWrapperComponent_label_1_ng_container_3_span_4_ng_template_1_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "usa-icon", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tipContent_r2 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("position", ctx_r0.props.tooltipPosition ? ctx_r0.props.tooltipPosition : "right")("sdsTooltip", tipContent_r2)("size", "lg")("icon", "info-circle");
} }
function FormlyLabelWrapperComponent_label_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FormlyLabelWrapperComponent_label_1_ng_container_3_span_3_Template, 2, 0, "span", 11)(4, FormlyLabelWrapperComponent_label_1_ng_container_3_span_4_Template, 4, 4, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("class", ctx_r0.props.labelClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.props.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.props.required && !ctx_r0.props.hideOptional);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.props.tooltipText && ctx_r0.field.type !== "checkbox");
} }
function FormlyLabelWrapperComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtemplate(1, FormlyLabelWrapperComponent_label_1_span_1_Template, 2, 2, "span", 6)(2, FormlyLabelWrapperComponent_label_1_ng_container_2_Template, 1, 1, "ng-container", 7)(3, FormlyLabelWrapperComponent_label_1_ng_container_3_Template, 5, 4, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c2$4, (ctx_r0.field == null ? null : ctx_r0.field.props == null ? null : ctx_r0.field.props.label) && !(ctx_r0.field == null ? null : ctx_r0.field.props == null ? null : ctx_r0.field.props.hideLabel) && (ctx_r0.field == null ? null : ctx_r0.field.parent == null ? null : ctx_r0.field.parent.fieldGroup == null ? null : ctx_r0.field.parent.fieldGroup.length) === 1, ctx_r0.props.hideLabel || (ctx_r0.props.group === "panel" || ctx_r0.props.group === "accordion") && (ctx_r0.field == null ? null : ctx_r0.field.parent == null ? null : ctx_r0.field.parent.type) !== "formly-group"));
    i0.ɵɵattribute("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.props.tagText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.props.labelTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.props.labelTemplate);
} }
/**
 * @param string [props.tagClass] Class to be added to the tag (default: sds-tag--info-white)
 * @param string [props.tagText] Text to be shown inside the tag
 * @param string [props.label] Text to be shown for the label
 * @param string [props.required] Makes the field required
 * @param string [props.hideOptional] Remove the optional text
 *
 */
class FormlyLabelWrapperComponent extends FieldWrapper {
    hasLabel() {
        if (this.props.hideLabel) {
            return false;
        }
        if (this.props.label) {
            if (!(this.field.type === 'checkbox' || this.field.type === 'multicheckbox')) {
                return true;
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyLabelWrapperComponent_BaseFactory; return function FormlyLabelWrapperComponent_Factory(t) { return (ɵFormlyLabelWrapperComponent_BaseFactory || (ɵFormlyLabelWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyLabelWrapperComponent)))(t || FormlyLabelWrapperComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyLabelWrapperComponent, selectors: [["ng-component"]], viewQuery: function FormlyLabelWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$k, 5, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 7, consts: [["fieldComponent", ""], ["tipContent", ""], [1, "usa-form-group"], ["class", "usa-label", 3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "usa-label", 3, "ngClass"], ["class", "usa-tag", 3, "ngClass", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], [4, "ngIf"], [1, "usa-tag", 3, "ngClass"], [3, "ngTemplateOutlet"], ["class", "text-normal", 4, "ngIf"], ["class", "margin-left-1", 4, "ngIf"], [1, "text-normal"], [1, "margin-left-1"], [1, "text-secondary", 3, "position", "sdsTooltip", "size", "icon"], [1, "margin-1", 3, "ngClass", "innerHTML"]], template: function FormlyLabelWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, FormlyLabelWrapperComponent_label_1_Template, 4, 8, "label", 3);
            i0.ɵɵelementStart(2, "div", 4);
            i0.ɵɵelementContainer(3, null, 0);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassProp("usa-form-group--error", ctx.showError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hasLabel());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c1$4, ctx.props.labelContentClass, (ctx.props.group === "panel" || ctx.props.group === "accordion") && (ctx.field == null ? null : ctx.field.parent == null ? null : ctx.field.parent.type) !== "formly-group"));
        } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2$1.IconComponent, i2$3.SdsTooltip], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyLabelWrapperComponent, [{
        type: Component,
        args: [{
                template: `
    <div class="usa-form-group" [class.usa-form-group--error]="showError">
      <label
        class="usa-label"
        *ngIf="hasLabel()"
        [attr.for]="id"
        [ngClass]="{
          'margin-bottom-1':
            this.field?.props?.label && !this.field?.props?.hideLabel && this.field?.parent?.fieldGroup?.length === 1,
          'usa-sr-only':
            props.hideLabel ||
            ((props.group === 'panel' || props.group === 'accordion') && field?.parent?.type !== 'formly-group')
        }"
      >
        <span
          *ngIf="props.tagText"
          class="usa-tag"
          [ngClass]="props.tagClass ? props.tagClass : 'sds-tag--info-white'"
          >{{ props.tagText }}</span
        >

        <ng-container *ngIf="props.labelTemplate" [ngTemplateOutlet]="props.labelTemplate"> </ng-container>
        <ng-container *ngIf="!props.labelTemplate">
          <span [attr.class]="props.labelClass"
            >{{ props.label
            }}<span class="text-normal" *ngIf="!props.required && !props.hideOptional"> (Optional)</span>
            <span *ngIf="props.tooltipText && field.type !== 'checkbox'" class="margin-left-1">
              <ng-template #tipContent>
                <p [ngClass]="props.tooltipClass" class="margin-1" [innerHTML]="props.tooltipText"></p>
              </ng-template>
              <usa-icon
                class="text-secondary"
                [position]="props.tooltipPosition ? props.tooltipPosition : 'right'"
                [sdsTooltip]="tipContent"
                [size]="'lg'"
                [icon]="'info-circle'"
              ></usa-icon>
            </span>
          </span>
        </ng-container>
      </label>

      <div
        [ngClass]="{
'{{props.labelContentClass}}': props.labelContentClass,
         'single-form-control':
              ((props.group === 'panel' || props.group === 'accordion') && field?.parent?.type !== 'formly-group')
          }"
      >
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyLabelWrapperComponent, { className: "FormlyLabelWrapperComponent" }); })();

const _c0$j = ["fieldComponent"];
function FormlyDescriptionWrapperComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.props.descriptionTemplate);
} }
function FormlyDescriptionWrapperComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.id + "-description")("innerHtml", ctx_r0.props.description, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", ctx_r0.props.description ? ctx_r0.props.description : undefined)("aria-label", ctx_r0.props.description);
} }
function FormlyDescriptionWrapperComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormlyDescriptionWrapperComponent_ng_container_2_div_1_Template, 1, 4, "div", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.props.description);
} }
/**
 * @param string [props.description] Add a description below the label
 *
 */
class FormlyDescriptionWrapperComponent extends FieldWrapper {
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyDescriptionWrapperComponent_BaseFactory; return function FormlyDescriptionWrapperComponent_Factory(t) { return (ɵFormlyDescriptionWrapperComponent_BaseFactory || (ɵFormlyDescriptionWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyDescriptionWrapperComponent)))(t || FormlyDescriptionWrapperComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyDescriptionWrapperComponent, selectors: [["ng-component"]], viewQuery: function FormlyDescriptionWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$j, 5, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [["fieldComponent", ""], [3, "ngTemplateOutlet", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet"], ["class", "usa-label--description", 3, "id", "innerHtml", 4, "ngIf"], [1, "usa-label--description", 3, "id", "innerHtml"]], template: function FormlyDescriptionWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, FormlyDescriptionWrapperComponent_ng_container_1_Template, 1, 1, "ng-container", 1)(2, FormlyDescriptionWrapperComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵelementContainer(3, null, 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.props.descriptionTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.props.descriptionTemplate);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyDescriptionWrapperComponent, [{
        type: Component,
        args: [{
                template: `
    <div>
      <ng-container *ngIf="props.descriptionTemplate" [ngTemplateOutlet]="props.descriptionTemplate"> </ng-container>
      <ng-container *ngIf="!props.descriptionTemplate">
        <div
          *ngIf="props.description"
          [attr.aria-label]="props.description ? props.description : undefined"
          class="usa-label--description"
          [attr.aria-label]="props.description"
          [id]="id + '-description'"
          [innerHtml]="props.description"
        ></div>
      </ng-container>
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyDescriptionWrapperComponent, { className: "FormlyDescriptionWrapperComponent" }); })();

const _c0$i = ["fieldComponent"];
function FormlyValidationWrapperComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "formly-validation-message", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("display", "block");
    i0.ɵɵproperty("id", ctx_r0.id + "-error-message");
    i0.ɵɵadvance();
    i0.ɵɵproperty("field", ctx_r0.field);
} }
/**
 * @param string [props.required] Makes the field required
 */
class FormlyValidationWrapperComponent extends FieldWrapper {
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyValidationWrapperComponent_BaseFactory; return function FormlyValidationWrapperComponent_Factory(t) { return (ɵFormlyValidationWrapperComponent_BaseFactory || (ɵFormlyValidationWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyValidationWrapperComponent)))(t || FormlyValidationWrapperComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyValidationWrapperComponent, selectors: [["ng-component"]], viewQuery: function FormlyValidationWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$i, 5, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["fieldComponent", ""], ["class", "usa-error-message", "role", "alert", "aria-live", "assertive", 3, "id", "display", 4, "ngIf"], ["role", "alert", "aria-live", "assertive", 1, "usa-error-message", 3, "id"], [3, "field"]], template: function FormlyValidationWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
            i0.ɵɵtemplate(2, FormlyValidationWrapperComponent_div_2_Template, 2, 4, "div", 1);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showError);
        } }, dependencies: [i1.NgIf, i3.ɵFormlyValidationMessage], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyValidationWrapperComponent, [{
        type: Component,
        args: [{
                template: `
    <ng-container #fieldComponent></ng-container>
    <div
      *ngIf="showError"
      class="usa-error-message"
      role="alert"
      [id]="id + '-error-message'"
      aria-live="assertive"
      [style.display]="'block'"
    >
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  `,
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyValidationWrapperComponent, { className: "FormlyValidationWrapperComponent" }); })();

const _c0$h = ["fieldComponent"];
const _c1$3 = ["groupAccordion"];
const _c2$3 = a0 => ({ "sds-panel--multiple": a0 });
function FormlyGroupWrapperComponent_ng_container_0_ng_container_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("class", ctx_r0.props.labelClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.props.label);
} }
function FormlyGroupWrapperComponent_ng_container_0_ng_container_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 2);
} }
function FormlyGroupWrapperComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "usa-accordion", 7, 1)(3, "usa-accordion-item", 8);
    i0.ɵɵtemplate(4, FormlyGroupWrapperComponent_ng_container_0_ng_container_2_ng_template_4_Template, 2, 2, "ng-template", 9)(5, FormlyGroupWrapperComponent_ng_container_0_ng_container_2_ng_template_5_Template, 2, 0, "ng-template", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("singleSelect", !ctx_r0.multi);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("expanded", ctx_r0.modelHasValue());
} }
function FormlyGroupWrapperComponent_ng_container_0_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-hidden", !ctx_r0.props.announceLabel ? undefined : "true");
    i0.ɵɵadvance();
    i0.ɵɵattribute("class", ctx_r0.props.labelClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.props.label);
} }
function FormlyGroupWrapperComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵtemplate(2, FormlyGroupWrapperComponent_ng_container_0_ng_container_3_div_2_Template, 3, 3, "div", 12);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementContainer(4, null, 2);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2$3, ctx_r0.field == null ? null : ctx_r0.field.fieldGroup == null ? null : ctx_r0.field.fieldGroup.length));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.props.hideLabel);
} }
function FormlyGroupWrapperComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, null, 2);
    i0.ɵɵelementContainerEnd();
} }
function FormlyGroupWrapperComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 4);
    i0.ɵɵtemplate(2, FormlyGroupWrapperComponent_ng_container_0_ng_container_2_Template, 6, 2, "ng-container", 5)(3, FormlyGroupWrapperComponent_ng_container_0_ng_container_3_Template, 6, 4, "ng-container", 5)(4, FormlyGroupWrapperComponent_ng_container_0_ng_container_4_Template, 3, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r0.props.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "accordion");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "panel");
} }
function FormlyGroupWrapperComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 2);
} }
/**
 * @param string [props.group] used to set the wrapper tupe
 * @param string [props.announceLabel] For screenreader
 * @param string [props.label] Text to be shown for the label
 * @param string [props.hideLabel] Hide the label
 *
 */
class FormlyGroupWrapperComponent extends FieldWrapper {
    constructor() {
        super();
        this.multi = true;
    }
    ngAfterViewInit() {
        if (this.props.group === 'accordion' || this.props.group === 'panel' || this.field.fieldGroup) {
            this.field.className = this.field.className ? this.field.className : 'margin-top-0';
        }
        if (this.props.group != 'accordion' || !this.accordion) {
            return;
        }
        this.resetAllSubscription = this.field.options?.fieldChanges?.subscribe(({ type }) => {
            if (type === 'resetAll' && this.accordionItem.expanded && !this.modelHasValue()) {
                this.accordion.collapse(this.accordionItem.id);
            }
        });
    }
    ngOnDestroy() {
        if (this.resetAllSubscription) {
            this.resetAllSubscription.unsubscribe();
        }
    }
    modelHasValue() {
        if (this.props.hasOwnProperty('expand')) {
            return this.props.expand;
        }
        else {
            const hasValue = this.formControl.value instanceof Object
                ? qs.stringify(this.formControl.value, { skipNulls: true })
                : this.formControl.value;
            return hasValue || this.formControl.dirty ? true : false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyGroupWrapperComponent_Factory(t) { return new (t || FormlyGroupWrapperComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyGroupWrapperComponent, selectors: [["ng-component"]], viewQuery: function FormlyGroupWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$h, 5, ViewContainerRef);
            i0.ɵɵviewQuery(_c1$3, 5);
            i0.ɵɵviewQuery(UsaAccordionItem, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionItem = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["defaultTemplate", ""], ["groupAccordion", ""], ["fieldComponent", ""], [4, "ngIf", "ngIfElse"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "sds-accordion--filters", 3, "singleSelect"], [3, "expanded"], ["UsaAccordionHeader", ""], ["UsaAccordionContent", ""], [1, "sds-panel", 3, "ngClass"], ["class", "sds-panel__header padding-top-1", 4, "ngIf"], [1, "sds-panel__body"], [1, "sds-panel__header", "padding-top-1"]], template: function FormlyGroupWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FormlyGroupWrapperComponent_ng_container_0_Template, 5, 3, "ng-container", 3)(1, FormlyGroupWrapperComponent_ng_template_1_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultTemplate_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.props.readonlyMode)("ngIfElse", defaultTemplate_r2);
        } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault, i2.UsaAccordionComponent, i2.UsaAccordionHeader, i2.UsaAccordionContent, i2.UsaAccordionItem], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyGroupWrapperComponent, [{
        type: Component,
        args: [{
                template: `
    <ng-container *ngIf="!props.readonlyMode; else defaultTemplate">
      <ng-container [ngSwitch]="props.group">
        <ng-container *ngSwitchCase="'accordion'">
          <usa-accordion #groupAccordion [singleSelect]="!multi" class="sds-accordion--filters">
            <usa-accordion-item [expanded]="modelHasValue()">
              <ng-template UsaAccordionHeader>
                <span [attr.class]="props.labelClass">{{ props.label }}</span>
              </ng-template>
              <ng-template UsaAccordionContent>
                <ng-container #fieldComponent></ng-container>
              </ng-template>
            </usa-accordion-item>
          </usa-accordion>
        </ng-container>
        <ng-container *ngSwitchCase="'panel'">
          <div class="sds-panel" [ngClass]="{ 'sds-panel--multiple': field?.fieldGroup?.length }">
            <div
              class="sds-panel__header padding-top-1"
              *ngIf="!props.hideLabel"
              [attr.aria-hidden]="!props.announceLabel ? undefined : 'true'"
            >
              <span [attr.class]="props.labelClass">{{ props.label }}</span>
            </div>
            <div class="sds-panel__body">
              <ng-container #fieldComponent></ng-container>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container #fieldComponent></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #defaultTemplate>
      <ng-container #fieldComponent></ng-container>
    </ng-template>
  `,
            }]
    }], () => [], { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }], accordion: [{
            type: ViewChild,
            args: ['groupAccordion']
        }], accordionItem: [{
            type: ViewChild,
            args: [UsaAccordionItem]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyGroupWrapperComponent, { className: "FormlyGroupWrapperComponent" }); })();

class FormlyFieldSearchComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super();
        this.cdr = _cdr;
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldSearchComponent_Factory(t) { return new (t || FormlyFieldSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldSearchComponent, selectors: [["sds-formly-field-search"]], viewQuery: function FormlyFieldSearchComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(SdsSearchComponent, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "submit", "formControl"]], template: function FormlyFieldSearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "sds-search", 0);
            i0.ɵɵlistener("submit", function FormlyFieldSearchComponent_Template_sds_search_submit_0_listener($event) { return ctx.props.submitHandler && ctx.props.submitHandler($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl);
        } }, dependencies: [i2$3.SdsSearchComponent, i2$2.NgControlStatus, i2$2.FormControlDirective], encapsulation: 2, changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldSearchComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-search',
                template: `
    <sds-search [formControl]="formControl" (submit)="props.submitHandler && props.submitHandler($event)"></sds-search>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], () => [{ type: i0.ChangeDetectorRef }], { template: [{
            type: ViewChild,
            args: [SdsSearchComponent, { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldSearchComponent, { className: "FormlyFieldSearchComponent" }); })();

const _c0$g = a0 => ({ "sds-card-selected": a0 });
function FormlyFieldFileInfoComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 2);
    i0.ɵɵlistener("keyup.enter", function FormlyFieldFileInfoComponent_div_1_Template_div_keyup_enter_1_listener() { const option_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.formControl.setValue(option_r2.value)); });
    i0.ɵɵelement(2, "input", 3);
    i0.ɵɵelementStart(3, "label", 4)(4, "div", 5)(5, "h3", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 7)(8, "span", 8);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0$g, ctx_r2.formControl.value == option_r2.value));
    i0.ɵɵattribute("aria-label", option_r2.label + " " + option_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("usa-input--error", ctx_r2.showError);
    i0.ɵɵproperty("id", ctx_r2.id + "_" + i_r4)("name", ctx_r2.id)("value", option_r2.value)("formControl", ctx_r2.formControl)("formlyAttributes", ctx_r2.field);
    i0.ɵɵattribute("value", option_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r2.id + "_" + i_r4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r2.label);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r2.value);
} }
class FormlyFieldFileInfoComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.isSelected = false;
        this.description = '';
        this.defaultOptions = {
            props: {
                options: [],
            },
        };
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldFileInfoComponent_BaseFactory; return function FormlyFieldFileInfoComponent_Factory(t) { return (ɵFormlyFieldFileInfoComponent_BaseFactory || (ɵFormlyFieldFileInfoComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldFileInfoComponent)))(t || FormlyFieldFileInfoComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldFileInfoComponent, selectors: [["sds-formly-field-file"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 6, consts: [[1, "grid-row", "grid-gap", "margin-top-1"], [4, "ngFor", "ngForOf"], ["role", "radio", "aria-checked", "false", "tabindex", "0", 1, "sds-card", "mobile-lg:grid-col", 3, "keyup.enter", "ngClass"], ["tabindex", "-1", "type", "radio", 1, "usa-sr-only", "usa-radio__input", 3, "id", "name", "value", "formControl", "formlyAttributes"], [3, "for"], [1, "sds-card__header", "sds-card__header--center"], [1, "sds-card__title"], [1, "sds-card__body", "sds-card__header--center"], [1, "bg-base-light", "padding-1", "padding-left-2", "padding-right-2"]], template: function FormlyFieldFileInfoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FormlyFieldFileInfoComponent_div_1_Template, 10, 15, "div", 1);
            i0.ɵɵpipe(2, "formlySelectOptions");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 4, i0.ɵɵpipeBind2(2, 1, ctx.props.options, ctx.field)));
        } }, dependencies: [i1.NgClass, i1.NgForOf, i2$2.DefaultValueAccessor, i2$2.RadioControlValueAccessor, i2$2.NgControlStatus, i2$2.FormControlDirective, i3.ɵFormlyAttributes, i1.AsyncPipe, i4.FormlySelectOptionsPipe], styles: [".sds-card-selected[_ngcontent-%COMP%]{border-color:#2672de!important;border-width:2px!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldFileInfoComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-field-file', template: `
    <div class="grid-row grid-gap margin-top-1">
      <div *ngFor="let option of props.options | formlySelectOptions: field | async; let i = index">
        <div
          role="radio"
          aria-checked="false"
          class="sds-card mobile-lg:grid-col"
          [ngClass]="{ 'sds-card-selected': formControl.value == option.value }"
          tabindex="0"
          (keyup.enter)="formControl.setValue(option.value)"
          [attr.aria-label]="option.label + ' ' + option.value"
        >
          <input
            tabindex="-1"
            type="radio"
            [id]="id + '_' + i"
            class="usa-sr-only usa-radio__input"
            [name]="id"
            [class.usa-input--error]="showError"
            [attr.value]="option.value"
            [value]="option.value"
            [formControl]="formControl"
            [formlyAttributes]="field"
          />
          <label [for]="id + '_' + i">
            <div class="sds-card__header sds-card__header--center">
              <h3 class="sds-card__title ">{{ option.label }}</h3>
            </div>
            <div class="sds-card__body sds-card__header--center ">
              <span class="bg-base-light padding-1 padding-left-2 padding-right-2">{{ option.value }}</span>
            </div>
          </label>
        </div>
      </div>
    </div>
  `, styles: [".sds-card-selected{border-color:#2672de!important;border-width:2px!important}\n"] }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldFileInfoComponent, { className: "FormlyFieldFileInfoComponent" }); })();

function FormlyFieldDateRangePickerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "mat-date-range-input", 3)(2, "input", 4);
    i0.ɵɵlistener("ngModelChange", function FormlyFieldDateRangePickerComponent_div_0_Template_input_ngModelChange_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView((ctx_r1.field.fieldGroup[0] == null ? null : ctx_r1.field.fieldGroup[0].props == null ? null : ctx_r1.field.fieldGroup[0].props.change) ? ctx_r1.field.fieldGroup[0].props.change(ctx_r1.field.fieldGroup[0]) : ""); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 5);
    i0.ɵɵlistener("ngModelChange", function FormlyFieldDateRangePickerComponent_div_0_Template_input_ngModelChange_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView((ctx_r1.field.fieldGroup[1] == null ? null : ctx_r1.field.fieldGroup[1].props == null ? null : ctx_r1.field.fieldGroup[1].props.change) ? ctx_r1.field.fieldGroup[1].props.change(ctx_r1.field.fieldGroup[1]) : ""); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-datepicker-toggle", 6);
    i0.ɵɵelement(5, "usa-icon", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-date-range-picker", 8, 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const picker_r3 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("usa-input--error", ctx_r1.showError);
    i0.ɵɵproperty("formGroup", ctx_r1.formControl)("rangePicker", picker_r3)("min", ctx_r1.props.minDate)("max", ctx_r1.props.maxDate)("id", ctx_r1.id)("formlyAttributes", ctx_r1.field);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formlyAttributes", ctx_r1.field.fieldGroup[0])("placeholder", (ctx_r1.field.fieldGroup[0] == null ? null : ctx_r1.field.fieldGroup[0].props == null ? null : ctx_r1.field.fieldGroup[0].props.placeholder) || "mmm-dd-yyyy")("formControlName", ctx_r1.field.fieldGroup[0].key);
    i0.ɵɵattribute("aria-label", (ctx_r1.field.fieldGroup[0] == null ? null : ctx_r1.field.fieldGroup[0].props == null ? null : ctx_r1.field.fieldGroup[0].props.placeholder) || "Start Date");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formlyAttributes", ctx_r1.field.fieldGroup[1])("placeholder", (ctx_r1.field.fieldGroup[1] == null ? null : ctx_r1.field.fieldGroup[1].props == null ? null : ctx_r1.field.fieldGroup[1].props.placeholder) || "mmm-dd-yyyy")("formControlName", ctx_r1.field.fieldGroup[1].key);
    i0.ɵɵattribute("aria-label", (ctx_r1.field.fieldGroup[1] == null ? null : ctx_r1.field.fieldGroup[1].props == null ? null : ctx_r1.field.fieldGroup[1].props.placeholder) || "End Date");
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", picker_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "calendar")("size", "sm");
    i0.ɵɵadvance();
    i0.ɵɵproperty("startAt", ctx_r1.to.startDate);
} }
class FormlyFieldDateRangePickerComponent extends FieldType {
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldDateRangePickerComponent_BaseFactory; return function FormlyFieldDateRangePickerComponent_Factory(t) { return (ɵFormlyFieldDateRangePickerComponent_BaseFactory || (ɵFormlyFieldDateRangePickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldDateRangePickerComponent)))(t || FormlyFieldDateRangePickerComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldDateRangePickerComponent, selectors: [["sds-formly-field-daterangepicker"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["picker", ""], ["class", "display-flex", 4, "ngIf"], [1, "display-flex"], [1, "usa-input", "display-inline-block", "margin-top-3", 3, "formGroup", "rangePicker", "min", "max", "id", "formlyAttributes"], ["matStartDate", "", 3, "ngModelChange", "formlyAttributes", "placeholder", "formControlName"], ["matEndDate", "", 3, "ngModelChange", "formlyAttributes", "placeholder", "formControlName"], ["matSuffix", "", 1, "padding-top-2", "padding-left-1", 3, "for"], ["matDatepickerToggleIcon", "", 3, "icon", "size"], [3, "startAt"]], template: function FormlyFieldDateRangePickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FormlyFieldDateRangePickerComponent_div_0_Template, 8, 20, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.field.hide);
        } }, dependencies: [i1.NgIf, i2$4.MatDatepickerToggle, i2$4.MatDatepickerToggleIcon, i2$4.MatDateRangeInput, i2$4.MatStartDate, i2$4.MatEndDate, i2$4.MatDateRangePicker, i3$1.MatSuffix, i2$1.IconComponent, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i3.ɵFormlyAttributes], styles: [".mat-date-range-input-start-wrapper{overflow:unset!important}\n", ".mat-date-range-input-end-wrapper{flex-grow:unset!important}\n", "table.mat-calendar-table td,table.mat-calendar-table th{border-style:none;background-color:unset}\n"], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldDateRangePickerComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-field-daterangepicker', template: `
    <div *ngIf="!field.hide" class="display-flex">
      <mat-date-range-input
        [formGroup]="formControl"
        [rangePicker]="picker"
        [min]="props.minDate"
        [max]="props.maxDate"
        [id]="id"
        class="usa-input display-inline-block margin-top-3"
        [formlyAttributes]="field"
        [class.usa-input--error]="showError"
      >
        <input
          matStartDate
          [attr.aria-label]="field.fieldGroup[0]?.props?.placeholder || 'Start Date'"
          [formlyAttributes]="field.fieldGroup[0]"
          [placeholder]="field.fieldGroup[0]?.props?.placeholder || 'mmm-dd-yyyy'"
          [formControlName]="field.fieldGroup[0].key"
          (ngModelChange)="
            field.fieldGroup[0]?.props?.change ? field.fieldGroup[0].props.change(field.fieldGroup[0]) : ''
          "
        />
        <input
          matEndDate
          [attr.aria-label]="field.fieldGroup[1]?.props?.placeholder || 'End Date'"
          [formlyAttributes]="field.fieldGroup[1]"
          [placeholder]="field.fieldGroup[1]?.props?.placeholder || 'mmm-dd-yyyy'"
          [formControlName]="field.fieldGroup[1].key"
          (ngModelChange)="
            field.fieldGroup[1]?.props?.change ? field.fieldGroup[1].props.change(field.fieldGroup[1]) : ''
          "
        />
      </mat-date-range-input>
      <mat-datepicker-toggle class="padding-top-2 padding-left-1" matSuffix [for]="picker">
        <usa-icon [icon]="'calendar'" matDatepickerToggleIcon [size]="'sm'"></usa-icon>
      </mat-datepicker-toggle>
      <mat-date-range-picker [startAt]="to.startDate" #picker></mat-date-range-picker>
    </div>
  `, encapsulation: ViewEncapsulation.None, styles: [".mat-date-range-input-start-wrapper{overflow:unset!important}\n", ".mat-date-range-input-end-wrapper{flex-grow:unset!important}\n", "table.mat-calendar-table td,table.mat-calendar-table th{border-style:none;background-color:unset}\n"] }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldDateRangePickerComponent, { className: "FormlyFieldDateRangePickerComponent" }); })();

var SdsFormlyTypes;
(function (SdsFormlyTypes) {
    SdsFormlyTypes["INPUT"] = "input";
    SdsFormlyTypes["BUTTON"] = "button";
    SdsFormlyTypes["CHECKBOX"] = "checkbox";
    SdsFormlyTypes["MULTICHECKBOX"] = "multicheckbox";
    SdsFormlyTypes["RADIO"] = "radio";
    SdsFormlyTypes["AUTOCOMPLETE"] = "autocomplete";
    SdsFormlyTypes["DATEPICKER"] = "datepicker";
    SdsFormlyTypes["SELECT"] = "select";
    SdsFormlyTypes["TEXTAREA"] = "textarea";
    SdsFormlyTypes["READONLY"] = "readonly";
    SdsFormlyTypes["DATERANGEPICKER"] = "daterangepicker";
    SdsFormlyTypes["DATERANGEPICKERV2"] = "daterangepickerv2";
    SdsFormlyTypes["FORMLYGROUP"] = "formly-group";
    SdsFormlyTypes["FORMLYARRAY"] = "formly-array";
    SdsFormlyTypes["CUSTOMTEXT"] = "customtext";
    SdsFormlyTypes["EDITOR"] = "editor";
    SdsFormlyTypes["FILEINFO"] = "fileinfo";
    SdsFormlyTypes["SEARCH"] = "search";
    SdsFormlyTypes["FILEINPUT"] = "fileinput";
    SdsFormlyTypes["TABS"] = "tabs";
    SdsFormlyTypes["RICHTEXTEDITOR"] = "rich-text-editor";
    SdsFormlyTypes["STEPARROW"] = "step-arrow";
    /**
     * This formly type should generally be used with another formly type in order
     * to render the values of that formly type in a table.
     *
     * Template Options:
     *
     * tableColumns - An array of SdsTableColumn objects
     *
     * name - The accessible name for this table
     *
     * noDataText - Text to render when no data is available for the table
     */
    SdsFormlyTypes["TABLE"] = "table";
})(SdsFormlyTypes || (SdsFormlyTypes = {}));
var SdsReadonlyTypes;
(function (SdsReadonlyTypes) {
    SdsReadonlyTypes["INPUT"] = "input";
    SdsReadonlyTypes["CHECKBOX"] = "checkbox";
    SdsReadonlyTypes["MULTICHECKBOX"] = "multicheckbox";
    SdsReadonlyTypes["RADIO"] = "radio";
    SdsReadonlyTypes["AUTOCOMPLETE"] = "autocomplete";
    SdsReadonlyTypes["DATEPICKER"] = "datepicker";
    SdsReadonlyTypes["SELECT"] = "select";
    SdsReadonlyTypes["TEXTAREA"] = "textarea";
    SdsReadonlyTypes["READONLY"] = "readonly";
    SdsReadonlyTypes["DATERANGEPICKER"] = "daterangepicker";
    SdsReadonlyTypes["DATERANGEPICKERV2"] = "daterangepickerv2";
    SdsReadonlyTypes["FILEINFO"] = "fileinfo";
    SdsReadonlyTypes["SEARCH"] = "search";
})(SdsReadonlyTypes || (SdsReadonlyTypes = {}));

const _c0$f = a0 => ({ $implicit: a0 });
function ReadonlyInputComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$f, ctx_r0.value));
} }
function ReadonlyInputComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value ? ctx_r0.value : "\u2014");
} }
class ReadonlyInputComponent {
    /** @nocollapse */ static { this.ɵfac = function ReadonlyInputComponent_Factory(t) { return new (t || ReadonlyInputComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyInputComponent, selectors: [["sds-readonly-input"]], inputs: { value: "value", valueTemplate: "valueTemplate" }, decls: 3, vars: 2, consts: [["defaultValue", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold"]], template: function ReadonlyInputComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyInputComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlyInputComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultValue_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.valueTemplate)("ngIfElse", defaultValue_r2);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyInputComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-input`,
                template: `
    <ng-container
      *ngIf="valueTemplate; else defaultValue"
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ $implicit: value }"
    >
    </ng-container>
    <ng-template #defaultValue>
      <span class="text-bold">{{ value ? value : '&mdash;' }}</span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyInputComponent, { className: "ReadonlyInputComponent" }); })();

const _c0$e = a0 => ({ $implicit: a0 });
function ReadonlyDatepickerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$e, ctx_r0.value));
} }
function ReadonlyDatepickerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.value ? i0.ɵɵpipeBind2(2, 1, ctx_r0.value, "mediumDate") : "\u2014", "");
} }
class ReadonlyDatepickerComponent {
    /** @nocollapse */ static { this.ɵfac = function ReadonlyDatepickerComponent_Factory(t) { return new (t || ReadonlyDatepickerComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyDatepickerComponent, selectors: [["sds-readonly-datepicker"]], inputs: { value: "value", valueTemplate: "valueTemplate" }, decls: 3, vars: 2, consts: [["defaultValue", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold"]], template: function ReadonlyDatepickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyDatepickerComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlyDatepickerComponent_ng_template_1_Template, 3, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultValue_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.valueTemplate)("ngIfElse", defaultValue_r2);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet, i1.DatePipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyDatepickerComponent, [{
        type: Component,
        args: [{
                selector: 'sds-readonly-datepicker',
                template: `
    <ng-container
      *ngIf="valueTemplate; else defaultValue"
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ $implicit: value }"
    >
    </ng-container>
    <ng-template #defaultValue>
      <span class="text-bold"> {{ value ? (value | date: 'mediumDate') : '&mdash;' }}</span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyDatepickerComponent, { className: "ReadonlyDatepickerComponent" }); })();

const _c0$d = a0 => ({ $implicit: a0 });
function ReadonlySelectComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$d, ctx_r0.displayValue.label));
} }
function ReadonlySelectComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.displayValue.label, i0.ɵɵsanitizeHtml);
} }
class ReadonlySelectComponent {
    ngOnInit() {
        if (!this.selectOptions || !this.selectOptions.length) {
            throw new Error(`No option list provided for readonly mode of select type with value of ${this.value}`);
        }
        if (!this.value) {
            this.displayValue = { label: '&mdash;', value: this.value };
        }
        else {
            this.displayValue = this.selectOptions.find((option) => option.value === this.value);
            if (!this.displayValue) {
                this.displayValue = { label: '&mdash;', value: this.value };
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlySelectComponent_Factory(t) { return new (t || ReadonlySelectComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlySelectComponent, selectors: [["sds-readonly-select"]], inputs: { value: "value", valueTemplate: "valueTemplate", selectOptions: "selectOptions" }, decls: 3, vars: 2, consts: [["defaultValue", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold", 3, "innerHTML"]], template: function ReadonlySelectComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlySelectComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlySelectComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultValue_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.valueTemplate)("ngIfElse", defaultValue_r2);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlySelectComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-select`,
                template: `
    <ng-container
      *ngIf="valueTemplate; else defaultValue"
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ $implicit: displayValue.label }"
    >
    </ng-container>
    <ng-template #defaultValue>
      <span [innerHTML]="displayValue.label" class="text-bold"></span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }], selectOptions: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlySelectComponent, { className: "ReadonlySelectComponent" }); })();

const _c0$c = a0 => ({ $implicit: a0 });
function ReadonlyRadioComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
} }
function ReadonlyRadioComponent_ng_template_1_span_0_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
} if (rf & 2) {
    const option_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$c, option_r1.label));
} }
function ReadonlyRadioComponent_ng_template_1_span_0_span_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r1.label);
} }
function ReadonlyRadioComponent_ng_template_1_span_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, ReadonlyRadioComponent_ng_template_1_span_0_span_1_ng_container_1_Template, 1, 4, "ng-container", 6)(2, ReadonlyRadioComponent_ng_template_1_span_0_span_1_ng_template_2_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const defaultValue_r3 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.valueTemplate)("ngIfElse", defaultValue_r3);
} }
function ReadonlyRadioComponent_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, ReadonlyRadioComponent_ng_template_1_span_0_span_1_Template, 4, 2, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r1.value === ctx_r1.value);
} }
function ReadonlyRadioComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ReadonlyRadioComponent_ng_template_1_span_0_Template, 2, 1, "span", 4);
    i0.ɵɵpipe(1, "formlySelectOptions");
    i0.ɵɵpipe(2, "async");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r1.radioOptions)));
} }
class ReadonlyRadioComponent {
    ngOnInit() {
        if (!this.radioOptions || !this.radioOptions.length) {
            throw new Error(`No option list provided for readonly mode of radio type with value of ${this.value}`);
        }
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyRadioComponent_Factory(t) { return new (t || ReadonlyRadioComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyRadioComponent, selectors: [["sds-readonly-radio"]], inputs: { value: "value", valueTemplate: "valueTemplate", radioOptions: "radioOptions" }, decls: 3, vars: 2, consts: [["definedValues", ""], ["defaultValue", ""], ["class", "text-bold", 4, "ngIf", "ngIfElse"], [1, "text-bold"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold", "display-block"]], template: function ReadonlyRadioComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyRadioComponent_span_0_Template, 2, 0, "span", 2)(1, ReadonlyRadioComponent_ng_template_1_Template, 3, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const definedValues_r4 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.value)("ngIfElse", definedValues_r4);
        } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.AsyncPipe, i4.FormlySelectOptionsPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyRadioComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-radio`,
                template: `
    <span *ngIf="!value; else definedValues" class="text-bold">&mdash;</span>

    <ng-template #definedValues>
      <span *ngFor="let option of radioOptions | formlySelectOptions | async">
        <span *ngIf="option.value === value">
          <ng-container
            *ngIf="valueTemplate; else defaultValue"
            [ngTemplateOutlet]="valueTemplate"
            [ngTemplateOutletContext]="{ $implicit: option.label }"
          >
          </ng-container>
          <ng-template #defaultValue>
            <span class="text-bold display-block">{{ option.label }}</span>
          </ng-template>
        </span>
      </span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }], radioOptions: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyRadioComponent, { className: "ReadonlyRadioComponent" }); })();

const _c0$b = a0 => ({ $implicit: a0 });
function ReadonlyAutocompleteComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$b, ctx_r0.displayValue));
} }
function ReadonlyAutocompleteComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.displayValue, i0.ɵɵsanitizeHtml);
} }
class ReadonlyAutocompleteComponent {
    ngOnInit() {
        if (!this.autocompleteSettings || !this.autocompleteSettings.primaryTextField) {
            throw new Error(`Primary text field missing in autocomplete settings with value of ${this.value}`);
        }
        if (!this.value || !this.value.length) {
            this.displayValue = '&mdash;';
        }
        else {
            this.displayValue = this.value.map((value) => value[this.autocompleteSettings.primaryTextField]).join(', ');
        }
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyAutocompleteComponent_Factory(t) { return new (t || ReadonlyAutocompleteComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyAutocompleteComponent, selectors: [["sds-readonly-autocomplete"]], inputs: { value: "value", valueTemplate: "valueTemplate", autocompleteSettings: "autocompleteSettings" }, decls: 3, vars: 2, consts: [["defaultValue", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold", 3, "innerHTML"]], template: function ReadonlyAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyAutocompleteComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlyAutocompleteComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultValue_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.valueTemplate)("ngIfElse", defaultValue_r2);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyAutocompleteComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-autocomplete`,
                template: `
    <ng-container
      *ngIf="valueTemplate; else defaultValue"
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ $implicit: displayValue }"
    >
    </ng-container>
    <ng-template #defaultValue>
      <span class="text-bold" [innerHTML]="displayValue"></span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }], autocompleteSettings: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyAutocompleteComponent, { className: "ReadonlyAutocompleteComponent" }); })();

const _c0$a = a0 => ({ $implicit: a0 });
function ReadonlyCheckboxComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$a, ctx_r0.value));
} }
function ReadonlyCheckboxComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value ? "Checked" : "Unchecked");
} }
class ReadonlyCheckboxComponent {
    /** @nocollapse */ static { this.ɵfac = function ReadonlyCheckboxComponent_Factory(t) { return new (t || ReadonlyCheckboxComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyCheckboxComponent, selectors: [["sds-readonly-checkbox"]], inputs: { value: "value", valueTemplate: "valueTemplate" }, decls: 3, vars: 2, consts: [["defaultValue", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold"]], template: function ReadonlyCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyCheckboxComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlyCheckboxComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultValue_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.valueTemplate)("ngIfElse", defaultValue_r2);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyCheckboxComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-checkbox`,
                template: `
    <ng-container
      *ngIf="valueTemplate; else defaultValue"
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ $implicit: value }"
    >
    </ng-container>
    <ng-template #defaultValue>
      <span class="text-bold">{{ value ? 'Checked' : 'Unchecked' }}</span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyCheckboxComponent, { className: "ReadonlyCheckboxComponent" }); })();

const _c0$9 = a0 => ({ $implicit: a0 });
function ReadonlyMulticheckboxComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
} }
function ReadonlyMulticheckboxComponent_ng_template_1_span_0_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
} if (rf & 2) {
    const option_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$9, option_r1.label));
} }
function ReadonlyMulticheckboxComponent_ng_template_1_span_0_span_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r1.label);
} }
function ReadonlyMulticheckboxComponent_ng_template_1_span_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, ReadonlyMulticheckboxComponent_ng_template_1_span_0_span_1_ng_container_1_Template, 1, 4, "ng-container", 6)(2, ReadonlyMulticheckboxComponent_ng_template_1_span_0_span_1_ng_template_2_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const defaultValue_r3 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.valueTemplate)("ngIfElse", defaultValue_r3);
} }
function ReadonlyMulticheckboxComponent_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, ReadonlyMulticheckboxComponent_ng_template_1_span_0_span_1_Template, 4, 2, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.value[option_r1.value]);
} }
function ReadonlyMulticheckboxComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ReadonlyMulticheckboxComponent_ng_template_1_span_0_Template, 2, 1, "span", 4);
    i0.ɵɵpipe(1, "formlySelectOptions");
    i0.ɵɵpipe(2, "async");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r1.multicheckboxOptions)));
} }
class ReadonlyMulticheckboxComponent {
    ngOnInit() {
        if (!this.multicheckboxOptions || !this.multicheckboxOptions.length) {
            throw new Error(`No option list provided for readonly mode of multicheckbox type with value of ${this.value}`);
        }
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyMulticheckboxComponent_Factory(t) { return new (t || ReadonlyMulticheckboxComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyMulticheckboxComponent, selectors: [["sds-readonly-multicheckbox"]], inputs: { value: "value", valueTemplate: "valueTemplate", multicheckboxOptions: "multicheckboxOptions" }, decls: 3, vars: 2, consts: [["definedValues", ""], ["defaultValue", ""], ["class", "text-bold", 4, "ngIf", "ngIfElse"], [1, "text-bold"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold", "display-block"]], template: function ReadonlyMulticheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyMulticheckboxComponent_span_0_Template, 2, 0, "span", 2)(1, ReadonlyMulticheckboxComponent_ng_template_1_Template, 3, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const definedValues_r4 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.value)("ngIfElse", definedValues_r4);
        } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.AsyncPipe, i4.FormlySelectOptionsPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyMulticheckboxComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-multicheckbox`,
                template: `
    <span *ngIf="!value; else definedValues" class="text-bold">&mdash;</span>

    <ng-template #definedValues>
      <span *ngFor="let option of multicheckboxOptions | formlySelectOptions | async">
        <span *ngIf="value[option.value]">
          <ng-container
            *ngIf="valueTemplate; else defaultValue"
            [ngTemplateOutlet]="valueTemplate"
            [ngTemplateOutletContext]="{ $implicit: option.label }"
          >
          </ng-container>
          <ng-template #defaultValue>
            <span class="text-bold display-block">{{ option.label }}</span>
          </ng-template>
        </span>
      </span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }], multicheckboxOptions: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyMulticheckboxComponent, { className: "ReadonlyMulticheckboxComponent" }); })();

const _c0$8 = a0 => ({ $implicit: a0 });
function ReadonlyDaterangeComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$8, ctx_r0.displayValue));
} }
function ReadonlyDaterangeComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayValue, " ");
} }
class ReadonlyDaterangeComponent {
    constructor(datePipe) {
        this.datePipe = datePipe;
        this.daterangepickerOptions = {
            fromDateKey: 'fromDate',
            toDateKey: 'toDate',
        };
    }
    ngOnInit() {
        let fromDate = this.datePipe.transform(this.value[this.daterangepickerOptions.fromDateKey], 'mediumDate');
        let toDate = this.datePipe.transform(this.value[this.daterangepickerOptions.toDateKey], 'mediumDate');
        this.displayValue = `${fromDate ? fromDate : '--'} ${toDate ? ' - ' + toDate : ''}`;
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyDaterangeComponent_Factory(t) { return new (t || ReadonlyDaterangeComponent)(i0.ɵɵdirectiveInject(i1.DatePipe)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyDaterangeComponent, selectors: [["sds-readonly-daterange"]], inputs: { value: "value", valueTemplate: "valueTemplate", daterangepickerOptions: "daterangepickerOptions" }, decls: 3, vars: 2, consts: [["defaultValue", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold"]], template: function ReadonlyDaterangeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyDaterangeComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlyDaterangeComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultValue_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.valueTemplate)("ngIfElse", defaultValue_r2);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyDaterangeComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-daterange`,
                template: `
    <ng-container
      *ngIf="valueTemplate; else defaultValue"
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ $implicit: displayValue }"
    >
    </ng-container>
    <ng-template #defaultValue>
      <span class="text-bold">
        {{ displayValue }}
      </span>
    </ng-template>
  `,
            }]
    }], () => [{ type: i1.DatePipe }], { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }], daterangepickerOptions: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyDaterangeComponent, { className: "ReadonlyDaterangeComponent" }); })();

const _c0$7 = a0 => ({ $implicit: a0 });
function ReadonlyFileinfoComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.valueTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$7, ctx_r0.displayValue));
} }
function ReadonlyFileinfoComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.displayValue);
} }
class ReadonlyFileinfoComponent {
    ngOnInit() {
        if (!this.fileInfoOptions || !this.fileInfoOptions.length) {
            throw new Error(`No option list provided for readonly mode of fileinfo type with value of ${this.value}`);
        }
    }
    ngOnChanges() {
        if (!this.fileInfoOptions) {
            return;
        }
        const selectedOption = this.fileInfoOptions.find((option) => option.value === this.value);
        if (!selectedOption) {
            this.displayValue = '&mdash;';
        }
        this.displayValue = selectedOption.label + ' - ' + selectedOption.value;
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyFileinfoComponent_Factory(t) { return new (t || ReadonlyFileinfoComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyFileinfoComponent, selectors: [["sds-readonly-fileinfo"]], inputs: { value: "value", valueTemplate: "valueTemplate", fileInfoOptions: "fileInfoOptions" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [["defaultValue", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-bold"]], template: function ReadonlyFileinfoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyFileinfoComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlyFileinfoComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const defaultValue_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.valueTemplate)("ngIfElse", defaultValue_r2);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyFileinfoComponent, [{
        type: Component,
        args: [{
                selector: `sds-readonly-fileinfo`,
                template: `
    <ng-container
      *ngIf="valueTemplate; else defaultValue"
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ $implicit: displayValue }"
    >
    </ng-container>
    <ng-template #defaultValue>
      <span class="text-bold">{{ displayValue }}</span>
    </ng-template>
  `,
            }]
    }], null, { value: [{
            type: Input
        }], valueTemplate: [{
            type: Input
        }], fileInfoOptions: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyFileinfoComponent, { className: "ReadonlyFileinfoComponent" }); })();

const _c0$6 = a0 => ({ $implicit: a0 });
function ReadonlyContainerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.labelTemplate.templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$6, ctx_r0.formlyFieldConfig == null ? null : ctx_r0.formlyFieldConfig.props));
} }
function ReadonlyContainerComponent_ng_template_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.formlyFieldConfig.props.tagClass ? ctx_r0.formlyFieldConfig.props.tagClass : "sds-tag--info-white");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.formlyFieldConfig.props.tagText);
} }
function ReadonlyContainerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 11);
    i0.ɵɵtemplate(1, ReadonlyContainerComponent_ng_template_1_span_1_Template, 2, 2, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.formlyFieldConfig == null ? null : ctx_r0.formlyFieldConfig.props == null ? null : ctx_r0.formlyFieldConfig.props.tagText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
} }
function ReadonlyContainerComponent_sds_readonly_input_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-input", 14);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef);
} }
function ReadonlyContainerComponent_sds_readonly_input_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-input", 14);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef);
} }
function ReadonlyContainerComponent_sds_readonly_input_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-input", 14);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef);
} }
function ReadonlyContainerComponent_sds_readonly_input_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-input", 14);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value.searchText)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef);
} }
function ReadonlyContainerComponent_sds_readonly_datepicker_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-datepicker", 14);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef);
} }
function ReadonlyContainerComponent_sds_readonly_select_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-select", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef)("selectOptions", ctx_r0.additionalConfig.providedOptions);
} }
function ReadonlyContainerComponent_sds_readonly_radio_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-radio", 16);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef)("radioOptions", ctx_r0.additionalConfig.providedOptions);
} }
function ReadonlyContainerComponent_sds_readonly_fileinfo_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-fileinfo", 17);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef)("fileInfoOptions", ctx_r0.additionalConfig.providedOptions);
} }
function ReadonlyContainerComponent_sds_readonly_autocomplete_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-autocomplete", 18);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef)("autocompleteSettings", ctx_r0.additionalConfig.autocompleteOptions);
} }
function ReadonlyContainerComponent_sds_readonly_checkbox_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-checkbox", 14);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef);
} }
function ReadonlyContainerComponent_sds_readonly_multicheckbox_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-multicheckbox", 19);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef)("multicheckboxOptions", ctx_r0.additionalConfig.providedOptions);
} }
function ReadonlyContainerComponent_sds_readonly_daterange_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-daterange", 20);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef)("daterangepickerOptions", ctx_r0.additionalConfig.daterangepickerOptions);
} }
function ReadonlyContainerComponent_sds_readonly_daterange_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-daterange", 20);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.value)("valueTemplate", ctx_r0.valueTemplate == null ? null : ctx_r0.valueTemplate.templateRef)("daterangepickerOptions", ctx_r0.additionalConfig.daterangepickerOptions);
} }
class ReadonlyLabelDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyLabelDirective_Factory(t) { return new (t || ReadonlyLabelDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: ReadonlyLabelDirective, selectors: [["", "sdsReadonlyLabel", ""]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyLabelDirective, [{
        type: Directive,
        args: [{
                selector: '[sdsReadonlyLabel]',
            }]
    }], () => [{ type: i0.TemplateRef }], null); })();
class ReadonlyValueDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyValueDirective_Factory(t) { return new (t || ReadonlyValueDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: ReadonlyValueDirective, selectors: [["", "sdsReadonlyValue", ""]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyValueDirective, [{
        type: Directive,
        args: [{
                selector: '[sdsReadonlyValue]',
            }]
    }], () => [{ type: i0.TemplateRef }], null); })();
/**
 * Wrapper level component for displaying readonly format for each formly types
 */
class ReadonlyContainerComponent {
    constructor() {
        /**
         * Additional information useful for displaying the value - will be ignored if formlyFieldConfig is defined
         */
        this.additionalConfig = {};
        this.sdsFormlyTypes = SdsFormlyTypes;
    }
    ngOnInit() {
        if (this.formlyFieldConfig) {
            this.label = this.formlyFieldConfig.props.label;
            this.value = this.formlyFieldConfig.formControl.value;
            this.formlyType = this.formlyFieldConfig.type.toString();
            this.assignAdditionalConfig();
        }
    }
    assignAdditionalConfig() {
        const options = this.formlyFieldConfig.props.options;
        this.additionalConfig = {
            providedOptions: options,
        };
        if (this.formlyFieldConfig.type === this.sdsFormlyTypes.AUTOCOMPLETE) {
            this.additionalConfig.autocompleteOptions = this.formlyFieldConfig.props.configuration;
        }
        // We do array access from field config for daterangepicker, which can be undefined for other types,
        // hence this is sectioned off in a conditional
        if (this.formlyFieldConfig.type === this.sdsFormlyTypes.DATERANGEPICKER) {
            this.additionalConfig.daterangepickerOptions = {
                fromDateKey: this.formlyFieldConfig.fieldGroup[0].key,
                toDateKey: this.formlyFieldConfig.fieldGroup[1].key,
            };
        }
    }
    /** @nocollapse */ static { this.ɵfac = function ReadonlyContainerComponent_Factory(t) { return new (t || ReadonlyContainerComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: ReadonlyContainerComponent, selectors: [["sds-readonly-container"]], contentQueries: function ReadonlyContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ReadonlyLabelDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, ReadonlyValueDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueTemplate = _t.first);
        } }, inputs: { formlyFieldConfig: "formlyFieldConfig", formlyType: "formlyType", label: "label", value: "value", additionalConfig: "additionalConfig" }, decls: 17, vars: 16, consts: [["defaultLabel", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], [3, "ngSwitch"], [3, "value", "valueTemplate", 4, "ngSwitchCase"], [3, "value", "valueTemplate", "selectOptions", 4, "ngSwitchCase"], [3, "value", "valueTemplate", "radioOptions", 4, "ngSwitchCase"], [3, "value", "valueTemplate", "fileInfoOptions", 4, "ngSwitchCase"], [3, "value", "valueTemplate", "autocompleteSettings", 4, "ngSwitchCase"], [3, "value", "valueTemplate", "multicheckboxOptions", 4, "ngSwitchCase"], [3, "value", "valueTemplate", "daterangepickerOptions", 4, "ngSwitchCase"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "usa-label"], ["class", "usa-tag", 3, "ngClass", 4, "ngIf"], [1, "usa-tag", 3, "ngClass"], [3, "value", "valueTemplate"], [3, "value", "valueTemplate", "selectOptions"], [3, "value", "valueTemplate", "radioOptions"], [3, "value", "valueTemplate", "fileInfoOptions"], [3, "value", "valueTemplate", "autocompleteSettings"], [3, "value", "valueTemplate", "multicheckboxOptions"], [3, "value", "valueTemplate", "daterangepickerOptions"]], template: function ReadonlyContainerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ReadonlyContainerComponent_ng_container_0_Template, 1, 4, "ng-container", 1)(1, ReadonlyContainerComponent_ng_template_1_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(3, "span", 2);
            i0.ɵɵtemplate(4, ReadonlyContainerComponent_sds_readonly_input_4_Template, 1, 2, "sds-readonly-input", 3)(5, ReadonlyContainerComponent_sds_readonly_input_5_Template, 1, 2, "sds-readonly-input", 3)(6, ReadonlyContainerComponent_sds_readonly_input_6_Template, 1, 2, "sds-readonly-input", 3)(7, ReadonlyContainerComponent_sds_readonly_input_7_Template, 1, 2, "sds-readonly-input", 3)(8, ReadonlyContainerComponent_sds_readonly_datepicker_8_Template, 1, 2, "sds-readonly-datepicker", 3)(9, ReadonlyContainerComponent_sds_readonly_select_9_Template, 1, 3, "sds-readonly-select", 4)(10, ReadonlyContainerComponent_sds_readonly_radio_10_Template, 1, 3, "sds-readonly-radio", 5)(11, ReadonlyContainerComponent_sds_readonly_fileinfo_11_Template, 1, 3, "sds-readonly-fileinfo", 6)(12, ReadonlyContainerComponent_sds_readonly_autocomplete_12_Template, 1, 3, "sds-readonly-autocomplete", 7)(13, ReadonlyContainerComponent_sds_readonly_checkbox_13_Template, 1, 2, "sds-readonly-checkbox", 3)(14, ReadonlyContainerComponent_sds_readonly_multicheckbox_14_Template, 1, 3, "sds-readonly-multicheckbox", 8)(15, ReadonlyContainerComponent_sds_readonly_daterange_15_Template, 1, 3, "sds-readonly-daterange", 9)(16, ReadonlyContainerComponent_sds_readonly_daterange_16_Template, 1, 3, "sds-readonly-daterange", 9);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const defaultLabel_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.labelTemplate)("ngIfElse", defaultLabel_r2);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngSwitch", ctx.formlyType);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.INPUT);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.TEXTAREA);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.READONLY);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.SEARCH);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.DATEPICKER);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.SELECT);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.RADIO);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.FILEINFO);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.AUTOCOMPLETE);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.CHECKBOX);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.MULTICHECKBOX);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.DATERANGEPICKER);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", ctx.sdsFormlyTypes.DATERANGEPICKERV2);
        } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i1.NgSwitch, i1.NgSwitchCase, ReadonlyInputComponent, ReadonlyDatepickerComponent, ReadonlySelectComponent, ReadonlyRadioComponent, ReadonlyAutocompleteComponent, ReadonlyCheckboxComponent, ReadonlyMulticheckboxComponent, ReadonlyDaterangeComponent, ReadonlyFileinfoComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadonlyContainerComponent, [{
        type: Component,
        args: [{ selector: `sds-readonly-container`, template: "<ng-container\n  *ngIf=\"labelTemplate; else defaultLabel\"\n  [ngTemplateOutlet]=\"labelTemplate.templateRef\"\n  [ngTemplateOutletContext]=\"{ $implicit: formlyFieldConfig?.props }\"\n>\n</ng-container>\n\n<ng-template #defaultLabel>\n  <label class=\"usa-label\">\n    <span\n      *ngIf=\"formlyFieldConfig?.props?.tagText\"\n      class=\"usa-tag\"\n      [ngClass]=\"formlyFieldConfig.props.tagClass ? formlyFieldConfig.props.tagClass : 'sds-tag--info-white'\"\n      >{{ formlyFieldConfig.props.tagText }}</span\n    >\n    {{ label }}\n  </label>\n</ng-template>\n\n<span [ngSwitch]=\"formlyType\">\n  <sds-readonly-input *ngSwitchCase=\"sdsFormlyTypes.INPUT\" [value]=\"value\" [valueTemplate]=\"valueTemplate?.templateRef\">\n  </sds-readonly-input>\n\n  <sds-readonly-input\n    *ngSwitchCase=\"sdsFormlyTypes.TEXTAREA\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n  >\n  </sds-readonly-input>\n\n  <sds-readonly-input\n    *ngSwitchCase=\"sdsFormlyTypes.READONLY\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n  >\n  </sds-readonly-input>\n\n  <sds-readonly-input\n    *ngSwitchCase=\"sdsFormlyTypes.SEARCH\"\n    [value]=\"value.searchText\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n  >\n  </sds-readonly-input>\n\n  <sds-readonly-datepicker\n    *ngSwitchCase=\"sdsFormlyTypes.DATEPICKER\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n  >\n  </sds-readonly-datepicker>\n\n  <sds-readonly-select\n    *ngSwitchCase=\"sdsFormlyTypes.SELECT\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n    [selectOptions]=\"additionalConfig.providedOptions\"\n  >\n  </sds-readonly-select>\n\n  <sds-readonly-radio\n    *ngSwitchCase=\"sdsFormlyTypes.RADIO\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n    [radioOptions]=\"additionalConfig.providedOptions\"\n  >\n  </sds-readonly-radio>\n\n  <sds-readonly-fileinfo\n    *ngSwitchCase=\"sdsFormlyTypes.FILEINFO\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n    [fileInfoOptions]=\"additionalConfig.providedOptions\"\n  >\n  </sds-readonly-fileinfo>\n\n  <sds-readonly-autocomplete\n    *ngSwitchCase=\"sdsFormlyTypes.AUTOCOMPLETE\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n    [autocompleteSettings]=\"additionalConfig.autocompleteOptions\"\n  >\n  </sds-readonly-autocomplete>\n\n  <sds-readonly-checkbox\n    *ngSwitchCase=\"sdsFormlyTypes.CHECKBOX\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n  >\n  </sds-readonly-checkbox>\n\n  <sds-readonly-multicheckbox\n    *ngSwitchCase=\"sdsFormlyTypes.MULTICHECKBOX\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n    [multicheckboxOptions]=\"additionalConfig.providedOptions\"\n  ></sds-readonly-multicheckbox>\n\n  <sds-readonly-daterange\n    *ngSwitchCase=\"sdsFormlyTypes.DATERANGEPICKER\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n    [daterangepickerOptions]=\"additionalConfig.daterangepickerOptions\"\n  >\n  </sds-readonly-daterange>\n\n  <sds-readonly-daterange\n    *ngSwitchCase=\"sdsFormlyTypes.DATERANGEPICKERV2\"\n    [value]=\"value\"\n    [valueTemplate]=\"valueTemplate?.templateRef\"\n    [daterangepickerOptions]=\"additionalConfig.daterangepickerOptions\"\n  >\n  </sds-readonly-daterange>\n</span>\n" }]
    }], null, { labelTemplate: [{
            type: ContentChild,
            args: [ReadonlyLabelDirective]
        }], valueTemplate: [{
            type: ContentChild,
            args: [ReadonlyValueDirective]
        }], formlyFieldConfig: [{
            type: Input
        }], formlyType: [{
            type: Input
        }], label: [{
            type: Input
        }], value: [{
            type: Input
        }], additionalConfig: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReadonlyContainerComponent, { className: "ReadonlyContainerComponent" }); })();

const _c0$5 = ["fieldComponent"];
function FormlyReadonlyWrapperComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.props.readonlyTemplate(ctx_r0.field), i0.ɵɵsanitizeHtml);
} }
function FormlyReadonlyWrapperComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "sds-readonly-container", 7);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formlyFieldConfig", ctx_r0.field);
} }
function FormlyReadonlyWrapperComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, FormlyReadonlyWrapperComponent_div_0_span_1_Template, 1, 1, "span", 5)(2, FormlyReadonlyWrapperComponent_div_0_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const defaultTemplate_r2 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.props.readonlyClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.props.readonlyTemplate)("ngIfElse", defaultTemplate_r2);
} }
function FormlyReadonlyWrapperComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 2);
} }
/**
 * @param string [props.required] Makes the field required
 */
class FormlyReadonlyWrapperComponent extends FieldWrapper {
    constructor() {
        super(...arguments);
        this.sdsFormlyTypes = SdsFormlyTypes;
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyReadonlyWrapperComponent_BaseFactory; return function FormlyReadonlyWrapperComponent_Factory(t) { return (ɵFormlyReadonlyWrapperComponent_BaseFactory || (ɵFormlyReadonlyWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyReadonlyWrapperComponent)))(t || FormlyReadonlyWrapperComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyReadonlyWrapperComponent, selectors: [["ng-component"]], viewQuery: function FormlyReadonlyWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$5, 5, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["passThrough", ""], ["defaultTemplate", ""], ["fieldComponent", ""], [3, "ngClass", 4, "ngIf", "ngIfElse"], [3, "ngClass"], [3, "innerHTML", 4, "ngIf", "ngIfElse"], [3, "innerHTML"], [3, "formlyFieldConfig"]], template: function FormlyReadonlyWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FormlyReadonlyWrapperComponent_div_0_Template, 4, 3, "div", 3)(1, FormlyReadonlyWrapperComponent_ng_template_1_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const passThrough_r3 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.field.type === ctx.sdsFormlyTypes.READONLY || ctx.props.readonlyMode)("ngIfElse", passThrough_r3);
        } }, dependencies: [i1.NgClass, i1.NgIf, ReadonlyContainerComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyReadonlyWrapperComponent, [{
        type: Component,
        args: [{
                template: `
    <div
      *ngIf="field.type === sdsFormlyTypes.READONLY || props.readonlyMode; else passThrough"
      [ngClass]="props.readonlyClass"
    >
      <span *ngIf="props.readonlyTemplate; else defaultTemplate" [innerHTML]="props.readonlyTemplate(field)"></span>
      <ng-template #defaultTemplate>
        <sds-readonly-container [formlyFieldConfig]="field"></sds-readonly-container>
      </ng-template>
    </div>
    <ng-template #passThrough>
      <ng-container #fieldComponent></ng-container>
    </ng-template>
  `,
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyReadonlyWrapperComponent, { className: "FormlyReadonlyWrapperComponent" }); })();

const _c0$4 = ["defaultTemplate"];
const _c1$2 = (a0, a1, a2, a3) => ({ props: a0, form: a1, model: a2, modelChange: a3 });
const _c2$2 = (a0, a1) => ({ $implicit: a0, column: a1 });
function FormlyFieldFileInputComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultTemplate_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.props.template ? ctx_r1.props.template : defaultTemplate_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c1$2, ctx_r1.props, ctx_r1.formControl, ctx_r1.model, ctx_r1.modelChange));
} }
function FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const column_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate(column_r4.label);
} }
function FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_3_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_3_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const element_r6 = i0.ɵɵnextContext().element; const column_r4 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(column_r4.onClick(element_r6, ctx_r1.field.parent)); });
    i0.ɵɵelementContainer(1, 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r6 = i0.ɵɵnextContext().element;
    const column_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const tableCellTemplates_r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tableCellTemplates_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2$2, element_r6, column_r4));
} }
function FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
} if (rf & 2) {
    const element_r6 = i0.ɵɵnextContext().element;
    const column_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const tableCellTemplates_r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", tableCellTemplates_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2$2, element_r6, column_r4));
} }
function FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_3_button_0_Template, 2, 5, "button", 16)(1, FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_3_ng_template_1_Template, 1, 5, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const noClick_r8 = i0.ɵɵreference(2);
    const column_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", column_r4.onClick)("ngIfElse", noClick_r8);
} }
function FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sds-table-column", 15);
    i0.ɵɵtemplate(1, FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_1_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(3, FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_ng_template_3_Template, 3, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r4 = ctx.$implicit;
    i0.ɵɵproperty("sdsColumnName", column_r4.columnName);
} }
function FormlyFieldFileInputComponent_ng_template_3_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const props_r9 = i0.ɵɵnextContext().props;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", props_r9.noDataText, " ");
} }
function FormlyFieldFileInputComponent_ng_template_3_ng_template_7_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const element_r11 = ctx_r9.$implicit;
    const column_r12 = ctx_r9.column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(element_r11[column_r12.property]);
} }
function FormlyFieldFileInputComponent_ng_template_3_ng_template_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext().column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(column_r12.text);
} }
function FormlyFieldFileInputComponent_ng_template_3_ng_template_7_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const element_r11 = ctx_r9.$implicit;
    const column_r12 = ctx_r9.column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(column_r12.textFn(element_r11));
} }
function FormlyFieldFileInputComponent_ng_template_3_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FormlyFieldFileInputComponent_ng_template_3_ng_template_7_span_0_Template, 2, 1, "span", 19)(1, FormlyFieldFileInputComponent_ng_template_3_ng_template_7_span_1_Template, 2, 1, "span", 19)(2, FormlyFieldFileInputComponent_ng_template_3_ng_template_7_span_2_Template, 2, 1, "span", 19);
} if (rf & 2) {
    const column_r12 = ctx.column;
    i0.ɵɵproperty("ngIf", column_r12.property);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r12.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r12.textFn);
} }
function FormlyFieldFileInputComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵelementStart(1, "sds-table", 11, 2);
    i0.ɵɵtemplate(3, FormlyFieldFileInputComponent_ng_template_3_sds_table_column_3_Template, 5, 1, "sds-table-column", 12);
    i0.ɵɵelement(4, "sds-header-row", 13)(5, "sds-row", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, FormlyFieldFileInputComponent_ng_template_3_div_6_Template, 2, 1, "div", 14)(7, FormlyFieldFileInputComponent_ng_template_3_ng_template_7_Template, 3, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const props_r9 = ctx.props;
    const form_r13 = ctx.form;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("data", form_r13.value)("tableName", props_r9.tableName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", props_r9.tableColumns);
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayedColumns", ctx_r1.displayedColumns);
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayedColumns", ctx_r1.displayedColumns);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !form_r13.value || !form_r13.value.length);
} }
class FormlyFieldFileInputComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super();
        this.modelChange = new EventEmitter();
        this.displayedTemplate = null;
        this.selectedFiles = [];
        this.displayedColumns = [];
        this.cdr = _cdr;
    }
    onSelectedFilesChange(ev) {
        this.modelChange.next(ev);
    }
    ngOnInit() {
        if (this.field && this.props.tableColumns)
            this.displayedColumns = this.props.tableColumns.map((column) => column.columnName);
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldFileInputComponent_Factory(t) { return new (t || FormlyFieldFileInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldFileInputComponent, selectors: [["sds-formly-field-file-input"]], viewQuery: function FormlyFieldFileInputComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(UsaFileInputComponent, 7);
            i0.ɵɵviewQuery(_c0$4, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
        } }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 10, consts: [["fileInput", ""], ["defaultTemplate", ""], ["fileTable", ""], ["tableCellTemplates", ""], ["sdsHeaderCell", ""], ["sdsCell", ""], ["noClick", ""], [3, "selectedFilesChange", "formControl", "id", "acceptFileType", "multiple", "hint", "disabled", "clearFilesOnAdd", "displayFileInfo", "uploadRequest"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "margin-top-2"], [3, "data", "tableName"], [3, "sdsColumnName", 4, "ngFor", "ngForOf"], [3, "displayedColumns"], ["class", "border border-base-light text-center padding-1", 4, "ngIf"], [3, "sdsColumnName"], ["class", "usa-button usa-button--unstyled text-secondary-dark", 3, "click", 4, "ngIf", "ngIfElse"], [1, "usa-button", "usa-button--unstyled", "text-secondary-dark", 3, "click"], [1, "border", "border-base-light", "text-center", "padding-1"], [4, "ngIf"]], template: function FormlyFieldFileInputComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "usa-file-input", 7, 0);
            i0.ɵɵlistener("selectedFilesChange", function FormlyFieldFileInputComponent_Template_usa_file_input_selectedFilesChange_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onSelectedFilesChange($event)); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, FormlyFieldFileInputComponent_ng_container_2_Template, 1, 7, "ng-container", 8)(3, FormlyFieldFileInputComponent_ng_template_3_Template, 9, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("id", ctx.id)("acceptFileType", ctx.props.acceptFileType)("multiple", ctx.props.multiple)("hint", ctx.props.hint)("disabled", ctx.props.disabled)("clearFilesOnAdd", ctx.props.clearFilesOnAdd)("displayFileInfo", ctx.props.displayFileInfo)("uploadRequest", ctx.props.uploadRequest);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.props.tableDisplay);
        } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$6.SdsTableComponent, i2$6.SdsTableRowComponent, i2$6.SdsTableHeaderRowComponent, i2$6.SdsTableColumnDefComponent, i2$2.NgControlStatus, i2$2.FormControlDirective, i2.UsaFileInputComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldFileInputComponent, [{
        type: Component,
        args: [{ selector: `sds-formly-field-file-input`, template: "<usa-file-input\n  #fileInput\n  [formControl]=\"formControl\"\n  [id]=\"id\"\n  [acceptFileType]=\"props.acceptFileType\"\n  [multiple]=\"props.multiple\"\n  [hint]=\"props.hint\"\n  [disabled]=\"props.disabled\"\n  [clearFilesOnAdd]=\"props.clearFilesOnAdd\"\n  [displayFileInfo]=\"props.displayFileInfo\"\n  [uploadRequest]=\"props.uploadRequest\"\n  (selectedFilesChange)=\"onSelectedFilesChange($event)\"\n>\n</usa-file-input>\n\n<ng-container\n  *ngIf=\"props.tableDisplay\"\n  [ngTemplateOutlet]=\"(props.template ? props.template : defaultTemplate)\"\n  [ngTemplateOutletContext]=\"{\n        props: props,\n        form: formControl,\n        model: model,\n        modelChange: modelChange\n      }\"\n>\n</ng-container>\n\n<ng-template\n  let-props=\"props\"\n  let-data=\"data\"\n  let-form=\"form\"\n  let-model=\"model\"\n  let-modelChange=\"modelChange\"\n  #defaultTemplate\n>\n  <div class=\"margin-top-2\"></div>\n\n  <sds-table [data]=\"form.value\" [tableName]=\"props.tableName\" #fileTable>\n    <sds-table-column *ngFor=\"let column of props.tableColumns\" [sdsColumnName]=\"column.columnName\">\n      <ng-template #sdsHeaderCell>{{column.label}}</ng-template>\n      <ng-template #sdsCell let-element=\"element\">\n        <button\n          class=\"usa-button usa-button--unstyled text-secondary-dark\"\n          *ngIf=\"column.onClick; else noClick\"\n          (click)=\"column.onClick(element, field.parent)\"\n        >\n          <ng-container\n            [ngTemplateOutlet]=\"tableCellTemplates\"\n            [ngTemplateOutletContext]=\"{$implicit: element, column: column}\"\n          ></ng-container>\n        </button>\n        <ng-template #noClick>\n          <ng-container\n            [ngTemplateOutlet]=\"tableCellTemplates\"\n            [ngTemplateOutletContext]=\"{$implicit: element, column: column}\"\n          ></ng-container>\n        </ng-template>\n      </ng-template>\n    </sds-table-column>\n    <sds-header-row [displayedColumns]=\"displayedColumns\"></sds-header-row>\n    <sds-row [displayedColumns]=\"displayedColumns\"></sds-row>\n  </sds-table>\n  <div *ngIf=\"!form.value || !form.value.length\" class=\"border border-base-light text-center padding-1\">\n    {{props.noDataText}}\n  </div>\n\n  <ng-template #tableCellTemplates let-element let-column=\"column\">\n    <span *ngIf=\"column.property\">{{element[column.property]}}</span>\n    <span *ngIf=\"column.text\">{{column.text}}</span>\n    <span *ngIf=\"column.textFn\">{{column.textFn(element)}}</span>\n  </ng-template>\n</ng-template>\n" }]
    }], () => [{ type: i0.ChangeDetectorRef }], { template: [{
            type: ViewChild,
            args: [UsaFileInputComponent, { static: true }]
        }], modelChange: [{
            type: Output
        }], defaultTemplate: [{
            type: ViewChild,
            args: ['defaultTemplate']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldFileInputComponent, { className: "FormlyFieldFileInputComponent" }); })();

const _c0$3 = a0 => [a0];
function FormlyTabsWrapperComponent_ng_container_4_sds_tab_panel_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sds-tab-panel", 7);
    i0.ɵɵelement(1, "formly-form", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fieldConfig_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabHeader", fieldConfig_r3.props == null ? null : fieldConfig_r3.props.tabHeader);
    i0.ɵɵadvance();
    i0.ɵɵproperty("fields", i0.ɵɵpureFunction1(3, _c0$3, fieldConfig_r3))("model", ctx_r1.model);
} }
function FormlyTabsWrapperComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "sds-tabs", 5);
    i0.ɵɵlistener("preTabChange", function FormlyTabsWrapperComponent_ng_container_4_Template_sds_tabs_preTabChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.props.preTabChange ? ctx_r1.props.preTabChange($event) : null); });
    i0.ɵɵtwoWayListener("selectedTabChange", function FormlyTabsWrapperComponent_ng_container_4_Template_sds_tabs_selectedTabChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.props.selectedTab, $event) || (ctx_r1.props.selectedTab = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(2, FormlyTabsWrapperComponent_ng_container_4_sds_tab_panel_2_Template, 2, 5, "sds-tab-panel", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabClass", ctx_r1.props.tabClass ? ctx_r1.props.tabClass : "sds-tabs--formly")("interceptTabChange", ctx_r1.props.interceptTabChange);
    i0.ɵɵtwoWayProperty("selectedTab", ctx_r1.props.selectedTab);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.field.fieldGroup);
} }
function FormlyTabsWrapperComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "formly-form", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("fields", ctx_r1.field.fieldGroup)("model", ctx_r1.model);
} }
class FormlyTabsWrapperComponent extends FieldWrapper {
    constructor() {
        super(...arguments);
        this.toDestroy = new Subscription();
    }
    ngOnInit() {
        // if (!this.field.fieldArray || !this.field.fieldArray['fieldGroup']) {
        //   throw new Error('Please define contents of keywords through a fieldGroup within the fieldArray property');
        // }
        // this._initialModel = this.model && this.model[this.key as string] ? { ...this.model[this.key as string] } : {};
        if (this.field && this.field.fieldGroup) {
            this.field.fieldGroup.forEach((fieldConfig) => {
                this.updateFieldConfig(fieldConfig);
            });
        }
        const valueChangeSub = this.formControl.valueChanges.subscribe((newValue) => {
            this._initialModel = newValue;
        });
        this.toDestroy.add(valueChangeSub);
    }
    ngOnDestroy() {
        this.toDestroy.unsubscribe();
    }
    /**
     * Updates field configurations for each tab content when a submit button is present.
     * If a submit button id is not defined in the input field's template options, then simply exits
     * If submit button id is defined, then we expect a button of type submit to exist
     * in the field config's field group, and attach submit handling logic to
     * the button's click event.
     * @param fieldConfig - the FormlyFieldConfig to transform into an array
     */
    updateFieldConfig(fieldConfig) {
        const submitButtonId = fieldConfig.props?.submitButtonId;
        if (!submitButtonId) {
            return;
        }
        // If submit button is present, manually add logic to update the form when the button is clicked
        fieldConfig.fieldGroup.forEach((field) => {
            if (field.id === submitButtonId) {
                field.props = field.props ? field.props : {};
                field.props.onClick = () => {
                    this.updateFieldModel(fieldConfig);
                };
            }
            field.modelOptions = { updateOn: 'submit' };
        });
    }
    /**
     * Submit handling logic for a field config that contains a submit button.
     * Angular form keeps a pendingValue internally to keep track of values
     * that exist in the input field, but have not yet been updated as the model
     * to to restrictions on when to update (such as onBlur or Submit). Thus we manually
     * do the update by setting the form's value to its pending value, which will
     * trigger a model change event for clients to execute on
     * @param fieldConfig - The field config whose form control need to be updated
     */
    updateFieldModel(fieldConfig) {
        // Manual update each form in formly field
        Object.keys(fieldConfig.form.controls).forEach((field) => {
            const control = fieldConfig.form.get(field);
            if (control._pendingValue) {
                control.setValue(control._pendingValue);
                control.markAsTouched();
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyTabsWrapperComponent_BaseFactory; return function FormlyTabsWrapperComponent_Factory(t) { return (ɵFormlyTabsWrapperComponent_BaseFactory || (ɵFormlyTabsWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyTabsWrapperComponent)))(t || FormlyTabsWrapperComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyTabsWrapperComponent, selectors: [["ng-component"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 5, consts: [["singleField", ""], [1, "usa-label", "text-bold", "text-base-dark"], [3, "innerHTML"], [1, "sds-filter-keywords"], [4, "ngIf", "ngIfElse"], [3, "preTabChange", "selectedTabChange", "tabClass", "interceptTabChange", "selectedTab"], [3, "tabHeader", 4, "ngFor", "ngForOf"], [3, "tabHeader"], [3, "fields", "model"], [1, "padding-left-2", "padding-right-2", "padding-bottom-1"]], template: function FormlyTabsWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 1);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "p", 2);
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtemplate(4, FormlyTabsWrapperComponent_ng_container_4_Template, 3, 4, "ng-container", 4)(5, FormlyTabsWrapperComponent_ng_template_5_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const singleField_r4 = i0.ɵɵreference(6);
            i0.ɵɵattribute("for", ctx.id);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.props.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.props.description, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.field.fieldGroup == null ? null : ctx.field.fieldGroup.length) > 1)("ngIfElse", singleField_r4);
        } }, dependencies: [i1.NgForOf, i1.NgIf, i2$3.TabsComponent, i2$3.TabPanelComponent, i3.FormlyForm], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyTabsWrapperComponent, [{
        type: Component,
        args: [{
                template: `
    <label [attr.for]="id" class="usa-label text-bold text-base-dark">{{ props.label }}</label>
    <p [innerHTML]="props.description"></p>
    <div class="sds-filter-keywords">
      <ng-container *ngIf="field.fieldGroup?.length > 1; else singleField">
        <sds-tabs
          [tabClass]="props.tabClass ? props.tabClass : 'sds-tabs--formly'"
          [interceptTabChange]="props.interceptTabChange"
          (preTabChange)="props.preTabChange ? props.preTabChange($event) : null"
          [(selectedTab)]="props.selectedTab"
        >
          <sds-tab-panel *ngFor="let fieldConfig of field.fieldGroup" [tabHeader]="fieldConfig.props?.tabHeader">
            <formly-form [fields]="[fieldConfig]" [model]="model"> </formly-form>
          </sds-tab-panel>
        </sds-tabs>
      </ng-container>

      <ng-template #singleField>
        <div class="padding-left-2 padding-right-2 padding-bottom-1">
          <formly-form [fields]="field.fieldGroup" [model]="model"></formly-form>
        </div>
      </ng-template>
    </div>
  `,
                // changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyTabsWrapperComponent, { className: "FormlyTabsWrapperComponent" }); })();

const _c0$2 = (a0, a1) => ({ $implicit: a0, column: a1 });
function FormlyFieldTableComponent_sds_table_column_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const column_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate(column_r1.label);
} }
function FormlyFieldTableComponent_sds_table_column_2_ng_template_3_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function FormlyFieldTableComponent_sds_table_column_2_ng_template_3_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const element_r3 = i0.ɵɵnextContext().element; const column_r1 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(column_r1.onClick(element_r3, ctx_r3.parentFieldConfig)); });
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r3 = i0.ɵɵnextContext().element;
    const column_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const tableCellTemplates_r5 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tableCellTemplates_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c0$2, element_r3, column_r1));
} }
function FormlyFieldTableComponent_sds_table_column_2_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    const element_r3 = i0.ɵɵnextContext().element;
    const column_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const tableCellTemplates_r5 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", tableCellTemplates_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c0$2, element_r3, column_r1));
} }
function FormlyFieldTableComponent_sds_table_column_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FormlyFieldTableComponent_sds_table_column_2_ng_template_3_button_0_Template, 2, 5, "button", 10)(1, FormlyFieldTableComponent_sds_table_column_2_ng_template_3_ng_template_1_Template, 1, 5, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const noClick_r6 = i0.ɵɵreference(2);
    const column_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", column_r1.onClick)("ngIfElse", noClick_r6);
} }
function FormlyFieldTableComponent_sds_table_column_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sds-table-column", 9);
    i0.ɵɵtemplate(1, FormlyFieldTableComponent_sds_table_column_2_ng_template_1_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(3, FormlyFieldTableComponent_sds_table_column_2_ng_template_3_Template, 3, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r1 = ctx.$implicit;
    i0.ɵɵproperty("sdsColumnName", column_r1.columnName);
} }
function FormlyFieldTableComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.props.noDataText, "\n");
} }
function FormlyFieldTableComponent_ng_template_6_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const element_r8 = ctx_r6.$implicit;
    const column_r9 = ctx_r6.column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(element_r8[column_r9.property]);
} }
function FormlyFieldTableComponent_ng_template_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r9 = i0.ɵɵnextContext().column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(column_r9.text);
} }
function FormlyFieldTableComponent_ng_template_6_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const element_r8 = ctx_r6.$implicit;
    const column_r9 = ctx_r6.column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(column_r9.textFn(element_r8));
} }
function FormlyFieldTableComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FormlyFieldTableComponent_ng_template_6_span_0_Template, 2, 1, "span", 14)(1, FormlyFieldTableComponent_ng_template_6_span_1_Template, 2, 1, "span", 14)(2, FormlyFieldTableComponent_ng_template_6_span_2_Template, 2, 1, "span", 14);
} if (rf & 2) {
    const column_r9 = ctx.column;
    i0.ɵɵproperty("ngIf", column_r9.property);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r9.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r9.textFn);
} }
class FormlyFieldTableComponent extends FieldType {
    constructor() {
        super(...arguments);
        this.displayedColumns = [];
    }
    ngOnInit() {
        this.displayedColumns = this.props.tableColumns.map((column) => column.columnName);
        this.parentFieldConfig = this.field.parent;
    }
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵFormlyFieldTableComponent_BaseFactory; return function FormlyFieldTableComponent_Factory(t) { return (ɵFormlyFieldTableComponent_BaseFactory || (ɵFormlyFieldTableComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormlyFieldTableComponent)))(t || FormlyFieldTableComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldTableComponent, selectors: [["sds-formly-field-table"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 6, consts: [["fileTable", ""], ["tableCellTemplates", ""], ["sdsHeaderCell", ""], ["sdsCell", ""], ["noClick", ""], [3, "data", "tableName"], [3, "sdsColumnName", 4, "ngFor", "ngForOf"], [3, "displayedColumns"], ["class", "border border-base-light text-center padding-1", 4, "ngIf"], [3, "sdsColumnName"], ["class", "usa-button usa-button--unstyled text-secondary-dark", 3, "click", 4, "ngIf", "ngIfElse"], [1, "usa-button", "usa-button--unstyled", "text-secondary-dark", 3, "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "border", "border-base-light", "text-center", "padding-1"], [4, "ngIf"]], template: function FormlyFieldTableComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "sds-table", 5, 0);
            i0.ɵɵtemplate(2, FormlyFieldTableComponent_sds_table_column_2_Template, 5, 1, "sds-table-column", 6);
            i0.ɵɵelement(3, "sds-header-row", 7)(4, "sds-row", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, FormlyFieldTableComponent_div_5_Template, 2, 1, "div", 8)(6, FormlyFieldTableComponent_ng_template_6_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("data", ctx.form.value)("tableName", ctx.props.name);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.props.tableColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("displayedColumns", ctx.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("displayedColumns", ctx.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.form.value || !ctx.form.value.length);
        } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$6.SdsTableComponent, i2$6.SdsTableRowComponent, i2$6.SdsTableHeaderRowComponent, i2$6.SdsTableColumnDefComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldTableComponent, [{
        type: Component,
        args: [{ selector: `sds-formly-field-table`, template: "<sds-table [data]=\"form.value\" [tableName]=\"props.name\" #fileTable>\n  <sds-table-column *ngFor=\"let column of props.tableColumns\" [sdsColumnName]=\"column.columnName\">\n    <ng-template #sdsHeaderCell>{{column.label}}</ng-template>\n    <ng-template #sdsCell let-element=\"element\">\n      <button\n        class=\"usa-button usa-button--unstyled text-secondary-dark\"\n        *ngIf=\"column.onClick; else noClick\"\n        (click)=\"column.onClick(element, parentFieldConfig)\"\n      >\n        <ng-container\n          [ngTemplateOutlet]=\"tableCellTemplates\"\n          [ngTemplateOutletContext]=\"{$implicit: element, column: column}\"\n        ></ng-container>\n      </button>\n      <ng-template #noClick>\n        <ng-container\n          [ngTemplateOutlet]=\"tableCellTemplates\"\n          [ngTemplateOutletContext]=\"{$implicit: element, column: column}\"\n        ></ng-container>\n      </ng-template>\n    </ng-template>\n  </sds-table-column>\n  <sds-header-row [displayedColumns]=\"displayedColumns\"></sds-header-row>\n  <sds-row [displayedColumns]=\"displayedColumns\"></sds-row>\n</sds-table>\n<div *ngIf=\"!form.value || !form.value.length\" class=\"border border-base-light text-center padding-1\">\n  {{props.noDataText}}\n</div>\n\n<ng-template #tableCellTemplates let-element let-column=\"column\">\n  <span *ngIf=\"column.property\">{{element[column.property]}}</span>\n  <span *ngIf=\"column.text\">{{column.text}}</span>\n  <span *ngIf=\"column.textFn\">{{column.textFn(element)}}</span>\n</ng-template>\n" }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldTableComponent, { className: "FormlyFieldTableComponent" }); })();

class FormlyFieldEditorComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super(); /* istanbul ignore next */
        this.cdr = _cdr;
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldEditorComponent_Factory(t) { return new (t || FormlyFieldEditorComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldEditorComponent, selectors: [["sds-formly-field-editor"]], viewQuery: function FormlyFieldEditorComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(SdsEditorComponent, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formControl"]], template: function FormlyFieldEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "sds-editor", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl);
        } }, dependencies: [i2$3.SdsEditorComponent, i2$2.NgControlStatus, i2$2.FormControlDirective], encapsulation: 2, changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldEditorComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-editor',
                template: ` <sds-editor [formControl]="formControl"></sds-editor> `,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], () => [{ type: i0.ChangeDetectorRef }], { template: [{
            type: ViewChild,
            args: [SdsEditorComponent, { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldEditorComponent, { className: "FormlyFieldEditorComponent" }); })();

class FormlyFieldRichTextEditorComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super();
        this.cdr = _cdr;
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldRichTextEditorComponent_Factory(t) { return new (t || FormlyFieldRichTextEditorComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldRichTextEditorComponent, selectors: [["sds-formly-rich-text-editor"]], viewQuery: function FormlyFieldRichTextEditorComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(SdsRichTextComponent, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formControl"]], template: function FormlyFieldRichTextEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "sds-rich-text", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl);
        } }, dependencies: [i2$2.NgControlStatus, i2$2.FormControlDirective, i2$3.SdsRichTextComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldRichTextEditorComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-rich-text-editor',
                template: ` <sds-rich-text [formControl]="formControl"> </sds-rich-text> `,
            }]
    }], () => [{ type: i0.ChangeDetectorRef }], { template: [{
            type: ViewChild,
            args: [SdsRichTextComponent, { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldRichTextEditorComponent, { className: "FormlyFieldRichTextEditorComponent" }); })();

class FormlyFieldStepArrowComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super(); /* istanbul ignore next */
        this.cdr = _cdr;
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyFieldStepArrowComponent_Factory(t) { return new (t || FormlyFieldStepArrowComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: FormlyFieldStepArrowComponent, selectors: [["sds-formly-field-autocomplete"]], viewQuery: function FormlyFieldStepArrowComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(SdsStepArrowComponent, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [[1, "grid-row"], [3, "number", "status"], [1, "margin-top-1"]], template: function FormlyFieldStepArrowComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "sds-step-arrow", 1);
            i0.ɵɵelementStart(2, "h3", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("number", ctx.props.number)("status", ctx.props.status);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.props.stepTitle);
        } }, dependencies: [i2$3.SdsStepArrowComponent], encapsulation: 2, changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyFieldStepArrowComponent, [{
        type: Component,
        args: [{
                selector: 'sds-formly-field-autocomplete',
                template: `
    <div class="grid-row">
      <sds-step-arrow [number]="props.number" [status]="props.status"></sds-step-arrow>
      <h3 class="margin-top-1">{{ props.stepTitle }}</h3>
    </div>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], () => [{ type: i0.ChangeDetectorRef }], { template: [{
            type: ViewChild,
            args: [SdsStepArrowComponent, { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormlyFieldStepArrowComponent, { className: "FormlyFieldStepArrowComponent" }); })();

const FIELD_TYPE_COMPONENTS = [
    FormlyFieldInputComponent,
    FormlyFieldCheckboxComponent,
    FormlyFieldFileInfoComponent,
    FormlyFieldRadioComponent,
    FormlyFieldSelectComponent,
    FormlyFieldTextAreaComponent,
    FormlyFieldMultiCheckboxComponent,
    FormlyWrapperFormFieldComponent,
    FormlyAccordianFormFieldComponent,
    FormlyFieldAutoCompleteComponent,
    FormlyFieldDatePickerComponent,
    FormlyFieldDateRangePickerComponent,
    FormlyFormFieldFilterWrapperComponent,
    FormlyFieldButtonComponent,
    FormlyLabelWrapperComponent,
    FormlyDescriptionWrapperComponent,
    FormlyValidationWrapperComponent,
    FormlyFieldTextComponent,
    FormlyGroupWrapperComponent,
    FormlyFieldSearchComponent,
    FormlyReadonlyWrapperComponent,
    FormlyFieldFileInputComponent,
    FormlyTabsWrapperComponent,
    FormlyFieldTableComponent,
    FormlyFieldEditorComponent,
    FormlyFieldRichTextEditorComponent,
    FormlyFieldStepArrowComponent,
];
const FORMLY_WRAPPERS = [
    {
        name: 'form-field',
        component: FormlyWrapperFormFieldComponent,
        componentName: 'FormlyWrapperFormFieldComponent',
    },
    {
        name: 'accordionwrapper',
        component: FormlyAccordianFormFieldComponent,
        componentName: 'FormlyAccordianFormFieldComponent',
    },
    {
        name: 'filterwrapper',
        component: FormlyFormFieldFilterWrapperComponent,
        componentName: 'FormlyFormFieldFilterWrapperComponent',
    },
    {
        name: 'label',
        component: FormlyLabelWrapperComponent,
        componentName: 'FormlyLabelWrapperComponent',
    },
    {
        name: 'description',
        component: FormlyDescriptionWrapperComponent,
        componentName: 'FormlyDescriptionWrapperComponent',
    },
    {
        name: 'validation',
        component: FormlyValidationWrapperComponent,
        componentName: 'FormlyValidationWrapperComponent',
    },
    {
        name: 'group',
        component: FormlyGroupWrapperComponent,
        componentName: 'FormlyGroupWrapperComponent',
    },
    {
        name: 'readonly',
        component: FormlyReadonlyWrapperComponent,
        componentName: 'FormlyReadonlyWrapperComponent',
    },
    {
        name: 'tabs',
        component: FormlyTabsWrapperComponent,
        componentName: 'FormlyTabsWrapperComponent',
    },
];
const FORMLY_CONFIG = {
    types: [
        {
            name: SdsFormlyTypes.FORMLYGROUP,
            wrappers: sdsGroupWrapper,
            defaultOptions: {
                defaultValue: {},
            },
        },
        {
            name: SdsFormlyTypes.FORMLYARRAY,
            wrappers: sdsGroupWrapper,
            defaultOptions: {
                defaultValue: {},
            },
        },
        {
            name: SdsFormlyTypes.READONLY,
            wrappers: sdsGroupWrapper,
            component: FormlyReadonlyWrapperComponent,
        },
        {
            name: SdsFormlyTypes.BUTTON,
            component: FormlyFieldButtonComponent,
        },
        {
            name: SdsFormlyTypes.CUSTOMTEXT,
            component: FormlyFieldTextComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.EDITOR,
            component: FormlyFieldEditorComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.INPUT,
            component: FormlyFieldInputComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.CHECKBOX,
            component: FormlyFieldCheckboxComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.FILEINFO,
            component: FormlyFieldFileInfoComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.RADIO,
            component: FormlyFieldRadioComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.SELECT,
            component: FormlyFieldSelectComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.TEXTAREA,
            component: FormlyFieldTextAreaComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.MULTICHECKBOX,
            component: FormlyFieldMultiCheckboxComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.AUTOCOMPLETE,
            component: FormlyFieldAutoCompleteComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.DATEPICKER,
            component: FormlyFieldDatePickerComponent,
            wrappers: sdsWrappers,
            defaultOptions: {
                validators: {
                    validation: [maxDateValidator, minDateValidator],
                },
            },
        },
        {
            name: SdsFormlyTypes.DATERANGEPICKER,
            extends: SdsFormlyTypes.FORMLYGROUP,
            wrappers: sdsWrappers,
            defaultOptions: {
                fieldGroup: [
                    {
                        type: SdsFormlyTypes.DATEPICKER,
                        key: 'fromDate',
                        props: {
                            label: 'From',
                            placeholder: 'eg: ' +
                                new Date().toLocaleString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric',
                                }),
                        },
                        expressionProperties: {
                            'props.minDate': minDateFromDateRangePicker,
                            'props.maxDate': maxDateFromDateRangePicker,
                            'props.hideOptional': getParentHideOptional,
                        },
                    },
                    {
                        type: SdsFormlyTypes.DATEPICKER,
                        key: 'toDate',
                        props: {
                            label: 'To',
                            placeholder: 'eg: ' +
                                new Date().toLocaleString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric',
                                }),
                        },
                        expressionProperties: {
                            'props.minDate': minDateToDateRangePicker,
                            'props.maxDate': maxDateToDateRangePicker,
                            'props.hideOptional': getParentHideOptional,
                        },
                    },
                ],
            },
        },
        {
            name: 'daterangepickerv2',
            component: FormlyFieldDateRangePickerComponent,
            wrappers: sdsWrappers,
            defaultOptions: {
                validators: {
                    validation: [dateRangeValidator],
                },
                fieldGroup: [
                    {
                        key: 'fromDate',
                        props: {
                            placeholder: 'eg: ' +
                                new Date().toLocaleString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric',
                                }),
                        },
                    },
                    {
                        key: 'toDate',
                        props: {
                            placeholder: new Date().toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                            }),
                        },
                    },
                ],
            },
        },
        {
            name: SdsFormlyTypes.SEARCH,
            component: FormlyFieldSearchComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.FILEINPUT,
            component: FormlyFieldFileInputComponent,
            wrappers: sdsWrappers,
        },
        {
            name: SdsFormlyTypes.TABLE,
            component: FormlyFieldTableComponent,
        },
        {
            name: SdsFormlyTypes.RICHTEXTEDITOR,
            component: FormlyFieldRichTextEditorComponent,
            wrappers: sdsWrappers,
        },
        { name: SdsFormlyTypes.STEPARROW, component: FormlyFieldStepArrowComponent, wrappers: sdsWrappers },
    ],
    wrappers: [
        { name: 'label', component: FormlyLabelWrapperComponent },
        { name: 'description', component: FormlyDescriptionWrapperComponent },
        { name: 'validation', component: FormlyValidationWrapperComponent },
        { name: 'group', component: FormlyGroupWrapperComponent },
        { name: 'form-field', component: FormlyWrapperFormFieldComponent },
        { name: 'accordionwrapper', component: FormlyAccordianFormFieldComponent },
        { name: 'filterwrapper', component: FormlyFormFieldFilterWrapperComponent },
        { name: 'readonly', component: FormlyReadonlyWrapperComponent },
        { name: 'tabs', component: FormlyTabsWrapperComponent },
    ],
};
function minDateToDateRangePicker(model, formState, field) {
    let date = null;
    //Setting a minumn date for the date range picker
    if (field.parent.props.minDate) {
        date = new Date(field.parent.props.minDate.getTime());
    }
    if (model) {
        if (model.fromDate) {
            date = model.fromDate;
        }
    }
    return date;
}
function minDateFromDateRangePicker(model, formState, field) {
    let date = null;
    //Setting a minumn date for the date range picker
    if (field.parent.props.minDate) {
        date = new Date(field.parent.props.minDate.getTime());
    }
    return date;
}
function maxDateToDateRangePicker(model, formState, field) {
    let date = null;
    //Setting a max date for the date range picker
    if (field.parent.props.maxDate) {
        date = new Date(field.parent.props.maxDate.getTime());
    }
    return date;
}
function maxDateFromDateRangePicker(model, formState, field) {
    let date = null;
    //Setting a max date for the date range picker
    if (field.parent.props.maxDate) {
        date = new Date(field.parent.props.maxDate);
    }
    if (model) {
        if (model.toDate) {
            date = model.toDate;
        }
    }
    return date;
}
function getParentHideOptional(model, formState, field) {
    if (field.parent && field.parent.props) {
        return field.parent.props.hideOptional;
    }
    return false;
}

const SlideInOutAnimation = [
    trigger('slideInOut', [
        state('in', style({
            'max-height': 'auto',
            opacity: '1',
            visibility: 'visible',
        })),
        state('out', style({
            'max-height': '0px',
            opacity: '0',
            visibility: 'hidden',
        })),
        transition('in => out', [
            group([
                animate('400ms ease-in-out', style({
                    opacity: '0',
                })),
                animate('600ms ease-in-out', style({
                    'max-height': '0px',
                })),
                animate('700ms ease-in-out', style({
                    visibility: 'hidden',
                })),
            ]),
        ]),
        transition('out => in', [
            group([
                animate('1ms ease-in-out', style({
                    visibility: 'visible',
                })),
                animate('600ms ease-in-out', style({
                    'max-height': '500px',
                })),
                animate('800ms ease-in-out', style({
                    opacity: '1',
                })),
            ]),
        ]),
    ]),
];
class AnimationWrapperComponent extends FieldWrapper {
    /** @nocollapse */ static { this.ɵfac = /** @pureOrBreakMyCode */ (() => { let ɵAnimationWrapperComponent_BaseFactory; return function AnimationWrapperComponent_Factory(t) { return (ɵAnimationWrapperComponent_BaseFactory || (ɵAnimationWrapperComponent_BaseFactory = i0.ɵɵgetInheritedFactory(AnimationWrapperComponent)))(t || AnimationWrapperComponent); }; })(); }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AnimationWrapperComponent, selectors: [["sam-formly-wrapper-animation"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["fieldComponent", ""]], template: function AnimationWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵelementContainer(1, null, 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("@slideInOut", ctx.field.hide ? "out" : "in");
        } }, encapsulation: 2, data: { animation: [SlideInOutAnimation] } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnimationWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'sam-formly-wrapper-animation',
                template: `
    <div [@slideInOut]="field.hide ? 'out' : 'in'">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
                // styles: [`
                //   ::ng-deep formly-field {
                //     display: block !important;
                //   }
                // `],
                animations: [SlideInOutAnimation],
            }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AnimationWrapperComponent, { className: "AnimationWrapperComponent" }); })();

class SdsReadonlyModule {
    /** @nocollapse */ static { this.ɵfac = function SdsReadonlyModule_Factory(t) { return new (t || SdsReadonlyModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsReadonlyModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule, FormlySelectModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsReadonlyModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormlySelectModule],
                declarations: [
                    ReadonlyInputComponent,
                    ReadonlyDatepickerComponent,
                    ReadonlySelectComponent,
                    ReadonlyRadioComponent,
                    ReadonlyAutocompleteComponent,
                    ReadonlyCheckboxComponent,
                    ReadonlyMulticheckboxComponent,
                    ReadonlyDaterangeComponent,
                    ReadonlyFileinfoComponent,
                    ReadonlyContainerComponent,
                    ReadonlyLabelDirective,
                    ReadonlyValueDirective,
                ],
                exports: [
                    ReadonlyInputComponent,
                    ReadonlyDatepickerComponent,
                    ReadonlySelectComponent,
                    ReadonlyRadioComponent,
                    ReadonlyAutocompleteComponent,
                    ReadonlyCheckboxComponent,
                    ReadonlyMulticheckboxComponent,
                    ReadonlyDaterangeComponent,
                    ReadonlyFileinfoComponent,
                    ReadonlyContainerComponent,
                    ReadonlyLabelDirective,
                    ReadonlyValueDirective,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsReadonlyModule, { declarations: [ReadonlyInputComponent,
        ReadonlyDatepickerComponent,
        ReadonlySelectComponent,
        ReadonlyRadioComponent,
        ReadonlyAutocompleteComponent,
        ReadonlyCheckboxComponent,
        ReadonlyMulticheckboxComponent,
        ReadonlyDaterangeComponent,
        ReadonlyFileinfoComponent,
        ReadonlyContainerComponent,
        ReadonlyLabelDirective,
        ReadonlyValueDirective], imports: [CommonModule, FormlySelectModule], exports: [ReadonlyInputComponent,
        ReadonlyDatepickerComponent,
        ReadonlySelectComponent,
        ReadonlyRadioComponent,
        ReadonlyAutocompleteComponent,
        ReadonlyCheckboxComponent,
        ReadonlyMulticheckboxComponent,
        ReadonlyDaterangeComponent,
        ReadonlyFileinfoComponent,
        ReadonlyContainerComponent,
        ReadonlyLabelDirective,
        ReadonlyValueDirective] }); })();

// Validate the min length of the character
function minLengthValidationMessage(err, field) {
    return `Should have at least ${field.props.minLength} characters`;
}
// Validate the max length of the character
function maxLengthValidationMessage(err, field) {
    return `This value should be less than ${field.props.maxLength} characters`;
}
// Validate the min value of the character
function minValidationMessage(err, field) {
    return `This value should be more than ${field.props.min}`;
}
function minDateValidationMessage(err, field) {
    const dt = field.props.minDate;
    const dateFormat = dt.toLocaleString('en-US', { month: 'short' }) + ', ' + dt.getDate() + ', ' + dt.getFullYear();
    return `Date must be on or after ${dateFormat}`;
}
function maxDateValidationMessage(err, field) {
    const dt = field.props.maxDate;
    const dateFormat = dt.toLocaleString('en-US', { month: 'short' }) + ' ' + dt.getDate() + ', ' + dt.getFullYear();
    return `Date must be on or before ${dateFormat}`;
}
function betweenDateValidationMessage(err, field) {
    const dtnmax = field.props.maxDate;
    const dateMaxFormat = dtnmax.toLocaleString('en-US', { month: 'short' }) + ' ' + dtnmax.getDate() + ', ' + dtnmax.getFullYear();
    const dtmin = field.props.minDate;
    const dateMinFormat = dtmin.toLocaleString('en-US', { month: 'short' }) + ' ' + dtmin.getDate() + ', ' + dtmin.getFullYear();
    return `Date must be between ${dateMinFormat} and ${dateMaxFormat} `;
}
function invalidDateFormatValidationMessage(err, field) {
    return `Valid date format required (ex: MM/DD/YYYY)`;
}
function requireOrInvalidDateFormat(err, field) {
    if (field.type === 'datepicker' &&
        field.props['invalidDateMessage'] &&
        field.formControl?.getError('matDatepickerParse')) {
        return `Valid date format required (ex: MM/DD/YYYY)`;
    }
    else {
        return 'This field is required';
    }
}
function matDatepickerMinValidationMessage(err, field) {
    const fieldWithMinDate = field.props.minDate ? field : field.parent;
    if (!fieldWithMinDate) {
        return `Please enter a valid date`;
    }
    return minDateValidationMessage(err, fieldWithMinDate);
}
function matDatepickerMaxValidationMessage(err, field) {
    const fieldWithMaxDate = field.props.maxDate ? field : field.parent;
    if (!fieldWithMaxDate) {
        return `Please enter a valid date`;
    }
    return maxDateValidationMessage(err, fieldWithMaxDate);
}
function matDateInBetweenValidationMessage(err, field) {
    const fieldWithMinDate = field.props.minDate ? field : field.parent;
    const fieldWithMaxDate = field.props.maxDate ? field : field.parent;
    if (fieldWithMinDate && !fieldWithMaxDate) {
        return minDateValidationMessage(err, fieldWithMinDate);
    }
    else if (fieldWithMaxDate && !fieldWithMinDate) {
        return maxDateValidationMessage(err, fieldWithMaxDate);
    }
    else if (fieldWithMaxDate && fieldWithMinDate) {
        return betweenDateValidationMessage(err, fieldWithMaxDate);
    }
    return `Please enter a valid date`;
}
// Validate the max value of the character
function maxValidationMessage(err, field) {
    return `This value should be less than ${field.props.max}`;
}
function animationExtension(field) {
    if (field.wrappers && field.wrappers.includes('animation')) {
        return;
    }
    field.wrappers = ['animation', ...(field.wrappers || [])];
}
const DATE_FORMAT = {
    ...MAT_NATIVE_DATE_FORMATS,
    display: {
        ...MAT_NATIVE_DATE_FORMATS.display,
        dateInput: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        },
    },
};
class SdsFormlyModule {
    static forChild(config = {}) {
        return {
            ngModule: SdsFormlyModule,
            providers: [...FormlyModule.forChild(config).providers],
        };
    }
    /** @nocollapse */ static { this.ɵfac = function SdsFormlyModule_Factory(t) { return new (t || SdsFormlyModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsFormlyModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT }], imports: [CommonModule,
            UsaAccordionModule,
            MatExpansionModule,
            SdsAutocompleteModule,
            SdsDialogModule,
            SdsSearchModule,
            SdsTextModule,
            SdsEditorModule,
            SdsCollapseModule,
            MatNativeDateModule,
            MatDatepickerModule,
            SdsTableModule,
            MatInputModule,
            IconModule,
            ReactiveFormsModule,
            FormlySelectModule,
            SdsReadonlyModule,
            FormsModule,
            UsaFileInputModule,
            SdsTooltipModule,
            SdsTableModule,
            SdsTabsModule,
            SdsPopoverModule,
            SdsRichTextModule,
            SdsStepArrowModule,
            NgxBootstrapIconsModule.pick({
                caretDownFill,
                caretUpFill,
                filter,
                arrowClockwise,
                chevronDown,
                infoCircleFill,
                calendar,
                x,
            }),
            FormlyModule.forChild(FORMLY_CONFIG),
            FormlyModule.forRoot({
                extras: {
                    checkExpressionOn: 'changeDetectionCheck',
                    lazyRender: false,
                    resetFieldOnHide: false,
                },
                validationMessages: [
                    { name: 'required', message: requireOrInvalidDateFormat },
                    { name: 'minLength', message: minLengthValidationMessage },
                    { name: 'maxLength', message: maxLengthValidationMessage },
                    { name: 'min', message: minValidationMessage },
                    { name: 'max', message: maxValidationMessage },
                    { name: 'minDate', message: minDateValidationMessage },
                    { name: 'maxDate', message: maxDateValidationMessage },
                    { name: 'betweenDate', message: betweenDateValidationMessage },
                    {
                        name: 'matDatepickerParse',
                        message: invalidDateFormatValidationMessage,
                    }, // Comes from the datepicker
                    {
                        name: 'matDatepickerMin',
                        message: matDatepickerMinValidationMessage,
                    }, // Comes from the datepicker
                    {
                        name: 'matStartDateInvalid',
                        message: matDateInBetweenValidationMessage,
                    }, // Comes from the datepicker
                    {
                        name: 'matDatepickerMax',
                        message: matDatepickerMaxValidationMessage,
                    }, // Comes from the datepicker
                ],
                validators: [
                    { name: 'minDate', validation: minDateValidator },
                    { name: 'maxDate', validation: maxDateValidator },
                    { name: 'dateRangeValidator', validation: dateRangeValidator },
                    { name: 'requiredTrue', validation: Validators.requiredTrue },
                ],
                wrappers: [{ name: 'animation', component: AnimationWrapperComponent }],
                extensions: [{ name: 'animation', extension: { onPopulate: animationExtension } }],
            })] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsFormlyModule, [{
        type: NgModule,
        args: [{
                declarations: [FIELD_TYPE_COMPONENTS, AnimationWrapperComponent],
                imports: [
                    CommonModule,
                    UsaAccordionModule,
                    MatExpansionModule,
                    SdsAutocompleteModule,
                    SdsDialogModule,
                    SdsSearchModule,
                    SdsTextModule,
                    SdsEditorModule,
                    SdsCollapseModule,
                    MatNativeDateModule,
                    MatDatepickerModule,
                    SdsTableModule,
                    MatInputModule,
                    IconModule,
                    ReactiveFormsModule,
                    FormlySelectModule,
                    SdsReadonlyModule,
                    FormsModule,
                    UsaFileInputModule,
                    SdsTooltipModule,
                    SdsTableModule,
                    SdsTabsModule,
                    SdsPopoverModule,
                    SdsRichTextModule,
                    SdsStepArrowModule,
                    NgxBootstrapIconsModule.pick({
                        caretDownFill,
                        caretUpFill,
                        filter,
                        arrowClockwise,
                        chevronDown,
                        infoCircleFill,
                        calendar,
                        x,
                    }),
                    FormlyModule.forChild(FORMLY_CONFIG),
                    FormlyModule.forRoot({
                        extras: {
                            checkExpressionOn: 'changeDetectionCheck',
                            lazyRender: false,
                            resetFieldOnHide: false,
                        },
                        validationMessages: [
                            { name: 'required', message: requireOrInvalidDateFormat },
                            { name: 'minLength', message: minLengthValidationMessage },
                            { name: 'maxLength', message: maxLengthValidationMessage },
                            { name: 'min', message: minValidationMessage },
                            { name: 'max', message: maxValidationMessage },
                            { name: 'minDate', message: minDateValidationMessage },
                            { name: 'maxDate', message: maxDateValidationMessage },
                            { name: 'betweenDate', message: betweenDateValidationMessage },
                            {
                                name: 'matDatepickerParse',
                                message: invalidDateFormatValidationMessage,
                            }, // Comes from the datepicker
                            {
                                name: 'matDatepickerMin',
                                message: matDatepickerMinValidationMessage,
                            }, // Comes from the datepicker
                            {
                                name: 'matStartDateInvalid',
                                message: matDateInBetweenValidationMessage,
                            }, // Comes from the datepicker
                            {
                                name: 'matDatepickerMax',
                                message: matDatepickerMaxValidationMessage,
                            }, // Comes from the datepicker
                        ],
                        validators: [
                            { name: 'minDate', validation: minDateValidator },
                            { name: 'maxDate', validation: maxDateValidator },
                            { name: 'dateRangeValidator', validation: dateRangeValidator },
                            { name: 'requiredTrue', validation: Validators.requiredTrue },
                        ],
                        wrappers: [{ name: 'animation', component: AnimationWrapperComponent }],
                        extensions: [{ name: 'animation', extension: { onPopulate: animationExtension } }],
                    }),
                ],
                providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT }],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsFormlyModule, { declarations: [FormlyFieldInputComponent, FormlyFieldCheckboxComponent, FormlyFieldFileInfoComponent, FormlyFieldRadioComponent, FormlyFieldSelectComponent, FormlyFieldTextAreaComponent, FormlyFieldMultiCheckboxComponent, FormlyWrapperFormFieldComponent, FormlyAccordianFormFieldComponent, FormlyFieldAutoCompleteComponent, FormlyFieldDatePickerComponent, FormlyFieldDateRangePickerComponent, FormlyFormFieldFilterWrapperComponent, FormlyFieldButtonComponent, FormlyLabelWrapperComponent, FormlyDescriptionWrapperComponent, FormlyValidationWrapperComponent, FormlyFieldTextComponent, FormlyGroupWrapperComponent, FormlyFieldSearchComponent, FormlyReadonlyWrapperComponent, FormlyFieldFileInputComponent, FormlyTabsWrapperComponent, FormlyFieldTableComponent, FormlyFieldEditorComponent, FormlyFieldRichTextEditorComponent, FormlyFieldStepArrowComponent, AnimationWrapperComponent], imports: [CommonModule,
        UsaAccordionModule,
        MatExpansionModule,
        SdsAutocompleteModule,
        SdsDialogModule,
        SdsSearchModule,
        SdsTextModule,
        SdsEditorModule,
        SdsCollapseModule,
        MatNativeDateModule,
        MatDatepickerModule,
        SdsTableModule,
        MatInputModule,
        IconModule,
        ReactiveFormsModule,
        FormlySelectModule,
        SdsReadonlyModule,
        FormsModule,
        UsaFileInputModule,
        SdsTooltipModule,
        SdsTableModule,
        SdsTabsModule,
        SdsPopoverModule,
        SdsRichTextModule,
        SdsStepArrowModule, i1$1.NgxBootstrapIconsModule, i3.FormlyModule, i3.FormlyModule] }); })();

class SdsFormlyResetComponent {
    constructor() {
        /**
         * Pass in classes for reset button -- default .usa-button .usa-button--unstyled
         */
        this.classes = ['usa-button', 'usa-button--unstyled'];
        this.resetClicked = new EventEmitter();
    }
    resetAll() {
        if (this.defaultModel) {
            this.options.resetModel(this.defaultModel);
        }
        else {
            this.options.resetModel();
        }
        this.resetClicked.emit();
    }
    /** @nocollapse */ static { this.ɵfac = function SdsFormlyResetComponent_Factory(t) { return new (t || SdsFormlyResetComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsFormlyResetComponent, selectors: [["sds-formly-reset"]], inputs: { options: "options", defaultModel: "defaultModel", classes: "classes" }, outputs: { resetClicked: "resetClicked" }, decls: 3, vars: 3, consts: [[3, "click", "ngClass"], [1, "icon-reset", 3, "icon", "size"]], template: function SdsFormlyResetComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function SdsFormlyResetComponent_Template_button_click_0_listener() { return ctx.resetAll(); });
            i0.ɵɵtext(1, " Reset ");
            i0.ɵɵelement(2, "usa-icon", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.classes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("icon", "arrow-clockwise")("size", "sm");
        } }, dependencies: [i1.NgClass, i2$1.IconComponent], styles: [".usa-button--unstyled[_ngcontent-%COMP%]{padding-right:0;width:initial;text-decoration:none;font-weight:600}.usa-button--unstyled[_ngcontent-%COMP%]:hover, .usa-button--unstyled[_ngcontent-%COMP%]:active{background:transparent;background:initial;color:initial;text-decoration:underline}.icon-reset[_ngcontent-%COMP%]{font-size:20px}button[_ngcontent-%COMP%]{display:inline-flex}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsFormlyResetComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-reset', template: "<button (click)=\"resetAll()\" [ngClass]=\"classes\">\n  Reset\n  <usa-icon [icon]=\"'arrow-clockwise'\" class=\"icon-reset\" [size]=\"'sm'\"></usa-icon>\n</button>\n", styles: [".usa-button--unstyled{padding-right:0;width:initial;text-decoration:none;font-weight:600}.usa-button--unstyled:hover,.usa-button--unstyled:active{background:transparent;background:initial;color:initial;text-decoration:underline}.icon-reset{font-size:20px}button{display:inline-flex}\n"] }]
    }], null, { options: [{
            type: Input
        }], defaultModel: [{
            type: Input
        }], classes: [{
            type: Input
        }], resetClicked: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsFormlyResetComponent, { className: "SdsFormlyResetComponent" }); })();

class SdsFormlyResetModule {
    /** @nocollapse */ static { this.ɵfac = function SdsFormlyResetModule_Factory(t) { return new (t || SdsFormlyResetModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsFormlyResetModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, NgxBootstrapIconsModule.pick({ arrowClockwise })] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsFormlyResetModule, [{
        type: NgModule,
        args: [{
                declarations: [SdsFormlyResetComponent],
                imports: [CommonModule, IconModule, NgxBootstrapIconsModule.pick({ arrowClockwise })],
                exports: [SdsFormlyResetComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsFormlyResetModule, { declarations: [SdsFormlyResetComponent], imports: [CommonModule, IconModule, i1$1.NgxBootstrapIconsModule], exports: [SdsFormlyResetComponent] }); })();

class FormlyUtilsService {
    /**
     * Set readonly mode of a formly field config list. Toggles all field config with defined
     * props property's readonlyMode to given value
     * @param readonlyMode - if true, readonly mode will be turned on, if false, readonly mode will be turned off
     * @param fields - The list of fields to toggle readonly mode on
     */
    static setReadonlyMode(readonlyMode, fields) {
        fields.forEach((field) => {
            this._setReadonlyMode(readonlyMode, field);
        });
    }
    /**
     * Parses a formly field config and returns a list of items that readonly container component would accept.
     * This is used when you have field configs and the model, but would like to use components for readonly display
     * rather than formly. props must be defined for the field in order to convert.
     * @param fields - The list of fields to parse
     * @param model - Contains the values for given fields
     * @param options - Additional cofiguration options
     * options:
     *  convertAll - By default any fields with a type not in SdsFormlyType will be ignored.
     *               Turn this on to include fields with no type or type not in SdsFormlyType.
     */
    static formlyConfigToReadonlyData(fields, model, options = { convertAll: false }) {
        const readonlyData = [];
        fields.forEach((field) => {
            this, this._formlyConfigToReadonlyData(field, model, readonlyData, options);
        });
        return readonlyData;
    }
    static _setReadonlyMode(readonlyMode, field) {
        if (field.fieldGroup) {
            field.fieldGroup.forEach((innerField) => {
                this._setReadonlyMode(readonlyMode, innerField);
            });
        }
        if (field.props && field.type && Object.values(SdsFormlyTypes).includes(field.type)) {
            field.props.readonlyMode = readonlyMode;
        }
    }
    static _formlyConfigToReadonlyData(field, model, readonlyData, options) {
        if (field.props && (options.convertAll || Object.values(SdsReadonlyTypes).includes(field.type))) {
            const label = field.props.label;
            const value = model[field.key];
            const readonlyOptions = {
                providedOptions: field.props.options,
                autocompleteOptions: field.props.configuration,
            };
            readonlyData.push({
                formlyType: field.type,
                label,
                value,
                readonlyOptions,
                formlyKey: field.key,
            });
            if (field.type === SdsFormlyTypes.DATERANGEPICKER || field.type === SdsFormlyTypes.DATERANGEPICKERV2) {
                readonlyOptions.daterangepickerOptions = {
                    fromDateKey: field.fieldGroup[0].key,
                    toDateKey: field.fieldGroup[1].key,
                };
                return;
            }
        }
        if (field.fieldGroup) {
            const innerModel = field.key ? model[field.key] : model;
            field.fieldGroup.forEach((innerField) => {
                this._formlyConfigToReadonlyData(innerField, innerModel, readonlyData, options);
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = function FormlyUtilsService_Factory(t) { return new (t || FormlyUtilsService)(); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: FormlyUtilsService, factory: FormlyUtilsService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormlyUtilsService, [{
        type: Injectable
    }], null, null); })();

class SDSFormlyUpdateComunicationService {
    constructor() {
        this.updateFilterSource = new Subject();
        /**
         * Observable to subscribe to for get updates of the filter
         */
        this.filterUpdate = this.updateFilterSource.asObservable();
    }
    /**
     * Update the filter
     * @param filterData
     */
    updateFilter(filterData) {
        this.updateFilterSource.next(filterData);
    }
    /** @nocollapse */ static { this.ɵfac = function SDSFormlyUpdateComunicationService_Factory(t) { return new (t || SDSFormlyUpdateComunicationService)(); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: SDSFormlyUpdateComunicationService, factory: SDSFormlyUpdateComunicationService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SDSFormlyUpdateComunicationService, [{
        type: Injectable
    }], null, null); })();

class SDSFormlyUpdateModelService {
    constructor() {
        /**
         * Filter update subject - This is a BehaviorSubject in case layout
         * component initializes and fires a filter model event before
         * sds-filters subscribes.
         */
        this.updateFilterModel = new BehaviorSubject(null);
        /**
         * Observable to subscribe to for get updates of the filter
         */
        this.filterModel = this.updateFilterModel.asObservable();
    }
    /**
     * Update the filter
     * @param filterData
     */
    updateModel(filterData) {
        this.updateFilterModel.next(filterData);
    }
}

class SdsAdvancedFiltersService {
    constructor() { }
    convertToCheckboxes(origFields, hideChildrenGroups = false) {
        const fields = [];
        origFields.forEach((origField) => {
            const defaultValue = [];
            if (origField.fieldGroup?.length && !hideChildrenGroups && !origField.props?.hideChildrenGroups) {
                const field = this.createMulticheckbox(origField, defaultValue);
                fields.push(field);
                // this.convertToCheckboxes(origField.fieldGroup, hideChildrenGroups);
            }
            else {
                if (origField.key) {
                    const field = {
                        type: 'checkbox',
                        key: origField.key,
                        defaultValue: !origField.hide,
                        props: {
                            hideOptional: true,
                        },
                    };
                    if (origField.props && origField.props.label) {
                        field.props.label = origField.props.label;
                    }
                    fields.push(field);
                }
            }
        });
        return fields;
    }
    // TODO: Should be changed so option has label field instead of key but multicheckbox field type must be updated so default value still works
    createMulticheckbox(origField, defaultValue) {
        const options = [];
        if (origField.fieldGroup?.length && origField.key) {
            origField.fieldGroup.forEach((field) => {
                if (field.fieldGroup?.length) {
                    options.push(this.createMulticheckbox(field, defaultValue));
                }
                else {
                    const label = field.props && field.props.label ? field.props.label : null;
                    const option = {
                        value: field.key,
                        label: label,
                        tagText: field.props.tagText,
                        tagClass: field.props.tagClass,
                    };
                    options.push(option);
                    if (!origField.hide && !field.hide) {
                        defaultValue.push(field.key);
                        // defaultValue.push(origField.key);
                    }
                }
            });
        }
        const field = {
            key: origField.key,
            type: 'multicheckbox',
            props: {
                hideOptional: true,
                selectAllOption: true,
                type: 'array',
                options: options,
            },
        };
        if (origField.props && origField.props.label) {
            field.props.label = origField.props.label;
        }
        if (!origField.hide) {
            field.defaultValue = defaultValue;
        }
        return field;
    }
    updateFields(selectedFields, fields, model) {
        fields.forEach((field) => {
            const key = field.key;
            let selectedField = selectedFields['filterToggle']['filters'][key];
            if (field.fieldGroup && field.fieldGroup.length > 1) {
                const fieldModel = model[key];
                this.updateFieldGroup(field, selectedField, fieldModel);
            }
            else {
                if (Array.isArray(selectedField)) {
                    if (selectedField.length > 0) {
                        this.updateSingleField(field, true, model);
                    }
                    else {
                        this.updateSingleField(field, false, model);
                    }
                }
                else {
                    this.updateSingleField(field, selectedField, model);
                }
            }
        });
        return {
            fields: fields,
            model: model,
        };
    }
    updateFieldGroup(parentField, selectedFields, model) {
        if (selectedFields && (selectedFields.length || typeof selectedFields === 'boolean')) {
            parentField.hide = false;
            if (selectedFields === true || selectedFields.length) {
                parentField.fieldGroup.forEach((field) => {
                    const key = field.key;
                    const fieldSelected = selectedFields.length ? selectedFields.includes(key) : field;
                    this.updateSingleField(field, fieldSelected, model);
                    if (field.fieldGroup && field.fieldGroup.length > 1) {
                        this.updateFieldGroup(field, selectedFields, model);
                    }
                });
            }
        }
        else {
            parentField.hide = true;
            parentField.fieldGroup.forEach((field) => {
                this.updateSingleField(field, false, model);
            });
        }
    }
    updateSingleField(field, fieldSelected, model) {
        if (fieldSelected) {
            field.hide = false;
        }
        else {
            field.hide = true;
            field.props = {
                ...field.props,
                required: false,
            };
            if (field.formControl) {
                field.formControl.reset();
            }
            else {
                model[field.key] = null;
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = function SdsAdvancedFiltersService_Factory(t) { return new (t || SdsAdvancedFiltersService)(); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: SdsAdvancedFiltersService, factory: SdsAdvancedFiltersService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsAdvancedFiltersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [], null); })();

function SdsFormlyDialogComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.title);
} }
function SdsFormlyDialogComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.subtitle);
} }
class SdsFormlyDialogComponent {
    constructor(advancedFiltersService, cdr, dialogRef, data) {
        this.advancedFiltersService = advancedFiltersService;
        this.cdr = cdr;
        this.dialogRef = dialogRef;
        this.data = data;
        this.submitFn = new EventEmitter();
        this.cancelFn = new EventEmitter();
        this.onChangeFn = new EventEmitter();
    }
    ngOnInit() {
        this.fields = this.data.fields;
        this.form = this.data.form ? this.data.form : new UntypedFormGroup({});
        this.model = this.data.model ? this.data.model : {};
        this.options = this.data.options ? this.data.options : {};
        this.cancel = this.data.cancel ? this.data.cancel : 'Cancel';
        this.submit = this.data.submit ? this.data.submit : 'Submit';
        this.disableSubmitButton = this.data.disableSubmitButtonEnabled ? this.data.disableSubmitButtonEnabled : false;
    }
    onModelChange() {
        this.onChangeFn.emit(this.model);
    }
    onSubmit() {
        this.submitFn.emit(this.model);
    }
    onCancel() {
        this.options.resetModel();
        this.cancelFn.emit(this.model);
    }
    /** @nocollapse */ static { this.ɵfac = function SdsFormlyDialogComponent_Factory(t) { return new (t || SdsFormlyDialogComponent)(i0.ɵɵdirectiveInject(SdsAdvancedFiltersService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$3.SdsDialogRef), i0.ɵɵdirectiveInject(SDS_DIALOG_DATA)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsFormlyDialogComponent, selectors: [["sds-formly-dialog"]], outputs: { submitFn: "submitFn", cancelFn: "cancelFn", onChangeFn: "onChangeFn" }, decls: 10, vars: 10, consts: [[3, "ngSubmit", "formGroup"], ["sds-dialog-title", "", 4, "ngIf"], ["sds-dialog-subtitle", "", 4, "ngIf"], ["sds-dialog-content", "", 1, "padding-bottom-1"], [3, "modelChange", "form", "fields", "options", "model"], ["sds-dialog-actions", ""], ["type", "button", 1, "usa-button", "usa-button--base", "bg-base-lighter", 3, "click"], ["type", "submit", 1, "usa-button", 3, "disabled"], ["sds-dialog-title", ""], ["sds-dialog-subtitle", ""]], template: function SdsFormlyDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵlistener("ngSubmit", function SdsFormlyDialogComponent_Template_form_ngSubmit_0_listener() { return ctx.onSubmit(); });
            i0.ɵɵtemplate(1, SdsFormlyDialogComponent_div_1_Template, 2, 1, "div", 1)(2, SdsFormlyDialogComponent_div_2_Template, 2, 1, "div", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "formly-form", 4);
            i0.ɵɵtwoWayListener("modelChange", function SdsFormlyDialogComponent_Template_formly_form_modelChange_4_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.model, $event) || (ctx.model = $event); return $event; });
            i0.ɵɵlistener("modelChange", function SdsFormlyDialogComponent_Template_formly_form_modelChange_4_listener() { return ctx.onModelChange(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 5)(6, "button", 6);
            i0.ɵɵlistener("click", function SdsFormlyDialogComponent_Template_button_click_6_listener() { return ctx.onCancel(); });
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 7);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.subtitle);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("form", ctx.form)("fields", ctx.fields)("options", ctx.options);
            i0.ɵɵtwoWayProperty("model", ctx.model);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.cancel, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disableSubmitButton);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.submit, " ");
        } }, dependencies: [i1.NgIf, i2$3.SdsDialogTitleDirective, i2$3.SdsDialogSubtitleDirective, i2$3.SdsDialogContentDirective, i2$3.SdsDialogActionsDirective, i2$2.ɵNgNoValidate, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i3.FormlyForm], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsFormlyDialogComponent, [{
        type: Component,
        args: [{ selector: 'sds-formly-dialog', template: "<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\">\n  <div *ngIf=\"data.title\" sds-dialog-title>{{ data.title }}</div>\n  <div *ngIf=\"data.subtitle\" sds-dialog-subtitle>{{ data.subtitle }}</div>\n  <div sds-dialog-content class=\"padding-bottom-1\">\n    <formly-form\n      [form]=\"form\"\n      [fields]=\"fields\"\n      [options]=\"options\"\n      [(model)]=\"model\"\n      (modelChange)=\"onModelChange()\"\n    ></formly-form>\n  </div>\n  <div sds-dialog-actions>\n    <button class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"onCancel()\" type=\"button\">\n      {{ cancel }}\n    </button>\n    <button class=\"usa-button\" [disabled]=\"disableSubmitButton\" type=\"submit\">\n      {{ submit }}\n    </button>\n  </div>\n</form>\n" }]
    }], () => [{ type: SdsAdvancedFiltersService }, { type: i0.ChangeDetectorRef }, { type: i2$3.SdsDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [SDS_DIALOG_DATA]
            }] }], { submitFn: [{
            type: Output
        }], cancelFn: [{
            type: Output
        }], onChangeFn: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsFormlyDialogComponent, { className: "SdsFormlyDialogComponent" }); })();

function AdvancedFiltersComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function AdvancedFiltersComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openDialog()); });
    i0.ɵɵtext(1, " More Filters ");
    i0.ɵɵelement(2, "usa-icon", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", "filter")("size", "sm");
} }
function AdvancedFiltersComponent_div_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 7)(1, "formly-form", 8);
    i0.ɵɵlistener("modelChange", function AdvancedFiltersComponent_div_1_ng_template_3_Template_formly_form_modelChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.updateSelectedFields($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("fields", ctx_r1.popoverContent);
} }
function AdvancedFiltersComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " More Filters ");
    i0.ɵɵelement(2, "usa-icon", 6);
    i0.ɵɵtemplate(3, AdvancedFiltersComponent_div_1_ng_template_3_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r4 = i0.ɵɵreference(4);
    i0.ɵɵproperty("sdsPopover", content_r4)("position", "bottom")("autoClose", "outside");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", "chevron-down")("size", "sm");
} }
class AdvancedFiltersComponent {
    constructor(dialog, advancedFiltersService, cdr) {
        this.dialog = dialog;
        this.advancedFiltersService = advancedFiltersService;
        this.cdr = cdr;
        /**
         *    Options for the form.
         */
        this.options = {};
        /**
         * Sort the filters by alphabetical order
         */
        this.sortMoreFilterBy = '';
        /**
         * Show option to include inactive filter values
         */
        this.isInactiveValueFieldShown = false;
        /**
         * Defines whether additional filters should be displayed through a popover or
         * a modal
         */
        this.enablePopover = false;
        this.showInactiveFiltersChange = new EventEmitter();
        this.selectAll = false;
        this.showInactiveOnOpen = false;
        this.showInactive = false;
        this.filtersFieldGroupKey = 'filters';
    }
    ngOnInit() {
        if (!this.enablePopover) {
            return;
        }
        this.popoverContent = this.getCheckboxFieldConfigs(true);
    }
    onSelectAllChange(selectAllValue, selectedform, isOnload, selectAllField) {
        const modalFields = this.advancedFiltersService.convertToCheckboxes(this.fields);
        const keys = Object.keys(selectedform.get(this.filtersFieldGroupKey).controls);
        if (!isOnload) {
            this.selectAll = selectAllValue;
            keys.forEach((key) => {
                if (key !== 'selectAll' && key !== 'showInactive') {
                    let currentField = modalFields.find((item) => item.key === key);
                    if (currentField.key === key && currentField.type === 'checkbox') {
                        selectedform.get(this.filtersFieldGroupKey).get(key).setValue(this.selectAll);
                    }
                    else if (currentField.type === 'multicheckbox') {
                        const array = [];
                        if (this.selectAll) {
                            currentField.props.options.forEach((option) => {
                                array.push(option.value);
                                if (option.type === 'multicheckbox') {
                                    option.props.options.forEach((option) => {
                                        array.push(option.value);
                                    });
                                }
                            });
                            selectedform.get(this.filtersFieldGroupKey).get(key).setValue(array);
                            this.cdr.detectChanges();
                        }
                        else {
                            if (this.enablePopover) {
                                selectedform.get(this.filtersFieldGroupKey).get(key).setValue(false);
                            }
                            else {
                                selectedform.get(this.filtersFieldGroupKey).get(key).setValue([]);
                            }
                        }
                    }
                }
            });
        }
        else {
            const allValues = [];
            keys.forEach((key) => {
                if (key !== 'selectAll') {
                    let currentField = modalFields.find((item) => item.key === key);
                    let val;
                    if (Array.isArray(selectedform.get(this.filtersFieldGroupKey).get(key).value)) {
                        val = selectedform.get(this.filtersFieldGroupKey).get(key).value.length > 0 ? true : false;
                    }
                    else {
                        val = selectedform.get(this.filtersFieldGroupKey).get(key).value;
                    }
                    if (!allValues.includes(val)) {
                        allValues.push(val);
                    }
                }
            });
            allValues.length === 1
                ? selectedform.get('selectAll').setValue(allValues[0])
                : selectedform.get('selectAll').setValue(false);
            this.cdr.detectChanges();
        }
    }
    onShowInactiveChange(value) {
        this.showInactiveFiltersChange.emit(value);
    }
    openDialog() {
        const checkboxFieldConfigs = this.getCheckboxFieldConfigs();
        const data = {
            fields: checkboxFieldConfigs,
            submit: 'Update',
            title: 'More Filters',
        };
        const dialogRef = this.dialog.open(SdsFormlyDialogComponent, {
            width: 'medium',
            data: data,
        });
        dialogRef.componentInstance.submitFn.subscribe((result) => {
            if (result) {
                this.updateSelectedFields(result);
            }
            dialogRef.close();
        });
        dialogRef.componentInstance.onChangeFn.subscribe((result) => {
            if (result &&
                dialogRef.componentInstance.model['filterToggle']['selectAll'] !== undefined &&
                this.selectAll != result['filterToggle']['selectAll']) {
                const newModel = {};
                this.selectAll = result['filterToggle']['selectAll'];
                const modalFields = this.advancedFiltersService.convertToCheckboxes(this.fields);
                const keys = modalFields.map(function (el) {
                    return el.key;
                });
                keys.forEach((key) => {
                    if (key !== 'selectAll' && key !== 'showInactive') {
                        let currentField = modalFields.find((item) => item.key === key);
                        if (currentField.key === key && currentField.type === 'checkbox') {
                            newModel[key] = this.selectAll;
                        }
                        else if (currentField.type === 'multicheckbox') {
                            const array = [];
                            if (this.selectAll) {
                                currentField.props.options.forEach((option) => {
                                    array.push(option.value);
                                    if (option.type === 'multicheckbox') {
                                        option.props.options.forEach((option) => {
                                            array.push(option.value);
                                        });
                                    }
                                });
                                newModel[key] = array;
                            }
                            else {
                                if (this.enablePopover) {
                                    newModel[key] = false;
                                }
                                else {
                                    newModel[key] = [];
                                }
                            }
                        }
                    }
                });
                const newFModel = { filterToggle: { filters: newModel, selectAll: result['filterToggle']['selectAll'] } };
                dialogRef.componentInstance.model = { ...dialogRef.componentInstance.model, ...newFModel };
                this.cdr.detectChanges();
            }
        });
        dialogRef.componentInstance.cancelFn.subscribe(() => {
            dialogRef.close();
        });
    }
    updateSelectedFields(result) {
        if (this.showInactiveOnOpen !== this.showInactive) {
            this.onShowInactiveChange(this.showInactive);
            this.showInactiveOnOpen = this.showInactive;
        }
        const response = this.advancedFiltersService.updateFields(result, this.fields, this.model);
        this.fields = response.fields;
        this.model = response.model;
    }
    getCheckboxFieldConfigs(hideChildrenGroups = false) {
        const modalFields = this.advancedFiltersService.convertToCheckboxes(this.fields, hideChildrenGroups);
        if (this.sortMoreFilterBy) {
            modalFields.sort((a, b) => a.props && b.props ? a.props[this.sortMoreFilterBy].localeCompare(b.props[this.sortMoreFilterBy]) : 0);
        }
        const filedGroup = this.filedGroup;
        const showInactiveGroup = this.showInactiveGroup;
        let updateField = [
            {
                key: 'filterToggle',
                fieldGroup: [
                    ...filedGroup,
                    {
                        key: this.filtersFieldGroupKey,
                        fieldGroup: [...modalFields],
                    },
                ],
            },
        ];
        if (this.isInactiveValueFieldShown) {
            updateField.push(...showInactiveGroup);
        }
        return updateField;
    }
    get filedGroup() {
        return [
            {
                props: { label: 'test' },
                fieldGroup: [
                    {
                        key: 'selectAll',
                        type: 'checkbox',
                        props: {
                            label: 'Select All',
                            hideOptional: true,
                            id: 'moreFilterSelectAll',
                        },
                    },
                    {
                        template: '<hr/>',
                    },
                ],
            },
        ];
    }
    get showInactiveGroup() {
        return [
            {
                template: '<hr/>',
            },
            {
                fieldGroup: [
                    {
                        key: 'showInactive',
                        type: 'checkbox',
                        defaultValue: this.showInactive,
                        props: {
                            label: 'Show Inactive Filter Values (Indicated by *)',
                            hideOptional: true,
                            id: 'moreFilterSelectAll',
                            textAlignEnd: true,
                        },
                        hooks: {
                            onInit: (field) => {
                                let isOnload = true;
                                const form = field.parent.formControl;
                                form
                                    .get('showInactive')
                                    .valueChanges.pipe(startWith(form.get('showInactive').value), tap((showInactiveValue) => {
                                    this.showInactive = showInactiveValue;
                                    isOnload = false;
                                }))
                                    .subscribe();
                            },
                        },
                    },
                ],
            },
        ];
    }
    /** @nocollapse */ static { this.ɵfac = function AdvancedFiltersComponent_Factory(t) { return new (t || AdvancedFiltersComponent)(i0.ɵɵdirectiveInject(i2$3.SdsDialogService), i0.ɵɵdirectiveInject(SdsAdvancedFiltersService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AdvancedFiltersComponent, selectors: [["sds-advanced-filters"]], inputs: { form: "form", fields: "fields", model: "model", options: "options", sortMoreFilterBy: "sortMoreFilterBy", isInactiveValueFieldShown: "isInactiveValueFieldShown", enablePopover: "enablePopover" }, outputs: { showInactiveFiltersChange: "showInactiveFiltersChange" }, decls: 2, vars: 2, consts: [["content", ""], ["type", "button", "class", "usa-button usa-button--unstyled", 3, "click", 4, "ngIf"], ["tabindex", "0", "aria-label", "More Filters", 3, "sdsPopover", "position", "autoClose", 4, "ngIf"], ["type", "button", 1, "usa-button", "usa-button--unstyled", 3, "click"], [1, "icon-filter", 3, "icon", "size"], ["tabindex", "0", "aria-label", "More Filters", 3, "sdsPopover", "position", "autoClose"], [3, "icon", "size"], [1, "padding-2", "text-left", "minw-card-lg"], [3, "modelChange", "fields"]], template: function AdvancedFiltersComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, AdvancedFiltersComponent_button_0_Template, 3, 2, "button", 1)(1, AdvancedFiltersComponent_div_1_Template, 5, 5, "div", 2);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.enablePopover);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.enablePopover);
        } }, dependencies: [i1.NgIf, i2$1.IconComponent, i3.FormlyForm, i2$3.SdsPopover], styles: [".usa-button--unstyled[_ngcontent-%COMP%]{padding-left:0;width:initial;text-decoration:none;font-weight:600}.usa-button--unstyled[_ngcontent-%COMP%]:hover, .usa-button--unstyled[_ngcontent-%COMP%]:active{background:transparent;background:initial;color:initial;text-decoration:underline}.icon-filter[_ngcontent-%COMP%]{font-size:20px}"], changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AdvancedFiltersComponent, [{
        type: Component,
        args: [{ selector: 'sds-advanced-filters', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button *ngIf=\"!enablePopover\" type=\"button\" (click)=\"openDialog()\" class=\"usa-button usa-button--unstyled\">\n  More Filters\n  <usa-icon [icon]=\"'filter'\" class=\"icon-filter\" [size]=\"'sm'\"></usa-icon>\n</button>\n\n<div\n  *ngIf=\"enablePopover\"\n  [sdsPopover]=\"content\"\n  [position]=\"'bottom'\"\n  [autoClose]=\"'outside'\"\n  tabindex=\"0\"\n  aria-label=\"More Filters\"\n>\n  More Filters\n  <usa-icon [icon]=\"'chevron-down'\" [size]=\"'sm'\"></usa-icon>\n  <ng-template #content>\n    <p class=\"padding-2 text-left minw-card-lg\">\n      <formly-form [fields]=\"popoverContent\" (modelChange)=\"updateSelectedFields($event)\"></formly-form>\n    </p>\n  </ng-template>\n</div>\n", styles: [".usa-button--unstyled{padding-left:0;width:initial;text-decoration:none;font-weight:600}.usa-button--unstyled:hover,.usa-button--unstyled:active{background:transparent;background:initial;color:initial;text-decoration:underline}.icon-filter{font-size:20px}\n"] }]
    }], () => [{ type: i2$3.SdsDialogService }, { type: SdsAdvancedFiltersService }, { type: i0.ChangeDetectorRef }], { form: [{
            type: Input
        }], fields: [{
            type: Input
        }], model: [{
            type: Input
        }], options: [{
            type: Input
        }], sortMoreFilterBy: [{
            type: Input
        }], isInactiveValueFieldShown: [{
            type: Input
        }], enablePopover: [{
            type: Input
        }], showInactiveFiltersChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AdvancedFiltersComponent, { className: "AdvancedFiltersComponent" }); })();

const _c0$1 = ["horizontalFiltersDialog"];
const _c1$1 = [[["sds-search"]]];
const _c2$1 = ["sds-search"];
const _c3$1 = a0 => [a0];
const _c4$1 = () => ({});
function SdsFiltersComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "sds-advanced-filters", 10);
    i0.ɵɵlistener("showInactiveFiltersChange", function SdsFiltersComponent_div_0_div_3_Template_sds_advanced_filters_showInactiveFiltersChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showInactiveFiltersChange.next($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("sortMoreFilterBy", ctx_r1.sortMoreFilterBy)("fields", ctx_r1.fields)("options", ctx_r1.options)("model", ctx_r1.model)("isInactiveValueFieldShown", ctx_r1.isInactiveValueFieldShown);
} }
function SdsFiltersComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "formly-form", 4);
    i0.ɵɵlistener("modelChange", function SdsFiltersComponent_div_0_Template_formly_form_modelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onModelChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, SdsFiltersComponent_div_0_div_3_Template, 2, 6, "div", 6);
    i0.ɵɵelementStart(4, "div", 7)(5, "sds-formly-reset", 8);
    i0.ɵɵlistener("resetClicked", function SdsFiltersComponent_div_0_Template_sds_formly_reset_resetClicked_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onResetClicked()); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("fields", ctx_r1.fields)("options", ctx_r1.options)("model", ctx_r1.model);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.advancedFilters);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", ctx_r1.options)("defaultModel", ctx_r1.defaultModel);
} }
function SdsFiltersComponent_div_1_div_2_div_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 22)(1, "formly-form", 23);
    i0.ɵɵlistener("modelChange", function SdsFiltersComponent_div_1_div_2_div_1_ng_template_3_Template_formly_form_modelChange_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onModelChange($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const field_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.options)("form", ctx_r1.form)("model", ctx_r1.model)("fields", i0.ɵɵpureFunction1(4, _c3$1, field_r6));
} }
function SdsFiltersComponent_div_1_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "usa-icon", 21);
    i0.ɵɵtemplate(3, SdsFiltersComponent_div_1_div_2_div_1_ng_template_3_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r7 = i0.ɵɵreference(4);
    const field_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("sdsPopover", content_r7)("position", "bottom")("autoClose", "outside");
    i0.ɵɵattribute("aria-label", field_r6.props.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", field_r6.props.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "chevron-down")("size", "sm");
} }
function SdsFiltersComponent_div_1_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "formly-form", 23);
    i0.ɵɵlistener("modelChange", function SdsFiltersComponent_div_1_div_2_div_2_Template_formly_form_modelChange_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onModelChange($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const field_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.options)("form", ctx_r1.form)("model", ctx_r1.model)("fields", i0.ɵɵpureFunction1(4, _c3$1, field_r6));
} }
function SdsFiltersComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SdsFiltersComponent_div_1_div_2_div_1_Template, 5, 7, "div", 19)(2, SdsFiltersComponent_div_1_div_2_div_2_Template, 2, 6, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !field_r6.hide && (field_r6.props == null ? null : field_r6.props.label));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(field_r6.props == null ? null : field_r6.props.label) && field_r6.hooks);
} }
function SdsFiltersComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "sds-advanced-filters", 24);
    i0.ɵɵlistener("showInactiveFiltersChange", function SdsFiltersComponent_div_1_div_3_Template_sds_advanced_filters_showInactiveFiltersChange_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.handleInactiveFilterChange($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("sortMoreFilterBy", ctx_r1.sortMoreFilterBy)("fields", ctx_r1.fields)("options", ctx_r1.options)("model", ctx_r1.model)("isInactiveValueFieldShown", ctx_r1.isInactiveValueFieldShown)("enablePopover", ctx_r1.horizontal);
} }
function SdsFiltersComponent_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "sds-formly-reset", 8);
    i0.ɵɵlistener("resetClicked", function SdsFiltersComponent_div_1_div_10_Template_sds_formly_reset_resetClicked_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.resetClicked.emit()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.options)("defaultModel", i0.ɵɵpureFunction0(2, _c4$1));
} }
function SdsFiltersComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵtemplate(2, SdsFiltersComponent_div_1_div_2_Template, 3, 2, "div", 13)(3, SdsFiltersComponent_div_1_div_3_Template, 2, 7, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15)(7, "button", 16);
    i0.ɵɵlistener("click", function SdsFiltersComponent_div_1_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openDialog()); });
    i0.ɵɵtext(8, " Filter By ");
    i0.ɵɵelement(9, "usa-icon", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, SdsFiltersComponent_div_1_div_10_Template, 2, 3, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.fields);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.advancedFilters);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("icon", "filter")("size", "sm");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showReset);
} }
function SdsFiltersComponent_ng_container_2_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const chip_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", chip_r12.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", chip_r12.label, ":");
} }
function SdsFiltersComponent_ng_container_2_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const value_r13 = ctx.$implicit;
    const chip_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", chip_r12.srValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(value_r13);
} }
function SdsFiltersComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 28)(2, "sds-readonly-container", 29);
    i0.ɵɵtemplate(3, SdsFiltersComponent_ng_container_2_div_1_ng_container_3_Template, 3, 2, "ng-container", 30)(4, SdsFiltersComponent_ng_container_2_div_1_ng_container_4_Template, 3, 2, "ng-container", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 32);
    i0.ɵɵlistener("click", function SdsFiltersComponent_ng_container_2_div_1_Template_button_click_5_listener() { const chip_r12 = i0.ɵɵrestoreView(_r11).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeChip(chip_r12)); })("keyup.enter", function SdsFiltersComponent_ng_container_2_div_1_Template_button_keyup_enter_5_listener() { const chip_r12 = i0.ɵɵrestoreView(_r11).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeChip(chip_r12)); });
    i0.ɵɵelement(6, "usa-icon", 33);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const chip_r12 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", chip_r12.label)("value", chip_r12.value)("additionalConfig", chip_r12.readonlyOptions)("formlyType", chip_r12.formlyType);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", "Remove Item " + chip_r12.label + " " + chip_r12.srValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "x");
} }
function SdsFiltersComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsFiltersComponent_ng_container_2_div_1_Template, 7, 6, "div", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.chips);
} }
function SdsFiltersComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37)(2, "button", 38);
    i0.ɵɵlistener("click", function SdsFiltersComponent_ng_template_3_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.close()); });
    i0.ɵɵelement(3, "usa-icon", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 40)(5, "h2", 41);
    i0.ɵɵtext(6, "Filter By");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 42);
    i0.ɵɵelement(8, "formly-form", 43);
    i0.ɵɵelementStart(9, "div", 5)(10, "div", 7)(11, "sds-formly-reset", 8);
    i0.ɵɵlistener("resetClicked", function SdsFiltersComponent_ng_template_3_Template_sds_formly_reset_resetClicked_11_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetClicked.emit()); });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(12, "div", 44)(13, "button", 45);
    i0.ɵɵlistener("click", function SdsFiltersComponent_ng_template_3_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.applyDialogFilters()); });
    i0.ɵɵtext(14, "Apply");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const data_r15 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("icon", "chevron-left");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("fields", data_r15.fields)("options", data_r15.options)("model", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", data_r15.options)("defaultModel", i0.ɵɵpureFunction0(6, _c4$1));
} }
class SdsFiltersComponent {
    constructor(formlyUpdateComunicationService, formlyDialogService, cdr, filterUpdateModelService) {
        this.formlyUpdateComunicationService = formlyUpdateComunicationService;
        this.formlyDialogService = formlyDialogService;
        this.cdr = cdr;
        this.filterUpdateModelService = filterUpdateModelService;
        /**
         *    Options for the form.
         */
        this.options = {};
        /**
         *  Emit results when model updated
         * To enable History Tracking
         *  If advanced filters dialog should be displayed -- defaults to false
         */
        this.advancedFilters = false;
        /**
         * Sort the filters by alphabetical order
         */
        this.sortMoreFilterBy = '';
        /**
         * Show option to include inactive filter values
         */
        this.isInactiveValueFieldShown = false;
        /**
         * Timer id for the timer awaiting the service call for more typeing
         */
        this.isHistoryEnable = false;
        /**
         * To get clean model without null and empty
         */
        this.getCleanModel = false;
        /**
         * Toggle layout for filters - when horizontal is toggled,
         * the reset and more filters are placed in top right corner
         */
        this.horizontal = false;
        /**
         * Switch to show/hide the reset all button
         * @default true
         */
        this.showReset = true;
        /**
         *  Emit results when model updated
         */
        // TODO: check type -- Formly models are typically objects
        this.filterChange = new EventEmitter();
        this.showInactiveFiltersChange = new EventEmitter();
        this.resetClicked = new EventEmitter();
        this.chips = [];
        this.unsubscribe$ = new Subject();
        this._isObj = (obj) => typeof obj === 'object' && obj !== null;
        this._isEmpty = (obj) => Object.keys(obj).length === 0;
        this.overwrite = (baseObj, newObj) => {
            const result = {};
            const mergedObj = { ...baseObj, ...newObj };
            for (const key in mergedObj) {
                if (Array.isArray(baseObj[key])) {
                    result[key] = newObj[key] || null;
                }
                else if (baseObj[key] instanceof Date) {
                    result[key] = newObj[key] === undefined ? null : new Date(newObj[key]);
                }
                else if (this._isObj(baseObj[key])) {
                    result[key] = this.overwrite(baseObj[key], newObj[key] || {});
                }
                else {
                    result[key] = newObj[key] || null;
                }
            }
            return result;
        };
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    ngOnInit() {
        // keep display chips to defined value if defined, otherwise, default to false, unless hoirzontal is turned on
        this.displayChips = this.displayChips != undefined ? this.displayChips : this.horizontal;
        if (this.filterUpdateModelService) {
            this.filterUpdateModelService.filterModel.pipe(takeUntil(this.unsubscribe$)).subscribe((filter) => {
                if (filter) {
                    const updatedFormValue = this.overwrite(this.form.getRawValue(), filter);
                    // Shallow copy to not trigger onChanges from formly side
                    Object.keys(updatedFormValue).forEach((key) => {
                        this.model[key] = updatedFormValue[key];
                    });
                    this.form.patchValue(updatedFormValue);
                    this.checkForHide();
                }
            });
            this.cdr.detectChanges();
        }
    }
    ngOnChanges(changes) {
        if (changes.model && changes.model.currentValue != changes.model.previousValue) {
            this.checkForHide();
        }
    }
    /**
     * This is for getting the model which has a value.
     */
    checkForHide() {
        let fieldWithValue = this.convertToParam(this.model);
        let keys = [];
        Object.keys(fieldWithValue).map((key) => {
            keys.push(key.replace(/\[/g, '.').replace(/\]/g, ''));
        });
        keys.forEach((key) => {
            const [lastKey] = key.split('.').slice(-1);
            this.fields.forEach((field) => {
                if (key.includes(field.key)) {
                    if (field.fieldGroup) {
                        const fieldExists = this.findFieldInFieldGroup(field.fieldGroup, lastKey);
                        if (fieldExists) {
                            field.hide = false;
                            fieldExists.hide = false;
                        }
                    }
                    else {
                        field.hide = false;
                    }
                }
            });
        });
    }
    /**
     * Recursively iterate over each field as well as potential field groups of the field
     * to find a field with the given key. Returns the field if found, otherwise returns null.
     * @param fields - The list of formly fields to search for the given key
     * @param key - The key of the formly field config to search for
     */
    findFieldInFieldGroup(fields, key) {
        let matchingField = null;
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            if (field.key === key) {
                matchingField = field;
            }
            else if (field.fieldGroup) {
                matchingField = this.findFieldInFieldGroup(field.fieldGroup, key);
            }
            // else if (field.fieldArray) {
            //         matchingField = this.findFieldInFieldGroup([field.fieldArray], key);
            //       }
            if (matchingField) {
                break;
            }
        }
        return matchingField;
    }
    onModelChange(change) {
        this.updateChange(change);
    }
    onResetClicked() {
        const fieldChangeEvent = {
            field: { key: '' },
            type: 'resetAll',
            value: undefined,
        };
        this.options.fieldChanges.next(fieldChangeEvent);
        this.resetClicked.emit();
    }
    updateChange(change) {
        const updatedModel = this.getCleanModel ? this.convertToModel(change) : change;
        this.filterChange.emit(updatedModel);
        if (this.formlyUpdateComunicationService) {
            this.formlyUpdateComunicationService.updateFilter(updatedModel);
        }
        if (this.displayChips) {
            this.generateChips(change, this.fields);
        }
        this.cdr.detectChanges();
    }
    convertToParam(filters) {
        const encodedValues = qs.stringify(filters, {
            skipNulls: true,
            encode: false,
        });
        if (encodedValues) {
            return this.getUrlParams(encodedValues);
        }
        else {
            return '';
        }
    }
    getUrlParams(queryString) {
        const target = {};
        queryString.split('&').forEach((pair) => {
            if (pair !== '') {
                const splitpair = pair.split('=');
                target[splitpair[0]] = splitpair[1] === '' || splitpair[1] === 'false' ? null : splitpair[1];
            }
        });
        return target;
    }
    convertToModel(filters) {
        let obj = {};
        const encodedValues = qs.stringify(filters, {
            skipNulls: true,
            encode: false,
        });
        obj = qs.parse(encodedValues, { decoder: this.cleanModelParser });
        return obj;
    }
    /**
     * Parser for qs.parse - if input string is true / false,
     * convert to boolean value, otherwise use default decoder
     */
    cleanModelParser(str, decoder, charset, type) {
        if (type === 'key') {
            return decoder(str, decoder, charset);
        }
        if (str === 'true' || str === 'false') {
            return str === 'true' ? true : false;
        }
        return decoder(str, decoder, charset);
    }
    handleInactiveFilterChange(inactiveFilterValue) {
        if (this.displayChips) {
            this.generateChips(this.model, this.fields);
        }
        this.showInactiveFiltersChange.emit(inactiveFilterValue);
    }
    openDialog() {
        const clonedFields = cloneDeep(this.fields);
        this._modelSnapshot = cloneDeep(this.model);
        this.removePopoverGroup(clonedFields);
        this.dialogRef = this.formlyDialogService.open(this.horizontalFiltersDialogTemplate, {
            data: { fields: clonedFields, options: {} },
            height: '100vh',
            width: '100vw',
            maxWidth: '100vw',
            maxHeight: '100vh',
            hasBackdrop: false,
            displayCloseBtn: false,
            panelClass: ['sds-dialog--full'],
        });
        this.dialogRef
            .afterClosed()
            .toPromise()
            .then((result) => {
            if (result) {
                this.onModelChange(result);
            }
            else {
                Object.assign(this.model, this._modelSnapshot);
            }
            this.dialogRef = null;
        });
    }
    close() {
        this.dialogRef.close();
    }
    applyDialogFilters() {
        this.dialogRef.close(this.model);
    }
    /**
     * Converts all popover type fields to accordion and unhides any hidden fields
     * so that they can be displayed in filter dialog during resposive mode for
     * horizontal filters
     * @param fields
     */
    removePopoverGroup(fields) {
        fields.forEach((field) => {
            if (field.props && field.props.group === 'popover') {
                field.props.group = 'accordion';
            }
            if (field.fieldGroup) {
                this.removePopoverGroup(field.fieldGroup);
            }
            // if (field.fieldArray) {
            //   this.removePopoverGroup([field.fieldArray]);
            // }
            field.hide = false;
        });
    }
    /**
     * Create chips to display for horizontal filters based on current model
     * and formly field config
     * @param model
     * @param fields
     */
    generateChips(model, fields) {
        const readonlyData = FormlyUtilsService.formlyConfigToReadonlyData(fields, model);
        const chipsWithValue = readonlyData.filter((data) => data.value);
        let allChips = [];
        chipsWithValue.forEach((chip) => {
            if (typeof chip.value != 'object') {
                chip['srValue'] = chip.value;
                allChips.push(chip);
                return;
            }
            if (Array.isArray(chip.value)) {
                const newChips = chip.value.map((chipValue) => {
                    return { ...chip, value: [chipValue], srValue: chipValue };
                });
                allChips = allChips.concat(newChips);
                return;
            }
            if (chip.formlyType === SdsFormlyTypes.DATERANGEPICKER || chip.formlyType === SdsFormlyTypes.DATERANGEPICKERV2) {
                const fromDateValue = chip.value[chip.readonlyOptions.daterangepickerOptions.fromDateKey];
                const toDateValue = chip.value[chip.readonlyOptions.daterangepickerOptions.toDateKey];
                if (fromDateValue || toDateValue) {
                    allChips.push(chip);
                }
                return;
            }
            Object.keys(chip.value).forEach((key) => {
                const value = chip.value[key];
                // Ignore falsey or empty string values
                if (!value || (typeof value.length === 'string' && !value.length)) {
                    return;
                }
                const newChip = { ...chip, value: { [key]: value }, srValue: key };
                allChips.push(newChip);
            });
        });
        this.chips = allChips;
    }
    /**
     * Removing a certain chip from UI is the same as applying a change to the form, so
     * this should update the form control. We can find the field to update based on the chip's
     * formly key and what values to update to based on values of existing chips with the same key
     * @param chip
     * @returns
     */
    removeChip(chip) {
        const field = this.findFieldInFieldGroup(this.fields, chip.formlyKey);
        if (!field) {
            throw new Error('Error: unable to find field to remove chip');
        }
        // If the form control is not complex, then we can simply reset
        if (typeof field.formControl.value != 'object') {
            field.formControl.reset();
            return;
        }
        if (chip.formlyType === SdsFormlyTypes.DATERANGEPICKER || chip.formlyType === SdsFormlyTypes.DATERANGEPICKERV2) {
            const fromDateControl = field.fieldGroup[0].formControl;
            const toDateControl = field.fieldGroup[1].formControl;
            fromDateControl.reset();
            toDateControl.reset();
            return;
        }
        // If the form control contains complex values, such as an object or array, we need to determine what the new
        // value of the form will be after this chip has been removed, and update the form control accordingly
        const chipsWithSameKey = this.chips.filter((exisingChip) => chip != exisingChip && chip.formlyKey === exisingChip.formlyKey);
        const existingValues = chipsWithSameKey.map((chipWithSameKey) => chipWithSameKey.value);
        if (Array.isArray(field.formControl.value)) {
            let updatedValue = [];
            existingValues.forEach((value) => {
                updatedValue = updatedValue.concat(value);
            });
            field.formControl.setValue(updatedValue);
            return;
        }
        const objectValue = {};
        Object.assign(objectValue, ...existingValues);
        field.formControl.setValue(objectValue);
    }
    /** @nocollapse */ static { this.ɵfac = function SdsFiltersComponent_Factory(t) { return new (t || SdsFiltersComponent)(i0.ɵɵdirectiveInject(SDSFormlyUpdateComunicationService, 8), i0.ɵɵdirectiveInject(i2$3.SdsDialogService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(SDSFormlyUpdateModelService, 8)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsFiltersComponent, selectors: [["sds-filters"]], viewQuery: function SdsFiltersComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.horizontalFiltersDialogTemplate = _t.first);
        } }, inputs: { form: "form", fields: "fields", model: "model", options: "options", advancedFilters: "advancedFilters", sortMoreFilterBy: "sortMoreFilterBy", isInactiveValueFieldShown: "isInactiveValueFieldShown", isHistoryEnable: "isHistoryEnable", getCleanModel: "getCleanModel", defaultModel: "defaultModel", horizontal: "horizontal", displayChips: "displayChips", showReset: "showReset" }, outputs: { filterChange: "filterChange", showInactiveFiltersChange: "showInactiveFiltersChange", resetClicked: "resetClicked" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2$1, decls: 5, vars: 3, consts: [["horizontalFiltersDialog", ""], ["content", ""], [4, "ngIf"], ["class", "sds-filters--horizontal", 4, "ngIf"], [3, "modelChange", "form", "fields", "options", "model"], [1, "grid-row", "margin-top-2"], ["class", "grid-col", 4, "ngIf"], [1, "grid-col", "text-right"], [3, "resetClicked", "options", "defaultModel"], [1, "grid-col"], [3, "showInactiveFiltersChange", "form", "sortMoreFilterBy", "fields", "options", "model", "isInactiveValueFieldShown"], [1, "sds-filters--horizontal"], [1, "horizontal-filters", "grid-row"], [4, "ngFor", "ngForOf"], [1, "search-input"], [1, "filters-modal", "margin-left-2"], ["type", "button", 1, "usa-button", "usa-button--unstyled", 3, "click"], [1, "icon-filter", 3, "icon", "size"], ["class", "horizontal-reset margin-left-2 text-right", 4, "ngIf"], ["tabindex", "0", "class", "margin-right-2", 3, "sdsPopover", "position", "autoClose", 4, "ngIf"], ["tabindex", "0", 1, "margin-right-2", 3, "sdsPopover", "position", "autoClose"], [3, "icon", "size"], [1, "text-left", "width-full"], [3, "modelChange", "options", "form", "model", "fields"], [3, "showInactiveFiltersChange", "form", "sortMoreFilterBy", "fields", "options", "model", "isInactiveValueFieldShown", "enablePopover"], [1, "horizontal-reset", "margin-left-2", "text-right"], ["class", "width-auto sds-tag sds-tag--chip sds-tag--input margin-right-2", 4, "ngFor", "ngForOf"], [1, "width-auto", "sds-tag", "sds-tag--chip", "sds-tag--input", "margin-right-2"], [1, "sds--tag__item"], [3, "label", "value", "additionalConfig", "formlyType"], [4, "sdsReadonlyLabel"], [4, "sdsReadonlyValue"], ["aria-hidden", "false", 1, "sds-tag__close", "position-static", 3, "click", "keyup.enter"], ["size", "lg", 3, "icon"], [1, "margin-right-1", "text-bold"], [1, "margin-right-1"], [1, "bg-accent-cool-lighter", "height-full"], [1, "grid-row", "shadow-4", "padding-1"], ["id", "cancelButton", "aria-label", "Cancel Filter By", 1, "sds-button", "sds-button--circular", "sds-button--white", 3, "click"], [3, "icon"], [1, "margin-x-auto"], [1, "usa-card__heading", "margin-top-1", "margin-left-neg-2"], [1, "padding-1"], [3, "fields", "options", "model"], [1, "padding-1", "shadow-4"], [1, "usa-button", "width-full", 3, "click"]], template: function SdsFiltersComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c1$1);
            i0.ɵɵtemplate(0, SdsFiltersComponent_div_0_Template, 6, 7, "div", 2)(1, SdsFiltersComponent_div_1_Template, 11, 5, "div", 3)(2, SdsFiltersComponent_ng_container_2_Template, 2, 1, "ng-container", 2)(3, SdsFiltersComponent_ng_template_3_Template, 15, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.horizontal);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.horizontal);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.displayChips);
        } }, dependencies: [i1.NgForOf, i1.NgIf, SdsFormlyResetComponent, i2$1.IconComponent, i3.FormlyForm, ReadonlyContainerComponent, ReadonlyLabelDirective, ReadonlyValueDirective, i2$3.SdsPopover, AdvancedFiltersComponent], encapsulation: 2, changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsFiltersComponent, [{
        type: Component,
        args: [{ selector: 'sds-filters', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- Vertical Filters -->\n<div *ngIf=\"!horizontal\">\n  <formly-form\n    [form]=\"form\"\n    [fields]=\"fields\"\n    [options]=\"options\"\n    [model]=\"model\"\n    (modelChange)=\"onModelChange($event)\"\n  >\n  </formly-form>\n  <div class=\"grid-row margin-top-2\">\n    <div *ngIf=\"advancedFilters\" class=\"grid-col\">\n      <sds-advanced-filters\n        [form]=\"form\"\n        [sortMoreFilterBy]=\"sortMoreFilterBy\"\n        [fields]=\"fields\"\n        [options]=\"options\"\n        [model]=\"model\"\n        (showInactiveFiltersChange)=\"showInactiveFiltersChange.next($event)\"\n        [isInactiveValueFieldShown]=\"isInactiveValueFieldShown\"\n      >\n      </sds-advanced-filters>\n    </div>\n    <div class=\"grid-col text-right\">\n      <sds-formly-reset [options]=\"options\" [defaultModel]=\"defaultModel\" (resetClicked)=\"onResetClicked()\">\n      </sds-formly-reset>\n    </div>\n  </div>\n</div>\n\n<!-- Horizontal Filters -->\n<div *ngIf=\"horizontal\" class=\"sds-filters--horizontal\">\n  <div class=\"horizontal-filters grid-row\">\n    <div *ngFor=\"let field of fields\">\n      <div\n        *ngIf=\"!field.hide && field.props?.label\"\n        [sdsPopover]=\"content\"\n        [position]=\"'bottom'\"\n        [autoClose]=\"'outside'\"\n        tabindex=\"0\"\n        [attr.aria-label]=\"field.props.label\"\n        class=\"margin-right-2\"\n      >\n        {{ field.props.label }}\n        <usa-icon [icon]=\"'chevron-down'\" [size]=\"'sm'\"></usa-icon>\n        <ng-template #content>\n          <p class=\"text-left width-full\">\n            <formly-form\n              [options]=\"options\"\n              [form]=\"form\"\n              [model]=\"model\"\n              [fields]=\"[field]\"\n              (modelChange)=\"onModelChange($event)\"\n            ></formly-form>\n          </p>\n        </ng-template>\n      </div>\n      <div *ngIf=\"!field.props?.label && field.hooks\">\n        <formly-form\n          [options]=\"options\"\n          [form]=\"form\"\n          [model]=\"model\"\n          [fields]=\"[field]\"\n          (modelChange)=\"onModelChange($event)\"\n        ></formly-form>\n      </div>\n    </div>\n\n    <div *ngIf=\"advancedFilters\">\n      <sds-advanced-filters\n        [form]=\"form\"\n        [sortMoreFilterBy]=\"sortMoreFilterBy\"\n        [fields]=\"fields\"\n        [options]=\"options\"\n        [model]=\"model\"\n        [isInactiveValueFieldShown]=\"isInactiveValueFieldShown\"\n        [enablePopover]=\"horizontal\"\n        (showInactiveFiltersChange)=\"handleInactiveFilterChange($event)\"\n      >\n      </sds-advanced-filters>\n    </div>\n  </div>\n\n  <div class=\"search-input\">\n    <ng-content select=\"sds-search\"></ng-content>\n  </div>\n\n  <div class=\"filters-modal margin-left-2\">\n    <button type=\"button\" (click)=\"openDialog()\" class=\"usa-button usa-button--unstyled\">\n      Filter By\n      <usa-icon [icon]=\"'filter'\" class=\"icon-filter\" [size]=\"'sm'\"></usa-icon>\n    </button>\n  </div>\n\n  <div *ngIf=\"showReset\" class=\"horizontal-reset margin-left-2 text-right\">\n    <sds-formly-reset [options]=\"options\" [defaultModel]=\"{}\" (resetClicked)=\"resetClicked.emit()\"></sds-formly-reset>\n  </div>\n</div>\n\n<!-- Chip Display -->\n<ng-container *ngIf=\"displayChips\">\n  <div *ngFor=\"let chip of chips\" class=\"width-auto sds-tag sds-tag--chip sds-tag--input margin-right-2\">\n    <div class=\"sds--tag__item\">\n      <sds-readonly-container\n        [label]=\"chip.label\"\n        [value]=\"chip.value\"\n        [additionalConfig]=\"chip.readonlyOptions\"\n        [formlyType]=\"chip.formlyType\"\n      >\n        <ng-container *sdsReadonlyLabel\n          ><span class=\"margin-right-1 text-bold\" [attr.aria-label]=\"chip.label\">{{ chip.label }}:</span></ng-container\n        >\n        <ng-container *sdsReadonlyValue=\"let value\"\n          ><span class=\"margin-right-1\" [attr.aria-label]=\"chip.srValue\">{{ value }}</span></ng-container\n        >\n      </sds-readonly-container>\n    </div>\n\n    <button\n      [attr.aria-label]=\"'Remove Item ' + chip.label + ' ' + chip.srValue\"\n      aria-hidden=\"false\"\n      class=\"sds-tag__close position-static\"\n      (click)=\"removeChip(chip)\"\n      (keyup.enter)=\"removeChip(chip)\"\n    >\n      <usa-icon [icon]=\"'x'\" size=\"lg\"></usa-icon>\n    </button>\n  </div>\n</ng-container>\n\n<ng-template #horizontalFiltersDialog let-data>\n  <div class=\"bg-accent-cool-lighter height-full\">\n    <div class=\"grid-row shadow-4 padding-1\">\n      <button\n        id=\"cancelButton\"\n        class=\"sds-button sds-button--circular sds-button--white\"\n        (click)=\"close()\"\n        aria-label=\"Cancel Filter By\"\n      >\n        <usa-icon [icon]=\"'chevron-left'\"></usa-icon>\n      </button>\n      <div class=\"margin-x-auto\">\n        <h2 class=\"usa-card__heading margin-top-1 margin-left-neg-2\">Filter By</h2>\n      </div>\n    </div>\n\n    <div class=\"padding-1\">\n      <formly-form [fields]=\"data.fields\" [options]=\"data.options\" [model]=\"model\"> </formly-form>\n      <div class=\"grid-row margin-top-2\">\n        <div class=\"grid-col text-right\">\n          <sds-formly-reset [options]=\"data.options\" [defaultModel]=\"{}\" (resetClicked)=\"resetClicked.emit()\">\n          </sds-formly-reset>\n        </div>\n      </div>\n    </div>\n    <div class=\"padding-1 shadow-4\">\n      <button class=\"usa-button width-full\" (click)=\"applyDialogFilters()\">Apply</button>\n    </div>\n  </div>\n</ng-template>\n" }]
    }], () => [{ type: SDSFormlyUpdateComunicationService, decorators: [{
                type: Optional
            }] }, { type: i2$3.SdsDialogService }, { type: i0.ChangeDetectorRef }, { type: SDSFormlyUpdateModelService, decorators: [{
                type: Optional
            }] }], { horizontalFiltersDialogTemplate: [{
            type: ViewChild,
            args: ['horizontalFiltersDialog']
        }], form: [{
            type: Input
        }], fields: [{
            type: Input
        }], model: [{
            type: Input
        }], options: [{
            type: Input
        }], advancedFilters: [{
            type: Input
        }], sortMoreFilterBy: [{
            type: Input
        }], isInactiveValueFieldShown: [{
            type: Input
        }], isHistoryEnable: [{
            type: Input
        }], getCleanModel: [{
            type: Input
        }], defaultModel: [{
            type: Input
        }], horizontal: [{
            type: Input
        }], displayChips: [{
            type: Input
        }], showReset: [{
            type: Input
        }], filterChange: [{
            type: Output
        }], showInactiveFiltersChange: [{
            type: Output
        }], resetClicked: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsFiltersComponent, { className: "SdsFiltersComponent" }); })();

class SdsFiltersModule {
    /** @nocollapse */ static { this.ɵfac = function SdsFiltersModule_Factory(t) { return new (t || SdsFiltersModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsFiltersModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ providers: [SDSFormlyUpdateModelService], imports: [CommonModule,
            FormsModule,
            SdsFormlyModule,
            SdsFormlyResetModule,
            IconModule,
            ReactiveFormsModule,
            FormlySelectModule,
            FormlyModule,
            SdsReadonlyModule,
            SdsPopoverModule,
            NgxBootstrapIconsModule.pick({ filter, x, chevronLeft })] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsFiltersModule, [{
        type: NgModule,
        args: [{
                declarations: [SdsFiltersComponent, AdvancedFiltersComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    SdsFormlyModule,
                    SdsFormlyResetModule,
                    IconModule,
                    ReactiveFormsModule,
                    FormlySelectModule,
                    FormlyModule,
                    SdsReadonlyModule,
                    SdsPopoverModule,
                    NgxBootstrapIconsModule.pick({ filter, x, chevronLeft }),
                ],
                exports: [SdsFiltersComponent],
                providers: [SDSFormlyUpdateModelService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsFiltersModule, { declarations: [SdsFiltersComponent, AdvancedFiltersComponent], imports: [CommonModule,
        FormsModule,
        SdsFormlyModule,
        SdsFormlyResetModule,
        IconModule,
        ReactiveFormsModule,
        FormlySelectModule,
        FormlyModule,
        SdsReadonlyModule,
        SdsPopoverModule, i1$1.NgxBootstrapIconsModule], exports: [SdsFiltersComponent] }); })();

class SdsFormlyDialogModule {
    /** @nocollapse */ static { this.ɵfac = function SdsFormlyDialogModule_Factory(t) { return new (t || SdsFormlyDialogModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsFormlyDialogModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule,
            SdsFiltersModule,
            SdsDialogModule,
            ReactiveFormsModule,
            SdsFormlyModule,
            FormlyModule,
            FormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsFormlyDialogModule, [{
        type: NgModule,
        args: [{
                declarations: [SdsFormlyDialogComponent],
                imports: [
                    CommonModule,
                    SdsFiltersModule,
                    SdsDialogModule,
                    ReactiveFormsModule,
                    SdsFormlyModule,
                    FormlyModule,
                    FormsModule,
                ],
                exports: [SdsFormlyDialogComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsFormlyDialogModule, { declarations: [SdsFormlyDialogComponent], imports: [CommonModule,
        SdsFiltersModule,
        SdsDialogModule,
        ReactiveFormsModule,
        SdsFormlyModule,
        FormlyModule,
        FormsModule], exports: [SdsFormlyDialogComponent] }); })();

const _c0 = ["sdsStepHeader", ""];
const _c1 = ["*"];
const _c2 = ["sdsStepFooter", ""];
const _c3 = ["mainContent"];
const _c4 = [[["sds-step"]], [["", "sdsStepHeader", ""]], [["", "sdsStepFooter", ""]]];
const _c5 = ["sds-step", "[sdsStepHeader]", "[sdsStepFooter]"];
const _c6 = a0 => [a0];
function SdsStepComponent_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.stepTemplate);
} }
function SdsStepComponent_ng_template_0_ng_template_1_formly_form_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "formly-form", 5);
    i0.ɵɵlistener("modelChange", function SdsStepComponent_ng_template_0_ng_template_1_formly_form_1_Template_formly_form_modelChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.onModelChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("form", ctx_r0.form)("model", ctx_r0.model)("fields", i0.ɵɵpureFunction1(4, _c6, ctx_r0.fieldConfig))("options", ctx_r0.options);
} }
function SdsStepComponent_ng_template_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1);
    i0.ɵɵtemplate(1, SdsStepComponent_ng_template_0_ng_template_1_formly_form_1_Template, 1, 6, "formly-form", 4);
    i0.ɵɵprojection(2, 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldConfig);
} }
function SdsStepComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SdsStepComponent_ng_template_0_ng_container_0_Template, 1, 1, "ng-container", 2)(1, SdsStepComponent_ng_template_0_ng_template_1_Template, 3, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵprojection(3);
} if (rf & 2) {
    const formlyField_r3 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.stepTemplate)("ngIfElse", formlyField_r3);
} }
class SdsStepHeaderComponent {
    /** @nocollapse */ static { this.ɵfac = function SdsStepHeaderComponent_Factory(t) { return new (t || SdsStepHeaderComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsStepHeaderComponent, selectors: [["", "sdsStepHeader", ""]], attrs: _c0, ngContentSelectors: _c1, decls: 1, vars: 0, template: function SdsStepHeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepHeaderComponent, [{
        type: Component,
        args: [{
                selector: `[sdsStepHeader]`,
                template: `<ng-content></ng-content>`,
            }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsStepHeaderComponent, { className: "SdsStepHeaderComponent" }); })();
class SdsStepFooterComponent {
    /** @nocollapse */ static { this.ɵfac = function SdsStepFooterComponent_Factory(t) { return new (t || SdsStepFooterComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsStepFooterComponent, selectors: [["", "sdsStepFooter", ""]], attrs: _c2, ngContentSelectors: _c1, decls: 1, vars: 0, template: function SdsStepFooterComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepFooterComponent, [{
        type: Component,
        args: [{
                selector: `[sdsStepFooter]`,
                template: '<ng-content></ng-content>',
            }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsStepFooterComponent, { className: "SdsStepFooterComponent" }); })();
let nextId = 0;
class SdsStepComponent {
    constructor(_stepper, _el, _document) {
        this._stepper = _stepper;
        this._el = _el;
        this._document = _document;
        /**
         * Id for step - auto generated if none is provided
         */
        this.id = `sds-step-${nextId++}`;
        /**
         * Whether the step is selected or not
         */
        this.selected = false;
        /**
         * Defines whether the step is an editable form or simply a label
         * @default true
         */
        this.editable = true;
        this.validateOnBlur = false;
        this.form = new FormGroup({});
        /**
         * Emitted anytime user input changes in the step - only applicable if
         * step is a formly field config
         */
        this.modelChange = new EventEmitter();
    }
    hasAllEmptyValues(obj) {
        if (!obj || typeof obj !== 'object') {
            return true; // Consider non-object types as empty
        }
        return Object.values(obj).every((value) => {
            if (Array.isArray(value)) {
                return value.length === 0; // Empty arrays
            }
            if (typeof value === 'object' && value !== null) {
                return this.hasAllEmptyValues(value); // Recursively check nested objects
            }
            return value === '' || value === null || value === undefined || value === false || value === 0;
        });
    }
    ngOnInit() {
        if (this.validateOnBlur) {
            this.form = new FormGroup({}, { updateOn: 'change' });
            const keyid = this.fieldConfig?.key ? this.fieldConfig?.key.toString() : '';
            if (keyid && this._stepper.model[keyid] && !this.hasAllEmptyValues(this._stepper.model[keyid])) {
                setTimeout(() => this.form.markAllAsTouched());
                console.log('model', this._stepper.model[keyid]);
                this.options = {
                    formState: {
                        submitted: false,
                    },
                };
            }
        }
        this.form.statusChanges.subscribe((status) => {
            this._stepper.updateValidation(this._stepper.selectedStep);
        });
    }
    /**
     * Dispatch a custom event for parent stepper component to listen for on model change
     * as well as an output binded event emitter for application level components to listen
     * for if they wanted to listen at individual step level
     * @param $event - the updated model
     */
    onModelChange($event) {
        let event;
        if (typeof Event === 'function') {
            event = new CustomEvent('stepModelChange', { bubbles: true, detail: $event });
        }
        else {
            // IE11 support
            event = this._document.createEvent('CustomEvent');
            event.initCustomEvent('sort', true, true, $event);
        }
        this._el.nativeElement.dispatchEvent(event);
        this.modelChange.emit($event);
    }
    /** @nocollapse */ static { this.ɵfac = function SdsStepComponent_Factory(t) { return new (t || SdsStepComponent)(i0.ɵɵdirectiveInject(forwardRef(() => SdsStepper)), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsStepComponent, selectors: [["sds-step"]], contentQueries: function SdsStepComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SdsStepComponent, 4);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
        } }, viewQuery: function SdsStepComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
        } }, inputs: { stepTemplate: "stepTemplate", stepValidationFn: "stepValidationFn", text: "text", id: "id", selected: "selected", fieldConfig: "fieldConfig", options: "options", model: "model", valid: "valid", hideFn: "hideFn", hide: "hide", isReview: "isReview", editable: "editable", route: "route", disabled: "disabled", validateOnBlur: "validateOnBlur" }, outputs: { modelChange: "modelChange" }, exportAs: ["sdsStep"], ngContentSelectors: _c5, decls: 2, vars: 0, consts: [["mainContent", ""], ["formlyField", ""], [3, "ngTemplateOutlet", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet"], [3, "form", "model", "fields", "options", "modelChange", 4, "ngIf"], [3, "modelChange", "form", "model", "fields", "options"]], template: function SdsStepComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c4);
            i0.ɵɵtemplate(0, SdsStepComponent_ng_template_0_Template, 4, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } }, dependencies: [i1.NgIf, i1.NgTemplateOutlet, i3.FormlyForm], encapsulation: 2, changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepComponent, [{
        type: Component,
        args: [{ selector: `sds-step`, exportAs: `sdsStep`, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #mainContent>\n  <ng-container *ngIf=\"stepTemplate; else formlyField\" [ngTemplateOutlet]=\"stepTemplate\"></ng-container>\n  <ng-template #formlyField>\n    <ng-content select=\"[sdsStepHeader]\"></ng-content>\n    <formly-form\n      [form]=\"form\"\n      *ngIf=\"fieldConfig\"\n      [model]=\"model\"\n      [fields]=\"[fieldConfig]\"\n      [options]=\"options\"\n      (modelChange)=\"onModelChange($event)\"\n    >\n    </formly-form>\n    <ng-content select=\"[sdsStepFooter]\"></ng-content>\n  </ng-template>\n\n  <ng-content select=\"sds-step\"></ng-content>\n</ng-template>\n" }]
    }], () => [{ type: SdsStepper, decorators: [{
                type: Inject,
                args: [forwardRef(() => SdsStepper)]
            }] }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }], { children: [{
            type: ContentChildren,
            args: [forwardRef(() => SdsStepComponent)]
        }], content: [{
            type: ViewChild,
            args: ['mainContent', { static: true }]
        }], stepTemplate: [{
            type: Input
        }], stepValidationFn: [{
            type: Input
        }], text: [{
            type: Input
        }], id: [{
            type: Input
        }], selected: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], options: [{
            type: Input
        }], model: [{
            type: Input
        }], valid: [{
            type: Input
        }], hideFn: [{
            type: Input
        }], hide: [{
            type: Input
        }], isReview: [{
            type: Input
        }], editable: [{
            type: Input
        }], route: [{
            type: Input
        }], disabled: [{
            type: Input
        }], validateOnBlur: [{
            type: Input
        }], modelChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsStepComponent, { className: "SdsStepComponent" }); })();
class SdsStepper {
    /**
     * Event emitted by sds-step component whenever a model change
     * occurs. Emits the modelChange event. This can be useful if
     * users want to attach a listener for any model change in overall
     * steps rather than listening for model change in each individual step
     * @param $event
     */
    onModelChange($event) {
        $event.stopImmediatePropagation();
        this.modelChange.emit($event.detail);
    }
    constructor(router, activatedRoute, cdr) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
        /**
         * Singular global model to store user input for all steps. Alternatively,
         * users may pass in a model specifically to each sds-step and manage the data
         * modal separately
         */
        this.model = {};
        /**
         * Mapping of step validity. This maps each step's id to a boolean value indicating
         * whether the step is valid or invalid. This maps defines valid/invalid icons
         * displayed in side nav
         */
        this.stepValidityMap = {};
        /**
         * Toggle custom error handling from user side. By default, errors are displayed
         * only on save click or when loading a pre-saved form with defined validity.
         * @default false
         */
        this.customErrorHandling = false;
        /** Whether the validity of previous steps should prevent navigating to next steps.
         * @default false
         */
        this.linear = false;
        /**
         * Unique identifier for the stepper. If none provided a default id will be used
         */
        this.id = `sds-stepper-${nextId++}`;
        /**
         * Configurable query parameter to use when keeping track of which
         * step the user is on from the URL. Useful when we'd want multiple
         * steppers in one page but don't want the query params to conflict
         * @default - sdsStepId
         */
        this.queryParamKey = 'sdsStepId';
        /**
         * This is used to disable/enable the routing for the stepper
         * @default - true
         */
        this.isRouteEnabled = true;
        this.validateStepsOnInit = true;
        /**
         * Input to override the check for _isReviewAndSubmitDisabled truthyness
         */
        this.canReviewWithErrors = false;
        /**
         * Output event - emitted when save button is clicked
         */
        this.saveData = new EventEmitter();
        /**
         * Output event - emitted when a step is changed, either through the
         *  navigation buttons at the bottom of the step or by clicking on a
         *  step in side panel
         */
        this.stepChange = new EventEmitter();
        /**
         * Output event - emitted if the current step is a formly config.
         *  Outputs whenever a model change occurs from the formly field
         */
        this.modelChange = new EventEmitter();
        /**
         * A flattened list of steps - steps with children are placed after their parent
         * in the list
         */
        this.flatSteps = [];
        /**
         * Switch that toggles on if and only if all steps in the flattned list of steps
         * are seen as valid in the validity map
         */
        this._isReviewAndSubmitDisabled = true;
    }
    ngOnChanges(changes) {
        if (!this.selectedStep) {
            return;
        }
        if (changes.currentStepId && this.selectedStep.id != changes.currentStepId.currentValue) {
            this.changeStep(changes.currentStepId.currentValue);
        }
        if (changes.stepValidityMap && changes.stepValidityMap.currentValue) {
            this.flatSteps.forEach((step) => {
                step.valid = this.stepValidityMap[step.id];
            });
        }
        /**
         * Handling toggling between linear and non-linear modes.
         * On switch to linear, disable incomplete forms.
         * On switch to non-linear, enable all steps except review step
         */
        if (changes.linear) {
            if (changes.linear.currentValue) {
                const lastValidStepIndex = this.evaluateIncompleteForms();
                this.changeStep(this.flatSteps[lastValidStepIndex].id);
            }
            else {
                this.flatSteps.forEach((step) => {
                    if (!step.isReview) {
                        step.disabled = false;
                    }
                    else if (!this._isReviewAndSubmitDisabled) {
                        step.disabled = false;
                    }
                });
            }
            this.flatSteps.forEach((step) => {
                step.valid = this.stepValidityMap[step.id];
            });
        }
    }
    ngAfterViewInit() {
        if (this.validateStepsOnInit === true ||
            (this.validateStepsOnInit instanceof Array && this.validateStepsOnInit.length > 0)) {
            const currentStep = this.selectedStep;
            if (!this.linear) {
                const isRouteEnabled = this.isRouteEnabled;
                this.flatSteps = this.getFlatSteps(this.stepTemplates).filter((step) => {
                    if (this.validateStepsOnInit === true) {
                        return true;
                    }
                    else {
                        return this.validateStepsOnInit.includes(step.id);
                    }
                });
                if (this.flatSteps.length === 0) {
                    return;
                }
                this.isRouteEnabled = false;
                this.flatSteps.forEach((step, index) => {
                    setTimeout(() => {
                        if (step.isReview) {
                            return;
                        }
                        const isValidateStepsOnInitArray = Array.isArray(this.validateStepsOnInit);
                        /**
                         * Handles cases where key specified in `queryParamKey` is not
                         * a part of the validateStepsOnInit array. Need to not check the
                         * validity when moving from `queryParamKey` step to first step in
                         * validateStepsOnInit array. Checking `queryParamKey` step before
                         * navigating would cause that step to be validated when that is not
                         * wanted.
                         */
                        if (index === 0 &&
                            this.currentStepId &&
                            isValidateStepsOnInitArray &&
                            !this.validateStepsOnInit.includes(this.currentStepId)) {
                            this.changeStep(step.id, 0, true);
                        }
                        else if (
                        /**
                         * Handles case where key specified in `queryParamKey` is the only
                         * member of validateStepsOnInit array. In this case changeStep
                         * will not cause form to be re-validated, so we need to do this
                         * manually.
                         */
                        this.currentStepId &&
                            isValidateStepsOnInitArray &&
                            this.validateStepsOnInit.length === 1 &&
                            this.validateStepsOnInit.includes(this.currentStepId)) {
                            this.updateValidation(step);
                        }
                        else {
                            this.changeStep(step.id);
                        }
                    }, 0);
                });
                setTimeout(() => {
                    this.changeStep(currentStep.id);
                    this.isRouteEnabled = isRouteEnabled;
                }, 0);
            }
        }
    }
    ngAfterContentInit() {
        this.flatSteps = this.getFlatSteps(this.stepTemplates);
        this.flatSteps.forEach((step) => {
            step.model = step.model ? step.model : this.model;
        });
        if (this.activatedRoute.snapshot.queryParams[this.queryParamKey] && !this.linear && this.isRouteEnabled) {
            this.currentStepId = this.activatedRoute.snapshot.queryParams[this.queryParamKey];
        }
        else if (!this.currentStepId) {
            this.currentStepId = this.flatSteps[0].id;
            this.selectedStepIndex = 0;
            this.selectedStep = this.flatSteps[this.selectedStepIndex];
        }
        if (this.stepValidityMap) {
            this.updateValidity(this.stepValidityMap, this.stepTemplates);
            this.checkReviewAndSubmit();
        }
        else {
            this.stepValidityMap = {};
        }
        if (this.linear) {
            this.evaluateIncompleteForms();
        }
        this.changeStep(this.currentStepId).finally(() => {
            if (this.isRouteEnabled) {
                this.activatedRoute.queryParams.subscribe((queryParam) => {
                    if (queryParam[this.queryParamKey] && queryParam[this.queryParamKey] != this.currentStepId) {
                        this.changeStep(queryParam[this.queryParamKey]);
                    }
                });
            }
        });
    }
    getFlatSteps(stepTemplates) {
        let flat = [];
        stepTemplates.forEach((step) => {
            if (step.hideFn && step.hideFn(step.model ? step.model : this.model, step.fieldConfig)) {
                step.hide = true;
                return;
            }
            step.hide = false;
            if (step.editable) {
                flat.push(step);
            }
            if (step.children && step.children.length) {
                const childSteps = this.getFlatSteps(step.children);
                flat = flat.concat(childSteps);
            }
        });
        return flat;
    }
    /**
     * Change currently selected step
     * @param stepId - The id of step to change to
     * @param incrementor - Optional input - Either a 1 or -1. When a value of 1
     *  is provided, then the step to change to will be the next step from the input step
     *  given. When a value of -1 is provided, then the selected step will be the step
     *  previous to the provided step
     */
    async changeStep(stepId, incrementor, blockValidity) {
        this.flatSteps = this.getFlatSteps(this.stepTemplates);
        let stepIndex = this.flatSteps.findIndex((step) => step.id === stepId);
        stepIndex = stepIndex === -1 ? 0 : stepIndex;
        if (incrementor) {
            stepIndex = stepIndex + incrementor;
            if (stepIndex > this.flatSteps.length) {
                throw Error(`StepIndex of ${stepIndex} is greater than the number of steps. Check that you are passing in a sensible incrementor.)`);
            }
        }
        const step = this.flatSteps[stepIndex];
        /** Already on desired step, nothing to do */
        if (step === this.selectedStep) {
            return;
        }
        /**
         * On non-linear mode, do not allow step change if step we are moving to is disabled or is review step.
         * In linear mode, we will run validations first, then decide whether or not to move to next step
         */
        if (!this.linear &&
            (step.disabled || (step.isReview && !this.canReviewWithErrors && this._isReviewAndSubmitDisabled))) {
            return;
        }
        // Update current step's validity before moving to next step
        if (this.selectedStep) {
            if (!blockValidity) {
                await this.updateValidation(this.selectedStep);
            }
            this.checkReviewAndSubmit();
            if (this.linear) {
                this.evaluateIncompleteForms();
            }
            this.selectedStep.selected = false;
        }
        /**
         * In linear mode and moving to next step.
         * Disable changing step if current step is invalid or has empty data, and display errors
         * */
        if (this.linear && stepIndex > this.selectedStepIndex && !this.stepValidityMap[this.selectedStep.id]) {
            this.toggleOnValidationForStep(this.selectedStep, this.stepValidityMap, this.customErrorHandling);
            return;
        }
        this.selectedStepIndex = stepIndex;
        this.selectedStep = this.flatSteps[stepIndex];
        this.selectedStep.selected = true;
        this.currentStepId = this.selectedStep.id;
        this.toggleOnValidationForStep(this.selectedStep, this.stepValidityMap, this.customErrorHandling);
        if (this.selectedStep.editable && this.isRouteEnabled) {
            this.router.navigate(this.selectedStep.route ? [this.selectedStep.route] : [], {
                queryParams: {
                    [this.queryParamKey]: this.currentStepId,
                },
                queryParamsHandling: 'merge',
            });
        }
        this.stepChange.emit(this.selectedStep);
    }
    /**
     * Enables validation error display for a given step
     * @param step
     */
    toggleOnValidationForStep(step, validityMap, customErrorHandling) {
        if (!step.options && !customErrorHandling) {
            this.selectedStep.options = {};
        }
        if (!step.options?.showError && !customErrorHandling) {
            this.selectedStep.options.showError = () => false;
        }
        if (validityMap[step.id] === false) {
            step.options.showError = (field) => field.formControl.invalid;
        }
    }
    onNextStep() {
        this.changeStep(this.selectedStep.id, 1);
        if (this.selectedStep.validateOnBlur) {
            this.updateValidation(this.selectedStep);
        }
    }
    onPreviousStep() {
        if (this.selectedStep.validateOnBlur) {
            this.updateValidation(this.selectedStep);
        }
        this.changeStep(this.selectedStep.id, -1);
    }
    /**
     * Called through sdsStepperSave button - updates validity of the current step
     * and toggles error display. Emits saveData event.
     */
    async onSaveClicked() {
        console.warn(`This is a deprectaed version of sdsStepperSave directive, and will be removed in future versions.
      Please switch to using sdsStepperPrevious/sdsStepperNext`);
        this.flatSteps = this.getFlatSteps(this.stepTemplates);
        this.selectedStepIndex = this.flatSteps.findIndex((step) => step.id === this.selectedStep.id);
        await this.updateValidation(this.selectedStep);
        this.checkReviewAndSubmit();
        if (this.linear) {
            this.evaluateIncompleteForms();
        }
        if (!this.customErrorHandling && this.stepValidityMap[this.currentStepId] === false) {
            this.selectedStep.options.showError = (field) => !field.formControl.valid;
        }
        this.saveData.emit({
            model: this.model,
            metadata: {
                stepId: this.selectedStep.id,
                stepValidityMap: this.stepValidityMap,
            },
        });
    }
    /**
     * Gets all steps that are not hidden
     * @param steps
     */
    getDisplayedSteps(steps) {
        if (!steps) {
            return [];
        }
        return steps.filter((step) => !step.hide);
    }
    /**
     * Used while in linear mode. All steps that are in the step validity and are valid
     * map should be enabled until we find the first step that is invalid.
     * Then all steps from that point on should be disabled
     *
     * @returns the index of the last valid step
     */
    evaluateIncompleteForms() {
        let startIndex = 0;
        this.flatSteps.some((step, index) => {
            step.disabled = false;
            if (!this.stepValidityMap[step.id]) {
                startIndex = index;
                return true;
            }
        });
        for (let i = startIndex + 1; i < this.flatSteps.length; i++) {
            this.flatSteps[i].disabled = true;
        }
        return startIndex;
    }
    checkReviewAndSubmit() {
        this._isReviewAndSubmitDisabled = this.flatSteps.some((step) => {
            if (step.isReview) {
                return false;
            }
            if (!this.stepValidityMap[step.id]) {
                return true;
            }
            return false;
        });
    }
    updateValidity(validityMap, stepTemplates) {
        stepTemplates.forEach((step) => {
            if (!step) {
                return;
            }
            step.valid = validityMap[step.id];
            if (step.children) {
                this.updateValidity(validityMap, step.children);
            }
        });
    }
    /**
     * Updates validity of a given step. If a synchronous stepValidationFn is provided
     * for the step, then that method is given priority over the step's formly form.
     * If a forceValidationValue is given, then the step's validation value will be set
     * to the value provided
     * @param currentStep - step to update validation for
     * @param forceValidationValue - true or false -
     *  if true, step's validity will be force set to true
     *  if false, step's validity will be force set to false
     * @returns
     */
    async updateValidation(currentStep, forceValidationValue) {
        if (!currentStep) {
            return;
        }
        if (forceValidationValue === true || forceValidationValue === false) {
            currentStep.valid = forceValidationValue;
            this.stepValidityMap[currentStep.id] = forceValidationValue;
            return;
        }
        // Custom validation function was provided, use provided custom validation
        if (currentStep.stepValidationFn) {
            const isValid = currentStep.stepValidationFn(currentStep.model ? currentStep.model : this.model);
            if (typeof isValid === 'boolean') {
                currentStep.valid = isValid;
                this.stepValidityMap[currentStep.id] = isValid;
            }
            else if (typeof isValid === 'object') {
                const res = await isValid.toPromise();
                currentStep.valid = res;
                this.stepValidityMap[currentStep.id] = res;
            }
            return;
        }
        const currentStepFieldConfig = currentStep.fieldConfig;
        if (!currentStepFieldConfig ||
            this.isFormEmpty(currentStepFieldConfig.formControl, currentStepFieldConfig.defaultValue)) {
            return;
        }
        const isValid = currentStep.fieldConfig.formControl.valid;
        currentStep.valid = isValid;
        this.stepValidityMap[currentStep.id] = isValid;
    }
    isFormEmpty(form, defaultValue) {
        if (!form) {
            return true;
        }
        if (form.value === false) {
            return false;
        }
        if (!form.value || form.value.length === 0) {
            return true;
        }
        if (typeof form.value != 'object') {
            return false;
        }
        const cleanModel = this.getCleanObject(form.value);
        return Object.keys(cleanModel).length === 0 || _.isEqual(cleanModel, defaultValue);
    }
    getCleanObject(input, output) {
        output = output || {};
        for (var key in input) {
            var value = input[key];
            if (value) {
                if (typeof value === 'object' && value !== null) {
                    this.getCleanObject(value, output);
                }
                else {
                    // Treat true string as boolean value & ignore value of string 'false'
                    if (value === 'true') {
                        output[key] = true;
                    }
                    else if (value != 'false') {
                        output[key] = value;
                    }
                }
            }
        }
        return output;
    }
    /** @nocollapse */ static { this.ɵfac = function SdsStepper_Factory(t) { return new (t || SdsStepper)(i0.ɵɵdirectiveInject(i3$2.Router), i0.ɵɵdirectiveInject(i3$2.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsStepper, selectors: [["", "sdsStepper", ""]], contentQueries: function SdsStepper_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SdsStepComponent, 4);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stepTemplates = _t);
        } }, hostBindings: function SdsStepper_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("stepModelChange", function SdsStepper_stepModelChange_HostBindingHandler($event) { return ctx.onModelChange($event); });
        } }, inputs: { model: "model", currentStepId: "currentStepId", stepValidityMap: "stepValidityMap", customErrorHandling: "customErrorHandling", linear: "linear", id: "id", queryParamKey: "queryParamKey", isRouteEnabled: "isRouteEnabled", validateStepsOnInit: "validateStepsOnInit", canReviewWithErrors: "canReviewWithErrors" }, outputs: { saveData: "saveData", stepChange: "stepChange", modelChange: "modelChange" }, exportAs: ["sdsStepper"], features: [i0.ɵɵNgOnChangesFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepper, [{
        type: Directive,
        args: [{
                selector: `[sdsStepper]`,
                exportAs: 'sdsStepper',
            }]
    }], () => [{ type: i3$2.Router }, { type: i3$2.ActivatedRoute }, { type: i0.ChangeDetectorRef }], { stepTemplates: [{
            type: ContentChildren,
            args: [SdsStepComponent]
        }], model: [{
            type: Input
        }], currentStepId: [{
            type: Input
        }], stepValidityMap: [{
            type: Input
        }], customErrorHandling: [{
            type: Input
        }], linear: [{
            type: Input
        }], id: [{
            type: Input
        }], queryParamKey: [{
            type: Input
        }], isRouteEnabled: [{
            type: Input
        }], validateStepsOnInit: [{
            type: Input
        }], canReviewWithErrors: [{
            type: Input
        }], saveData: [{
            type: Output
        }], stepChange: [{
            type: Output
        }], modelChange: [{
            type: Output
        }], onModelChange: [{
            type: HostListener,
            args: ['stepModelChange', ['$event']]
        }] }); })();

/** Button that moves to the next step in a stepper workflow. */
class SdsStepperNextDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
    // In Ivy the `host` bindings will be merged when this class is extended, whereas in
    // ViewEngine they're overwritten.
    // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
    // tslint:disable-next-line:no-host-decorator-in-concrete
    _handleClick() {
        this._stepper.onNextStep();
    }
    _disabled() {
        const flatSteps = this._stepper.flatSteps;
        const nextIndex = this._stepper.selectedStepIndex + 1;
        // Handle edge case - no steps or no selected step
        if (!flatSteps || this._stepper.selectedStepIndex == undefined) {
            return true;
        }
        /** Handle case where current step is last step */
        if (this._stepper.selectedStepIndex >= flatSteps.length - 1) {
            return true;
        }
        /**
         * For linear mode, enable the next step, on click, current step will be validated,
         * and if valid, user will automatically progress to next step
         */
        if (this._stepper.linear) {
            return;
        }
        /** Otherwise, if next step is disabled or next step is review step and review step is disabled, disable next step */
        if (flatSteps[nextIndex].disabled ||
            (flatSteps[nextIndex].isReview && !this._stepper.canReviewWithErrors && this._stepper._isReviewAndSubmitDisabled)) {
            return true;
        }
        return;
    }
    /** @nocollapse */ static { this.ɵfac = function SdsStepperNextDirective_Factory(t) { return new (t || SdsStepperNextDirective)(i0.ɵɵdirectiveInject(SdsStepper)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsStepperNextDirective, selectors: [["", "sdsStepperNext", ""]], hostVars: 1, hostBindings: function SdsStepperNextDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function SdsStepperNextDirective_click_HostBindingHandler() { return ctx._handleClick(); });
        } if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx._disabled());
        } } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepperNextDirective, [{
        type: Directive,
        args: [{
                selector: `[sdsStepperNext]`,
                host: {
                    '[attr.disabled]': '_disabled()',
                },
            }]
    }], () => [{ type: SdsStepper }], { _handleClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();
/** Button that moves to the next step in a stepper workflow. */
class SdsStepperPreviousDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
    // In Ivy the `host` bindings will be merged when this class is extended, whereas in
    // ViewEngine they're overwritten.
    // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
    // tslint:disable-next-line:no-host-decorator-in-concrete
    _handleClick() {
        this._stepper.onPreviousStep();
    }
    _disabled() {
        const flatSteps = this._stepper.flatSteps;
        const previousStep = this._stepper.selectedStepIndex - 1;
        if (!flatSteps || !this._stepper.selectedStepIndex) {
            return true;
        }
        if (this._stepper.selectedStepIndex === 0) {
            return true;
        }
        if (flatSteps[previousStep].disabled ||
            (flatSteps[previousStep].isReview && this._stepper._isReviewAndSubmitDisabled)) {
            return true;
        }
        return;
    }
    /** @nocollapse */ static { this.ɵfac = function SdsStepperPreviousDirective_Factory(t) { return new (t || SdsStepperPreviousDirective)(i0.ɵɵdirectiveInject(SdsStepper)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsStepperPreviousDirective, selectors: [["", "sdsStepperPrevious", ""]], hostVars: 1, hostBindings: function SdsStepperPreviousDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function SdsStepperPreviousDirective_click_HostBindingHandler() { return ctx._handleClick(); });
        } if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx._stepper.selectedStepIndex === 0 ? true : undefined);
        } } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepperPreviousDirective, [{
        type: Directive,
        args: [{
                selector: `[sdsStepperPrevious]`,
                host: {
                    '[attr.disabled]': '_stepper.selectedStepIndex === 0 ? true : undefined',
                },
            }]
    }], () => [{ type: SdsStepper }], { _handleClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();
/** Button that moves to the next step in a stepper workflow. */
class SdsStepperSaveDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
    // In Ivy the `host` bindings will be merged when this class is extended, whereas in
    // ViewEngine they're overwritten.
    // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
    // tslint:disable-next-line:no-host-decorator-in-concrete
    _handleClick() {
        this._stepper.onSaveClicked();
    }
    /** @nocollapse */ static { this.ɵfac = function SdsStepperSaveDirective_Factory(t) { return new (t || SdsStepperSaveDirective)(i0.ɵɵdirectiveInject(SdsStepper)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsStepperSaveDirective, selectors: [["", "sdsStepperSave", ""]], hostBindings: function SdsStepperSaveDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function SdsStepperSaveDirective_click_HostBindingHandler() { return ctx._handleClick(); });
        } } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepperSaveDirective, [{
        type: Directive,
        args: [{
                selector: `[sdsStepperSave]`,
            }]
    }], () => [{ type: SdsStepper }], { _handleClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();
/** Button that moves to the next step in a stepper workflow. */
class SdsStepperNavDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    // We have to use a `HostListener` here in order to support both Ivy and ViewEngine.
    // In Ivy the `host` bindings will be merged when this class is extended, whereas in
    // ViewEngine they're overwritten.
    // TODO(crisbeto): we move this back into `host` once Ivy is turned on by default.
    // tslint:disable-next-line:no-host-decorator-in-concrete
    _handleClick() {
        this._stepper.changeStep(this.sdsStepperNav.id);
    }
    /** @nocollapse */ static { this.ɵfac = function SdsStepperNavDirective_Factory(t) { return new (t || SdsStepperNavDirective)(i0.ɵɵdirectiveInject(SdsStepper)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsStepperNavDirective, selectors: [["", "sdsStepperNav", ""]], hostVars: 1, hostBindings: function SdsStepperNavDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function SdsStepperNavDirective_click_HostBindingHandler() { return ctx._handleClick(); });
        } if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx.sdsStepperNav.disabled);
        } }, inputs: { sdsStepperNav: "sdsStepperNav" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepperNavDirective, [{
        type: Directive,
        args: [{
                selector: `[sdsStepperNav]`,
                host: {
                    '[attr.disabled]': 'sdsStepperNav.disabled',
                },
            }]
    }], () => [{ type: SdsStepper }], { sdsStepperNav: [{
            type: Input
        }], _handleClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();
/**
 * Directive designed for when using ngx-uswds' step indicator component
 * with sds stepper. This directive manages internal sync of usa-step-indicator
 * and sds stepper steps such that when a step changes in one component, it is
 * accurately reflected on the other
 *
 * usage example:
 * Inside the template of a component that extends SdsStepper -
 *  <usa-step-indicator sdsStepperUSWDSNav> </usa-step-indicator>
 */
class SdsStepperUSWDSNavDirective {
    constructor(_stepper, _el) {
        this._stepper = _stepper;
        this._el = _el;
        this.stepChangeSubscriptions = new Subscription();
    }
    ngOnInit() {
        const usaStepChange = this._el.currentStepChange.subscribe((stepIndex) => {
            const step = this._el.steps[stepIndex];
            const nextStep = this._stepper.flatSteps.find((flatStep) => flatStep.text === step.label);
            this._stepper.changeStep(nextStep.id);
        });
        this.stepChangeSubscriptions.add(usaStepChange);
    }
    ngOnDestroy() {
        this.stepChangeSubscriptions.unsubscribe();
    }
    /** @nocollapse */ static { this.ɵfac = function SdsStepperUSWDSNavDirective_Factory(t) { return new (t || SdsStepperUSWDSNavDirective)(i0.ɵɵdirectiveInject(forwardRef(() => SdsStepper)), i0.ɵɵdirectiveInject(i2.UsaStepIndicatorComponent)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsStepperUSWDSNavDirective, selectors: [["usa-step-indicator", "sdsStepperUSWDSNav", ""]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepperUSWDSNavDirective, [{
        type: Directive,
        args: [{
                selector: `usa-step-indicator [sdsStepperUSWDSNav]`,
            }]
    }], () => [{ type: SdsStepper, decorators: [{
                type: Inject,
                args: [forwardRef(() => SdsStepper)]
            }] }, { type: i2.UsaStepIndicatorComponent }], null); })();

class SdsStepperModule {
    /** @nocollapse */ static { this.ɵfac = function SdsStepperModule_Factory(t) { return new (t || SdsStepperModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsStepperModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FormlyModule,
            SdsFormlyModule,
            IconModule,
            NgxBootstrapIconsModule.pick({ chevronLeft, chevronRight, x, check, question, save }),
            RouterModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsStepperModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    FormlyModule,
                    SdsFormlyModule,
                    IconModule,
                    NgxBootstrapIconsModule.pick({ chevronLeft, chevronRight, x, check, question, save }),
                    RouterModule,
                ],
                declarations: [
                    SdsStepComponent,
                    SdsStepHeaderComponent,
                    SdsStepFooterComponent,
                    SdsStepper,
                    SdsStepperNavDirective,
                    SdsStepperNextDirective,
                    SdsStepperPreviousDirective,
                    SdsStepperSaveDirective,
                    SdsStepperUSWDSNavDirective,
                ],
                exports: [
                    SdsStepComponent,
                    SdsStepHeaderComponent,
                    SdsStepFooterComponent,
                    SdsStepper,
                    SdsStepperNavDirective,
                    SdsStepperNextDirective,
                    SdsStepperPreviousDirective,
                    SdsStepperSaveDirective,
                    SdsStepperUSWDSNavDirective,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsStepperModule, { declarations: [SdsStepComponent,
        SdsStepHeaderComponent,
        SdsStepFooterComponent,
        SdsStepper,
        SdsStepperNavDirective,
        SdsStepperNextDirective,
        SdsStepperPreviousDirective,
        SdsStepperSaveDirective,
        SdsStepperUSWDSNavDirective], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
        SdsFormlyModule,
        IconModule, i1$1.NgxBootstrapIconsModule, RouterModule], exports: [SdsStepComponent,
        SdsStepHeaderComponent,
        SdsStepFooterComponent,
        SdsStepper,
        SdsStepperNavDirective,
        SdsStepperNextDirective,
        SdsStepperPreviousDirective,
        SdsStepperSaveDirective,
        SdsStepperUSWDSNavDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractSdsFormly, AdvancedFiltersComponent, DATE_FORMAT, FIELD_TYPE_COMPONENTS, FORMLY_CONFIG, FORMLY_WRAPPERS, FormlyUtilsService, ReadonlyAutocompleteComponent, ReadonlyCheckboxComponent, ReadonlyContainerComponent, ReadonlyDatepickerComponent, ReadonlyDaterangeComponent, ReadonlyFileinfoComponent, ReadonlyInputComponent, ReadonlyLabelDirective, ReadonlyMulticheckboxComponent, ReadonlyRadioComponent, ReadonlySelectComponent, ReadonlyValueDirective, SDSFormlyUpdateComunicationService, SDSFormlyUpdateModelService, SdsAdvancedFiltersService, SdsFiltersComponent, SdsFiltersModule, SdsFormlyDialogComponent, SdsFormlyDialogModule, SdsFormlyModule, SdsFormlyResetComponent, SdsFormlyResetModule, SdsFormlyTypes, SdsReadonlyModule, SdsReadonlyTypes, SdsStepComponent, SdsStepFooterComponent, SdsStepHeaderComponent, SdsStepper, SdsStepperModule, SdsStepperNavDirective, SdsStepperNextDirective, SdsStepperPreviousDirective, SdsStepperSaveDirective, SdsStepperUSWDSNavDirective, animationExtension, autocompleteRequired, betweenDateValidationMessage, dateRangeValidator, getParentHideOptional, invalidDateFormatValidationMessage, matDateInBetweenValidationMessage, matDatepickerMaxValidationMessage, matDatepickerMinValidationMessage, maxDateFromDateRangePicker, maxDateToDateRangePicker, maxDateValidationMessage, maxDateValidator, maxLengthValidationMessage, maxValidationMessage, minDateFromDateRangePicker, minDateToDateRangePicker, minDateValidationMessage, minDateValidator, minLengthValidationMessage, minValidationMessage, multiCheckboxRequired, requireOrInvalidDateFormat, sdsFieldWrapper, sdsGroupWrapper, sdsWrappers };
